/* eslint-disable no-use-before-define */
import { apiBase as api } from './api-base'

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    postByTenantAccountSave: build.mutation<
      PostByTenantAccountSaveApiResponse,
      PostByTenantAccountSaveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/save`,
        method: 'POST',
        body: queryArg.apiUnapprovedAccount
      })
    }),
    postByTenantAccountUpdateSave: build.mutation<
      PostByTenantAccountUpdateSaveApiResponse,
      PostByTenantAccountUpdateSaveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/update/save`,
        method: 'POST',
        body: queryArg.apiUnapprovedAccountUpdate
      })
    }),
    postByTenantAccountSubmitAndAccountIdentifier: build.mutation<
      PostByTenantAccountSubmitAndAccountIdentifierApiResponse,
      PostByTenantAccountSubmitAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/submit/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    postByTenantAccountApproveEconomicsAndAccountIdentifier: build.mutation<
      PostByTenantAccountApproveEconomicsAndAccountIdentifierApiResponse,
      PostByTenantAccountApproveEconomicsAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/approve/economics/${queryArg.accountIdentifier}`,
        method: 'POST',
        body: queryArg.apiTradeEconomics
      })
    }),
    postByTenantAccountApproveAndAccountIdentifier: build.mutation<
      PostByTenantAccountApproveAndAccountIdentifierApiResponse,
      PostByTenantAccountApproveAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/approve/${queryArg.accountIdentifier}`,
        method: 'POST',
        body: queryArg.apiTradeApproval
      })
    }),
    postByTenantAccountRejectAndAccountIdentifier: build.mutation<
      PostByTenantAccountRejectAndAccountIdentifierApiResponse,
      PostByTenantAccountRejectAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/reject/${queryArg.accountIdentifier}`,
        method: 'POST',
        body: queryArg.apiTradeRejection
      })
    }),
    postByTenantAccountCommitAndAccountIdentifier: build.mutation<
      PostByTenantAccountCommitAndAccountIdentifierApiResponse,
      PostByTenantAccountCommitAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/commit/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    postByTenantAccountCommitClientAndAccountIdentifier: build.mutation<
      PostByTenantAccountCommitClientAndAccountIdentifierApiResponse,
      PostByTenantAccountCommitClientAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/commit/client/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    postByTenantAccountConfirmAndAccountIdentifier: build.mutation<
      PostByTenantAccountConfirmAndAccountIdentifierApiResponse,
      PostByTenantAccountConfirmAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/confirm/${queryArg.accountIdentifier}`,
        method: 'POST',
        body: queryArg.apiConfirmSettlementRequest
      })
    }),
    postByTenantAccountActivateAndAccountIdentifier: build.mutation<
      PostByTenantAccountActivateAndAccountIdentifierApiResponse,
      PostByTenantAccountActivateAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/activate/${queryArg.accountIdentifier}`,
        method: 'POST',
        body: queryArg.apiTradeActivation
      })
    }),
    postByTenantAccountCloseAndAccountIdentifier: build.mutation<
      PostByTenantAccountCloseAndAccountIdentifierApiResponse,
      PostByTenantAccountCloseAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/close/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    postByTenantAccountDeleteAndAccountIdentifier: build.mutation<
      PostByTenantAccountDeleteAndAccountIdentifierApiResponse,
      PostByTenantAccountDeleteAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/delete/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    postByTenantAccountDeleterevertdraftAndAccountIdentifier: build.mutation<
      PostByTenantAccountDeleterevertdraftAndAccountIdentifierApiResponse,
      PostByTenantAccountDeleterevertdraftAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/deleterevertdraft/${queryArg.accountIdentifier}`,
        method: 'POST'
      })
    }),
    getByTenantAccountAndAccountSourceAccountIdentifier: build.query<
      GetByTenantAccountAndAccountSourceAccountIdentifierApiResponse,
      GetByTenantAccountAndAccountSourceAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/${queryArg.accountSource}/${queryArg.accountIdentifier}`
      })
    }),
    getByTenantAccountSummaryAndAccountSourceAccountIdentifier: build.query<
      GetByTenantAccountSummaryAndAccountSourceAccountIdentifierApiResponse,
      GetByTenantAccountSummaryAndAccountSourceAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/summary/${queryArg.accountSource}/${queryArg.accountIdentifier}`
      })
    }),
    getByTenantAccount: build.query<GetByTenantAccountApiResponse, GetByTenantAccountApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account`,
        params: {
          NoteIds: queryArg.noteIds,
          CurrencyCode: queryArg.currencyCode,
          ClientType: queryArg.clientType,
          AccountRunningStatus: queryArg.accountRunningStatus,
          PortfolioType: queryArg.portfolioType,
          StrategyType: queryArg.strategyType,
          IsNoteCollateralized: queryArg.isNoteCollateralized
        }
      })
    }),
    getByTenantAccountDashboard: build.query<
      GetByTenantAccountDashboardApiResponse,
      GetByTenantAccountDashboardApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/dashboard`,
        params: {
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending,
          CurrencyCode: queryArg.currencyCode,
          ClientType: queryArg.clientType,
          NoteIds: queryArg.noteIds,
          IsNoteCollateralized: queryArg.isNoteCollateralized
        }
      })
    }),
    getByTenantAccountRunning: build.query<
      GetByTenantAccountRunningApiResponse,
      GetByTenantAccountRunningApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/running`,
        params: {
          Clients: queryArg.clients,
          ClientsList: queryArg.clientsList,
          BusinessUnits: queryArg.businessUnits,
          BusinessUnitsList: queryArg.businessUnitsList,
          Notes: queryArg.notes,
          NotesList: queryArg.notesList,
          Currencies: queryArg.currencies,
          CurrenciesList: queryArg.currenciesList,
          Portfolios: queryArg.portfolios,
          PortfoliosList: queryArg.portfoliosList,
          Strategies: queryArg.strategies,
          StrategiesList: queryArg.strategiesList,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber,
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending
        }
      })
    }),
    postByTenantAccountExport: build.mutation<
      PostByTenantAccountExportApiResponse,
      PostByTenantAccountExportApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/export`,
        method: 'POST',
        body: queryArg.getAccountsFilters
      })
    }),
    postByTenantAccountAccrualsExport: build.mutation<
      PostByTenantAccountAccrualsExportApiResponse,
      PostByTenantAccountAccrualsExportApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/accruals/export`,
        method: 'POST',
        body: queryArg.apiGetAccountAccrualsFilter
      })
    }),
    postByTenantAccountExportJson: build.mutation<
      PostByTenantAccountExportJsonApiResponse,
      PostByTenantAccountExportJsonApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/export/json`,
        method: 'POST',
        body: queryArg.getAccountsFilters
      })
    }),
    getByTenantAccountInprogress: build.query<
      GetByTenantAccountInprogressApiResponse,
      GetByTenantAccountInprogressApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/inprogress`,
        params: {
          WildcardString: queryArg.wildcardString,
          Status: queryArg.status,
          FilterNewAccounts: queryArg.filterNewAccounts,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber,
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending
        }
      })
    }),
    getByTenantAccountInprogressAndAccountIdentifier: build.query<
      GetByTenantAccountInprogressAndAccountIdentifierApiResponse,
      GetByTenantAccountInprogressAndAccountIdentifierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/inprogress/${queryArg.accountIdentifier}`
      })
    }),
    getByTenantAccountFirstaccountdate: build.query<
      GetByTenantAccountFirstaccountdateApiResponse,
      GetByTenantAccountFirstaccountdateApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/firstaccountdate` })
    }),
    getByTenantAccountAllaccountdetails: build.query<
      GetByTenantAccountAllaccountdetailsApiResponse,
      GetByTenantAccountAllaccountdetailsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/allaccountdetails` })
    }),
    getByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDate: build.query<
      GetByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDateApiResponse,
      GetByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/snapshots/range/${queryArg.accountSource}/${queryArg.accountId}/${queryArg.startDate}/${queryArg.endDate}`
      })
    }),
    getByTenantAccountSnapshotsAndDate: build.query<
      GetByTenantAccountSnapshotsAndDateApiResponse,
      GetByTenantAccountSnapshotsAndDateApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/snapshots/${queryArg.date}` })
    }),
    getByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatest: build.query<
      GetByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatestApiResponse,
      GetByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatestApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/snapshots/${queryArg.accountSource}/${queryArg.accountIdentifier}/latest`
      })
    }),
    getByTenantAccountStatic: build.query<
      GetByTenantAccountStaticApiResponse,
      GetByTenantAccountStaticApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/static` })
    }),
    getByTenantAccountStaticAndAccountName: build.query<
      GetByTenantAccountStaticAndAccountNameApiResponse,
      GetByTenantAccountStaticAndAccountNameApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/static/${queryArg.accountName}` })
    }),
    postByTenantAccountPricesAndAccountId: build.mutation<
      PostByTenantAccountPricesAndAccountIdApiResponse,
      PostByTenantAccountPricesAndAccountIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/prices/${queryArg.accountId}`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    postByTenantAccountLocksAndAccountIdLockTypeRemove: build.mutation<
      PostByTenantAccountLocksAndAccountIdLockTypeRemoveApiResponse,
      PostByTenantAccountLocksAndAccountIdLockTypeRemoveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/account/locks/${queryArg.accountId}/${queryArg.lockType}/remove`,
        method: 'POST'
      })
    }),
    getByTenantAccountExportPendingfees: build.query<
      GetByTenantAccountExportPendingfeesApiResponse,
      GetByTenantAccountExportPendingfeesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/account/export/pendingfees` })
    }),
    getByTenantVAndDateAccountAccountId: build.query<
      GetByTenantVAndDateAccountAccountIdApiResponse,
      GetByTenantVAndDateAccountAccountIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/v/${queryArg.date}/account/${queryArg.accountId}`
      })
    }),
    getByTenantVAndAccountIdHistory: build.query<
      GetByTenantVAndAccountIdHistoryApiResponse,
      GetByTenantVAndAccountIdHistoryApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/v/${queryArg.accountId}/history` })
    }),
    getByTenantVDates: build.query<GetByTenantVDatesApiResponse, GetByTenantVDatesApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/v/dates` })
    }),
    getByTenantAsset: build.query<GetByTenantAssetApiResponse, GetByTenantAssetApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset` })
    }),
    getByTenantAssetList: build.query<GetByTenantAssetListApiResponse, GetByTenantAssetListApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/list`,
        params: {
          WildcardString: queryArg.wildcardString,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber,
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending
        }
      })
    }),
    getByTenantAssetAndAssetIdDetails: build.query<
      GetByTenantAssetAndAssetIdDetailsApiResponse,
      GetByTenantAssetAndAssetIdDetailsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/${queryArg.assetId}/details` })
    }),
    getByTenantAssetAndAssetIdHistory: build.query<
      GetByTenantAssetAndAssetIdHistoryApiResponse,
      GetByTenantAssetAndAssetIdHistoryApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/${queryArg.assetId}/history` })
    }),
    getByTenantAssetMutualfunds: build.query<
      GetByTenantAssetMutualfundsApiResponse,
      GetByTenantAssetMutualfundsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/mutualfunds` })
    }),
    getByTenantAssetSegregatedportfolios: build.query<
      GetByTenantAssetSegregatedportfoliosApiResponse,
      GetByTenantAssetSegregatedportfoliosApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/segregatedportfolios` })
    }),
    getByTenantAssetAndAssetId: build.query<
      GetByTenantAssetAndAssetIdApiResponse,
      GetByTenantAssetAndAssetIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/${queryArg.assetId}` })
    }),
    postByTenantAssetMutualfund: build.mutation<
      PostByTenantAssetMutualfundApiResponse,
      PostByTenantAssetMutualfundApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/mutualfund`,
        method: 'POST',
        body: queryArg.apiMutualFundAsset
      })
    }),
    putByTenantAssetMutualfund: build.mutation<
      PutByTenantAssetMutualfundApiResponse,
      PutByTenantAssetMutualfundApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/mutualfund`,
        method: 'PUT',
        body: queryArg.apiMutualFundAsset
      })
    }),
    putByTenantAssetFundManager: build.mutation<
      PutByTenantAssetFundManagerApiResponse,
      PutByTenantAssetFundManagerApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/fund-manager`,
        method: 'PUT',
        body: queryArg.apiRenameFundManagerRequest
      })
    }),
    putByTenantAssetAndAssetIdTradingProviderNewTradingProvider: build.mutation<
      PutByTenantAssetAndAssetIdTradingProviderNewTradingProviderApiResponse,
      PutByTenantAssetAndAssetIdTradingProviderNewTradingProviderApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/TradingProvider/${queryArg.newTradingProvider}`,
        method: 'PUT'
      })
    }),
    putByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProvider: build.mutation<
      PutByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProviderApiResponse,
      PutByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProviderApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/MarketDataProvider/${queryArg.newMarketDataProvider}`,
        method: 'PUT'
      })
    }),
    postByTenantAssetSegregatedportfolio: build.mutation<
      PostByTenantAssetSegregatedportfolioApiResponse,
      PostByTenantAssetSegregatedportfolioApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/segregatedportfolio`,
        method: 'POST',
        body: queryArg.apiSegregatedPortfolioAsset
      })
    }),
    putByTenantAssetSegregatedportfolio: build.mutation<
      PutByTenantAssetSegregatedportfolioApiResponse,
      PutByTenantAssetSegregatedportfolioApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/segregatedportfolio`,
        method: 'PUT',
        body: queryArg.apiSegregatedPortfolioAsset
      })
    }),
    getByTenantAssetDefaults: build.query<
      GetByTenantAssetDefaultsApiResponse,
      GetByTenantAssetDefaultsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/defaults` })
    }),
    postByTenantAssetUpload: build.mutation<
      PostByTenantAssetUploadApiResponse,
      PostByTenantAssetUploadApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/upload`, method: 'POST' })
    }),
    postByTenantAssetAndAssetIdExdatesAdd: build.mutation<
      PostByTenantAssetAndAssetIdExdatesAddApiResponse,
      PostByTenantAssetAndAssetIdExdatesAddApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/exdates/add`,
        method: 'POST',
        body: queryArg.apiAssetExDates
      })
    }),
    getByTenantAssetIndexes: build.query<
      GetByTenantAssetIndexesApiResponse,
      GetByTenantAssetIndexesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/asset/indexes` })
    }),
    postByTenantAssetIndex: build.mutation<
      PostByTenantAssetIndexApiResponse,
      PostByTenantAssetIndexApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/index`,
        method: 'POST',
        body: queryArg.apiIndex
      })
    }),
    getByTenantAssetListOrderAlert: build.query<
      GetByTenantAssetListOrderAlertApiResponse,
      GetByTenantAssetListOrderAlertApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/list/order/alert`,
        params: {
          WildcardString: queryArg.wildcardString,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber
        }
      })
    }),
    postByTenantAssetAndAssetIdMarketdataready: build.mutation<
      PostByTenantAssetAndAssetIdMarketdatareadyApiResponse,
      PostByTenantAssetAndAssetIdMarketdatareadyApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/marketdataready`,
        method: 'POST'
      })
    }),
    postByTenantAssetAndAssetIdSoftdelete: build.mutation<
      PostByTenantAssetAndAssetIdSoftdeleteApiResponse,
      PostByTenantAssetAndAssetIdSoftdeleteApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/softdelete`,
        method: 'POST'
      })
    }),
    postByTenantAssetAndAssetIdRestore: build.mutation<
      PostByTenantAssetAndAssetIdRestoreApiResponse,
      PostByTenantAssetAndAssetIdRestoreApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/asset/${queryArg.assetId}/restore`,
        method: 'POST'
      })
    }),
    getSystemAuditAfterByDate: build.query<
      GetSystemAuditAfterByDateApiResponse,
      GetSystemAuditAfterByDateApiArg
    >({
      query: queryArg => ({ url: `/system/audit/after/${queryArg.date}` })
    }),
    postAuthLogin: build.mutation<PostAuthLoginApiResponse, PostAuthLoginApiArg>({
      query: queryArg => ({ url: `/auth/login`, method: 'POST', body: queryArg.apiLoginUser })
    }),
    postAuthLogout: build.mutation<PostAuthLogoutApiResponse, PostAuthLogoutApiArg>({
      query: () => ({ url: `/auth/logout`, method: 'POST' })
    }),
    getAuthAuthConfigJs: build.query<GetAuthAuthConfigJsApiResponse, GetAuthAuthConfigJsApiArg>({
      query: () => ({ url: `/auth/auth-config.js` })
    }),
    getByTenantBusinessunitAndBusinessUnitId: build.query<
      GetByTenantBusinessunitAndBusinessUnitIdApiResponse,
      GetByTenantBusinessunitAndBusinessUnitIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/businessunit/${queryArg.businessUnitId}` })
    }),
    postByTenantBusinessunitAndBusinessUnitIdUsers: build.mutation<
      PostByTenantBusinessunitAndBusinessUnitIdUsersApiResponse,
      PostByTenantBusinessunitAndBusinessUnitIdUsersApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/businessunit/${queryArg.businessUnitId}/users`,
        method: 'POST',
        body: queryArg.apiAddBusinessUnitUser
      })
    }),
    getByTenantBusinessunitAndBusinessUnitIdUsers: build.query<
      GetByTenantBusinessunitAndBusinessUnitIdUsersApiResponse,
      GetByTenantBusinessunitAndBusinessUnitIdUsersApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/businessunit/${queryArg.businessUnitId}/users`
      })
    }),
    postByTenantBusinessunitTransfer: build.mutation<
      PostByTenantBusinessunitTransferApiResponse,
      PostByTenantBusinessunitTransferApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/businessunit/transfer`,
        method: 'POST',
        body: queryArg.apiTransferBusinessUnitOwnership
      })
    }),
    getByTenantCashinstrument: build.query<
      GetByTenantCashinstrumentApiResponse,
      GetByTenantCashinstrumentApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/cashinstrument` })
    }),
    getByTenantCashinstrumentList: build.query<
      GetByTenantCashinstrumentListApiResponse,
      GetByTenantCashinstrumentListApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/list`,
        params: {
          WildcardString: queryArg.wildcardString,
          CashInstrumentType: queryArg.cashInstrumentType,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber,
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending
        }
      })
    }),
    postByTenantCashinstrumentLoan: build.mutation<
      PostByTenantCashinstrumentLoanApiResponse,
      PostByTenantCashinstrumentLoanApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/loan`,
        method: 'POST',
        body: queryArg.apiLoan
      })
    }),
    postByTenantCashinstrumentLoanUpdate: build.mutation<
      PostByTenantCashinstrumentLoanUpdateApiResponse,
      PostByTenantCashinstrumentLoanUpdateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/loan/update`,
        method: 'POST',
        body: queryArg.apiLoan
      })
    }),
    postByTenantCashinstrumentDeposit: build.mutation<
      PostByTenantCashinstrumentDepositApiResponse,
      PostByTenantCashinstrumentDepositApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/deposit`,
        method: 'POST',
        body: queryArg.apiDeposit
      })
    }),
    postByTenantCashinstrumentDepositUpdate: build.mutation<
      PostByTenantCashinstrumentDepositUpdateApiResponse,
      PostByTenantCashinstrumentDepositUpdateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/deposit/update`,
        method: 'POST',
        body: queryArg.apiDeposit
      })
    }),
    postByTenantCashinstrumentZcbcurve: build.mutation<
      PostByTenantCashinstrumentZcbcurveApiResponse,
      PostByTenantCashinstrumentZcbcurveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/zcbcurve`,
        method: 'POST',
        body: queryArg.apiZcbCurve
      })
    }),
    postByTenantCashinstrumentZcbcurveUpdate: build.mutation<
      PostByTenantCashinstrumentZcbcurveUpdateApiResponse,
      PostByTenantCashinstrumentZcbcurveUpdateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/cashinstrument/zcbcurve/update`,
        method: 'POST',
        body: queryArg.apiZcbCurve
      })
    }),
    postByTenantClient: build.mutation<PostByTenantClientApiResponse, PostByTenantClientApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client`,
        method: 'POST',
        body: queryArg.apiNewClient
      })
    }),
    getByTenantClient: build.query<GetByTenantClientApiResponse, GetByTenantClientApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/client` })
    }),
    putByTenantClient: build.mutation<PutByTenantClientApiResponse, PutByTenantClientApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client`,
        method: 'PUT',
        body: queryArg.apiClient
      })
    }),
    getByTenantClientUsers: build.query<
      GetByTenantClientUsersApiResponse,
      GetByTenantClientUsersApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/client/users` })
    }),
    getByTenantClientAndClientId: build.query<
      GetByTenantClientAndClientIdApiResponse,
      GetByTenantClientAndClientIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/client/${queryArg.clientId}` })
    }),
    getByTenantClientAndClientIdUsers: build.query<
      GetByTenantClientAndClientIdUsersApiResponse,
      GetByTenantClientAndClientIdUsersApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/client/${queryArg.clientId}/users` })
    }),
    postByTenantClientAndClientIdUsers: build.mutation<
      PostByTenantClientAndClientIdUsersApiResponse,
      PostByTenantClientAndClientIdUsersApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client/${queryArg.clientId}/users`,
        method: 'POST',
        body: queryArg.apiAddClientUser
      })
    }),
    postByTenantClientAndClientIdBusinessUnits: build.mutation<
      PostByTenantClientAndClientIdBusinessUnitsApiResponse,
      PostByTenantClientAndClientIdBusinessUnitsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client/${queryArg.clientId}/businessUnits`,
        method: 'POST',
        body: queryArg.apiAddBusinessUnitToClient
      })
    }),
    putByTenantClientAndClientIdBusinessUnits: build.mutation<
      PutByTenantClientAndClientIdBusinessUnitsApiResponse,
      PutByTenantClientAndClientIdBusinessUnitsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client/${queryArg.clientId}/businessUnits`,
        method: 'PUT',
        body: queryArg.apiBusinessUnit
      })
    }),
    deleteByTenantClientAndClientIdBusinessUnitsBusinessUnitId: build.mutation<
      DeleteByTenantClientAndClientIdBusinessUnitsBusinessUnitIdApiResponse,
      DeleteByTenantClientAndClientIdBusinessUnitsBusinessUnitIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/client/${queryArg.clientId}/businessUnits/${queryArg.businessUnitId}`,
        method: 'DELETE'
      })
    }),
    getByTenantCounterpartyCounterpartyids: build.query<
      GetByTenantCounterpartyCounterpartyidsApiResponse,
      GetByTenantCounterpartyCounterpartyidsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/counterparty/counterpartyids` })
    }),
    getByTenantCounterpartyAll: build.query<
      GetByTenantCounterpartyAllApiResponse,
      GetByTenantCounterpartyAllApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/counterparty/all` })
    }),
    postByTenantCounterpartyAdd: build.mutation<
      PostByTenantCounterpartyAddApiResponse,
      PostByTenantCounterpartyAddApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/counterparty/add`,
        method: 'POST',
        body: queryArg.apiCounterparty
      })
    }),
    putByTenantCounterpartyUpdate: build.mutation<
      PutByTenantCounterpartyUpdateApiResponse,
      PutByTenantCounterpartyUpdateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/counterparty/update`,
        method: 'PUT',
        body: queryArg.apiCounterparty
      })
    }),
    postByTenantUploadModelparameters: build.mutation<
      PostByTenantUploadModelparametersApiResponse,
      PostByTenantUploadModelparametersApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/upload/modelparameters`,
        method: 'POST',
        body: queryArg.apiModelParametersMessage
      })
    }),
    postByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDate: build.mutation<
      PostByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDateApiResponse,
      PostByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/upload/exchangefile/${queryArg.contentType}/${queryArg.fileType}/${queryArg.fileName}/${queryArg.referenceDate}`,
        method: 'POST'
      })
    }),
    postByTenantDfm: build.mutation<PostByTenantDfmApiResponse, PostByTenantDfmApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/dfm`,
        method: 'POST',
        body: queryArg.apiNewDfm
      })
    }),
    putByTenantDfm: build.mutation<PutByTenantDfmApiResponse, PutByTenantDfmApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/dfm`, method: 'PUT', body: queryArg.apiDfm })
    }),
    postByTenantDfmAndDfmIdUsers: build.mutation<
      PostByTenantDfmAndDfmIdUsersApiResponse,
      PostByTenantDfmAndDfmIdUsersApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/dfm/${queryArg.dfmId}/users`,
        method: 'POST',
        body: queryArg.apiAddDfmUser
      })
    }),
    getByTenantDfmAndDfmIdUsers: build.query<
      GetByTenantDfmAndDfmIdUsersApiResponse,
      GetByTenantDfmAndDfmIdUsersApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/dfm/${queryArg.dfmId}/users` })
    }),
    getDiagnosticsTaxclassifier: build.query<
      GetDiagnosticsTaxclassifierApiResponse,
      GetDiagnosticsTaxclassifierApiArg
    >({
      query: () => ({ url: `/diagnostics/taxclassifier` })
    }),
    getDiagnosticsByTenantTaxclassifier: build.query<
      GetDiagnosticsByTenantTaxclassifierApiResponse,
      GetDiagnosticsByTenantTaxclassifierApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/${queryArg.tenant}/taxclassifier` })
    }),
    getDiagnosticsError: build.query<GetDiagnosticsErrorApiResponse, GetDiagnosticsErrorApiArg>({
      query: () => ({ url: `/diagnostics/error` })
    }),
    postDiagnosticsError: build.mutation<
      PostDiagnosticsErrorApiResponse,
      PostDiagnosticsErrorApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/error`, method: 'POST', body: queryArg.body })
    }),
    getDiagnosticsMediatr: build.query<
      GetDiagnosticsMediatrApiResponse,
      GetDiagnosticsMediatrApiArg
    >({
      query: () => ({ url: `/diagnostics/mediatr` })
    }),
    getDiagnosticsMediatrSend: build.query<
      GetDiagnosticsMediatrSendApiResponse,
      GetDiagnosticsMediatrSendApiArg
    >({
      query: () => ({ url: `/diagnostics/mediatr/send` })
    }),
    getDiagnosticsRoles: build.query<GetDiagnosticsRolesApiResponse, GetDiagnosticsRolesApiArg>({
      query: () => ({ url: `/diagnostics/roles` })
    }),
    getDiagnostics: build.query<GetDiagnosticsApiResponse, GetDiagnosticsApiArg>({
      query: () => ({ url: `/diagnostics` })
    }),
    getDiagnosticsService: build.query<
      GetDiagnosticsServiceApiResponse,
      GetDiagnosticsServiceApiArg
    >({
      query: () => ({ url: `/diagnostics/service` })
    }),
    getDiagnosticsTenantByTenant: build.query<
      GetDiagnosticsTenantByTenantApiResponse,
      GetDiagnosticsTenantByTenantApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/tenant/${queryArg.tenant}` })
    }),
    postDiagnosticsLogsByTenantNameClean: build.mutation<
      PostDiagnosticsLogsByTenantNameCleanApiResponse,
      PostDiagnosticsLogsByTenantNameCleanApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/logs/${queryArg.tenantName}/clean`, method: 'POST' })
    }),
    postDiagnosticsLogs: build.mutation<PostDiagnosticsLogsApiResponse, PostDiagnosticsLogsApiArg>({
      query: queryArg => ({
        url: `/diagnostics/logs`,
        method: 'POST',
        body: queryArg.apiLogRequest
      })
    }),
    getDiagnosticsBackupByPartIndexesdescription: build.query<
      GetDiagnosticsBackupByPartIndexesdescriptionApiResponse,
      GetDiagnosticsBackupByPartIndexesdescriptionApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/backup/${queryArg.part}/indexesdescription` })
    }),
    getDiagnosticsBackupByPartIndexes: build.query<
      GetDiagnosticsBackupByPartIndexesApiResponse,
      GetDiagnosticsBackupByPartIndexesApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/backup/${queryArg.part}/indexes` })
    }),
    getDiagnosticsBackupByPart: build.query<
      GetDiagnosticsBackupByPartApiResponse,
      GetDiagnosticsBackupByPartApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/backup/${queryArg.part}` })
    }),
    postDiagnosticsBackupByPart: build.mutation<
      PostDiagnosticsBackupByPartApiResponse,
      PostDiagnosticsBackupByPartApiArg
    >({
      query: queryArg => ({
        url: `/diagnostics/backup/${queryArg.part}`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    getDiagnosticsBackupPartialByPart: build.query<
      GetDiagnosticsBackupPartialByPartApiResponse,
      GetDiagnosticsBackupPartialByPartApiArg
    >({
      query: queryArg => ({
        url: `/diagnostics/backup/partial/${queryArg.part}`,
        body: queryArg.apiBackUpRequest
      })
    }),
    postDiagnosticsRestoreByPart: build.mutation<
      PostDiagnosticsRestoreByPartApiResponse,
      PostDiagnosticsRestoreByPartApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/restore/${queryArg.part}`, method: 'POST' })
    }),
    postDiagnosticsRestorePartialByPart: build.mutation<
      PostDiagnosticsRestorePartialByPartApiResponse,
      PostDiagnosticsRestorePartialByPartApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/restore/partial/${queryArg.part}`, method: 'POST' })
    }),
    postDiagnosticsRestoreByPartIndexes: build.mutation<
      PostDiagnosticsRestoreByPartIndexesApiResponse,
      PostDiagnosticsRestoreByPartIndexesApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/restore/${queryArg.part}/indexes`, method: 'POST' })
    }),
    postDiagnosticsDropByPartIndexes: build.mutation<
      PostDiagnosticsDropByPartIndexesApiResponse,
      PostDiagnosticsDropByPartIndexesApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/drop/${queryArg.part}/indexes`, method: 'POST' })
    }),
    postDiagnosticsDropByPartIndexAndIndex: build.mutation<
      PostDiagnosticsDropByPartIndexAndIndexApiResponse,
      PostDiagnosticsDropByPartIndexAndIndexApiArg
    >({
      query: queryArg => ({
        url: `/diagnostics/drop/${queryArg.part}/index/${queryArg.index}`,
        method: 'POST'
      })
    }),
    postDiagnosticsCreateindex: build.mutation<
      PostDiagnosticsCreateindexApiResponse,
      PostDiagnosticsCreateindexApiArg
    >({
      query: queryArg => ({
        url: `/diagnostics/createindex`,
        method: 'POST',
        body: queryArg.indexDescription
      })
    }),
    getDiagnosticsCheckindexesByTenant: build.query<
      GetDiagnosticsCheckindexesByTenantApiResponse,
      GetDiagnosticsCheckindexesByTenantApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/checkindexes/${queryArg.tenant}` })
    }),
    postDiagnosticsEmail: build.mutation<
      PostDiagnosticsEmailApiResponse,
      PostDiagnosticsEmailApiArg
    >({
      query: queryArg => ({
        url: `/diagnostics/email`,
        method: 'POST',
        body: queryArg.apiEmailRequest
      })
    }),
    getDiagnosticsWaitByNumberSeconds: build.query<
      GetDiagnosticsWaitByNumberSecondsApiResponse,
      GetDiagnosticsWaitByNumberSecondsApiArg
    >({
      query: queryArg => ({ url: `/diagnostics/wait/${queryArg.numberSeconds}` })
    }),
    getDiagnosticsStop: build.query<GetDiagnosticsStopApiResponse, GetDiagnosticsStopApiArg>({
      query: () => ({ url: `/diagnostics/stop` })
    }),
    postByTenantDistributionsAdd: build.mutation<
      PostByTenantDistributionsAddApiResponse,
      PostByTenantDistributionsAddApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/distributions/add`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    getByTenantDistributionsAndAssetId: build.query<
      GetByTenantDistributionsAndAssetIdApiResponse,
      GetByTenantDistributionsAndAssetIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/distributions/${queryArg.assetId}` })
    }),
    postByTenantDistributionsReinvestmentsAdd: build.mutation<
      PostByTenantDistributionsReinvestmentsAddApiResponse,
      PostByTenantDistributionsReinvestmentsAddApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/distributions/reinvestments/add`,
        method: 'POST',
        body: queryArg.apiNewReinvestmentConfirmation
      })
    }),
    getByTenantDistributionsReinvestmentsAndAssetId: build.query<
      GetByTenantDistributionsReinvestmentsAndAssetIdApiResponse,
      GetByTenantDistributionsReinvestmentsAndAssetIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/distributions/reinvestments/${queryArg.assetId}`
      })
    }),
    getByTenantDistributionsReinvestmentsDataAndAssetIdExDate: build.query<
      GetByTenantDistributionsReinvestmentsDataAndAssetIdExDateApiResponse,
      GetByTenantDistributionsReinvestmentsDataAndAssetIdExDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/distributions/reinvestments/data/${queryArg.assetId}/${queryArg.exDate}`
      })
    }),
    putByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDate: build.mutation<
      PutByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDateApiResponse,
      PutByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/distributions/reinvestments/assign/${queryArg.confirmationId}/${queryArg.exDate}`,
        method: 'PUT'
      })
    }),
    getByTenantDistributionsAssetswithalerts: build.query<
      GetByTenantDistributionsAssetswithalertsApiResponse,
      GetByTenantDistributionsAssetswithalertsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/distributions/assetswithalerts` })
    }),
    getByTenantDocumentationAccountAndAccountIdSummary: build.query<
      GetByTenantDocumentationAccountAndAccountIdSummaryApiResponse,
      GetByTenantDocumentationAccountAndAccountIdSummaryApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/documentation/account/${queryArg.accountId}/summary`
      })
    }),
    getByTenantDocumentationNoteAndNoteIdSummary: build.query<
      GetByTenantDocumentationNoteAndNoteIdSummaryApiResponse,
      GetByTenantDocumentationNoteAndNoteIdSummaryApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/documentation/note/${queryArg.noteId}/summary`
      })
    }),
    getByTenantDocumentationAccountAndAccountIdDocumentNumber: build.query<
      GetByTenantDocumentationAccountAndAccountIdDocumentNumberApiResponse,
      GetByTenantDocumentationAccountAndAccountIdDocumentNumberApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/documentation/account/${queryArg.accountId}/${queryArg.documentNumber}`
      })
    }),
    getByTenantDocumentationAndFileName: build.query<
      GetByTenantDocumentationAndFileNameApiResponse,
      GetByTenantDocumentationAndFileNameApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/documentation/${queryArg.fileName}` })
    }),
    postByTenantDocumentationAndFileName: build.mutation<
      PostByTenantDocumentationAndFileNameApiResponse,
      PostByTenantDocumentationAndFileNameApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/documentation/${queryArg.fileName}`,
        method: 'POST'
      })
    }),
    getEmailListByDate: build.query<GetEmailListByDateApiResponse, GetEmailListByDateApiArg>({
      query: queryArg => ({ url: `/email/list/${queryArg.date}` })
    }),
    getEmailById: build.query<GetEmailByIdApiResponse, GetEmailByIdApiArg>({
      query: queryArg => ({ url: `/email/${queryArg.id}` })
    }),
    getExchangefileByTenantAndFilenameType: build.query<
      GetExchangefileByTenantAndFilenameTypeApiResponse,
      GetExchangefileByTenantAndFilenameTypeApiArg
    >({
      query: queryArg => ({
        url: `/exchangefile/${queryArg.tenant}/${queryArg.filename}/${queryArg.type}`
      })
    }),
    postExchangefileByTenantAndFilenameTypeDate: build.mutation<
      PostExchangefileByTenantAndFilenameTypeDateApiResponse,
      PostExchangefileByTenantAndFilenameTypeDateApiArg
    >({
      query: queryArg => ({
        url: `/exchangefile/${queryArg.tenant}/${queryArg.filename}/${queryArg.type}/${queryArg.date}`,
        method: 'POST'
      })
    }),
    getExchangefileLastByTenantAndTypeMaxDateInclusive: build.query<
      GetExchangefileLastByTenantAndTypeMaxDateInclusiveApiResponse,
      GetExchangefileLastByTenantAndTypeMaxDateInclusiveApiArg
    >({
      query: queryArg => ({
        url: `/exchangefile/last/${queryArg.tenant}/${queryArg.type}/${queryArg.maxDateInclusive}`
      })
    }),
    postByTenantOrderCorrection: build.mutation<
      PostByTenantOrderCorrectionApiResponse,
      PostByTenantOrderCorrectionApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/order/correction`,
        method: 'POST',
        body: queryArg.apiNewAggregatedOrderCorrection
      })
    }),
    postByTenantOrderConfirmation: build.mutation<
      PostByTenantOrderConfirmationApiResponse,
      PostByTenantOrderConfirmationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/order/confirmation`,
        method: 'POST',
        body: queryArg.apiNewAggregatedOrderConfirmation
      })
    }),
    getByTenantOrderOutstandingAndAssetId: build.query<
      GetByTenantOrderOutstandingAndAssetIdApiResponse,
      GetByTenantOrderOutstandingAndAssetIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/order/outstanding/${queryArg.assetId}` })
    }),
    getByTenantOrderConfirmed: build.query<
      GetByTenantOrderConfirmedApiResponse,
      GetByTenantOrderConfirmedApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/order/confirmed`,
        params: {
          AssetId: queryArg.assetId,
          CreationStartDateInclusive: queryArg.creationStartDateInclusive,
          CreationEndDateInclusive: queryArg.creationEndDateInclusive,
          IncludeRedemptionOrders: queryArg.includeRedemptionOrders,
          IncludeSubscriptionOrders: queryArg.includeSubscriptionOrders,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber
        }
      })
    }),
    getMediatRSend: build.query<GetMediatRSendApiResponse, GetMediatRSendApiArg>({
      query: queryArg => ({
        url: `/MediatR/send`,
        params: {
          Name: queryArg.name,
          Value: queryArg.value
        }
      })
    }),
    getByTenantNomQueueAndDateDepth: build.query<
      GetByTenantNomQueueAndDateDepthApiResponse,
      GetByTenantNomQueueAndDateDepthApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/nom/queue/${queryArg.date}/depth` })
    }),
    postByTenantNomOne: build.mutation<PostByTenantNomOneApiResponse, PostByTenantNomOneApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/nom/one`, method: 'POST' })
    }),
    postByTenantNomMany: build.mutation<PostByTenantNomManyApiResponse, PostByTenantNomManyApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/nom/many`, method: 'POST' })
    }),
    postByTenantNomInstruction: build.mutation<
      PostByTenantNomInstructionApiResponse,
      PostByTenantNomInstructionApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/nom/instruction`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    postByTenantNoteExport: build.mutation<
      PostByTenantNoteExportApiResponse,
      PostByTenantNoteExportApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/export`,
        method: 'POST',
        body: queryArg.apiGetNoteExportFilters
      })
    }),
    getByTenantNoteHoldingsAndDateExport: build.query<
      GetByTenantNoteHoldingsAndDateExportApiResponse,
      GetByTenantNoteHoldingsAndDateExportApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/note/holdings/${queryArg.date}/export` })
    }),
    getByTenantNoteExportFilter: build.query<
      GetByTenantNoteExportFilterApiResponse,
      GetByTenantNoteExportFilterApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/export/filter`,
        params: {
          CounterpartyIds: queryArg.counterpartyIds,
          StartDateInclusive: queryArg.startDateInclusive,
          EndDateInclusive: queryArg.endDateInclusive,
          MaximumNumberResults: queryArg.maximumNumberResults
        }
      })
    }),
    getByTenantNoteAndNoteIdStatementLatest: build.query<
      GetByTenantNoteAndNoteIdStatementLatestApiResponse,
      GetByTenantNoteAndNoteIdStatementLatestApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/note/${queryArg.noteId}/statement/latest` })
    }),
    getByTenantNoteAndNoteIdStatementDate: build.query<
      GetByTenantNoteAndNoteIdStatementDateApiResponse,
      GetByTenantNoteAndNoteIdStatementDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/statement/${queryArg.date}`
      })
    }),
    getByTenantNoteAndNoteIdStatementYearMonth: build.query<
      GetByTenantNoteAndNoteIdStatementYearMonthApiResponse,
      GetByTenantNoteAndNoteIdStatementYearMonthApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/statement/${queryArg.year}/${queryArg.month}`
      })
    }),
    getByTenantNoteStatements: build.query<
      GetByTenantNoteStatementsApiResponse,
      GetByTenantNoteStatementsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/statements`,
        params: {
          ids: queryArg.ids
        }
      })
    }),
    getByTenantNoteAndNoteIdStatementsPrevious: build.query<
      GetByTenantNoteAndNoteIdStatementsPreviousApiResponse,
      GetByTenantNoteAndNoteIdStatementsPreviousApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/statements/previous`
      })
    }),
    postByTenantNoteDataAccountAndAccountIdNewinstructions: build.mutation<
      PostByTenantNoteDataAccountAndAccountIdNewinstructionsApiResponse,
      PostByTenantNoteDataAccountAndAccountIdNewinstructionsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/data/account/${queryArg.accountId}/newinstructions`,
        method: 'POST',
        body: queryArg.apiInstructionSet
      })
    }),
    getByTenantNoteInstructionValidate: build.query<
      GetByTenantNoteInstructionValidateApiResponse,
      GetByTenantNoteInstructionValidateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/instruction/validate`,
        body: queryArg.apiNoteInstructionSubmission
      })
    }),
    postByTenantNoteInstructionSubmit: build.mutation<
      PostByTenantNoteInstructionSubmitApiResponse,
      PostByTenantNoteInstructionSubmitApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/instruction/submit`,
        method: 'POST',
        body: queryArg.apiNoteInstructionSubmission
      })
    }),
    postByTenantNoteAndNoteIdInstructionReject: build.mutation<
      PostByTenantNoteAndNoteIdInstructionRejectApiResponse,
      PostByTenantNoteAndNoteIdInstructionRejectApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/reject`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdInstructionApprove: build.mutation<
      PostByTenantNoteAndNoteIdInstructionApproveApiResponse,
      PostByTenantNoteAndNoteIdInstructionApproveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/approve`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdInstructionApproveCommitment: build.mutation<
      PostByTenantNoteAndNoteIdInstructionApproveCommitmentApiResponse,
      PostByTenantNoteAndNoteIdInstructionApproveCommitmentApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/approve/commitment`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdInstructionApproveCommitmentClient: build.mutation<
      PostByTenantNoteAndNoteIdInstructionApproveCommitmentClientApiResponse,
      PostByTenantNoteAndNoteIdInstructionApproveCommitmentClientApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/approve/commitment/client`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdInstructionApproveSettlement: build.mutation<
      PostByTenantNoteAndNoteIdInstructionApproveSettlementApiResponse,
      PostByTenantNoteAndNoteIdInstructionApproveSettlementApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/approve/settlement`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdInstructionActivate: build.mutation<
      PostByTenantNoteAndNoteIdInstructionActivateApiResponse,
      PostByTenantNoteAndNoteIdInstructionActivateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/instruction/activate`,
        method: 'POST'
      })
    }),
    getByTenantNoteInprogress: build.query<
      GetByTenantNoteInprogressApiResponse,
      GetByTenantNoteInprogressApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/inprogress`,
        params: {
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber
        }
      })
    }),
    getByTenantNoteInprogressCount: build.query<
      GetByTenantNoteInprogressCountApiResponse,
      GetByTenantNoteInprogressCountApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/note/inprogress/count` })
    }),
    postByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitId: build.mutation<
      PostByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitIdApiResponse,
      PostByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/change/businessunit/${queryArg.newBusinessUnitId}`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyId: build.mutation<
      PostByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyIdApiResponse,
      PostByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/change/counterparty/${queryArg.newCounterpartyId}`,
        method: 'POST'
      })
    }),
    postByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoan: build.mutation<
      PostByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoanApiResponse,
      PostByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoanApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/${queryArg.noteId}/change/iscollateralforloan/${queryArg.isCollateralForLoan}`,
        method: 'POST'
      })
    }),
    postByTenantNote: build.mutation<PostByTenantNoteApiResponse, PostByTenantNoteApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note`,
        method: 'POST',
        body: queryArg.addNote
      })
    }),
    getByTenantNote: build.query<GetByTenantNoteApiResponse, GetByTenantNoteApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/note` })
    }),
    postByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassification: build.mutation<
      PostByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassificationApiResponse,
      PostByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassificationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/changetaxclassification/${queryArg.noteId}/${queryArg.newTaxClassification}`,
        method: 'POST',
        body: queryArg.changeNoteApiTaxClassification
      })
    }),
    getByTenantNoteAndNoteIdClose: build.query<
      GetByTenantNoteAndNoteIdCloseApiResponse,
      GetByTenantNoteAndNoteIdCloseApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/note/${queryArg.noteId}/close` })
    }),
    getByTenantNoteBusinessunitAndId: build.query<
      GetByTenantNoteBusinessunitAndIdApiResponse,
      GetByTenantNoteBusinessunitAndIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/note/businessunit/${queryArg.id}` })
    }),
    getByTenantNoteDataAccountAndAccountIdPendingchanges: build.query<
      GetByTenantNoteDataAccountAndAccountIdPendingchangesApiResponse,
      GetByTenantNoteDataAccountAndAccountIdPendingchangesApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/data/account/${queryArg.accountId}/pendingchanges`
      })
    }),
    postByTenantNoteDataAccountAndAccountIdNewinstructions2: build.mutation<
      PostByTenantNoteDataAccountAndAccountIdNewinstructions2ApiResponse,
      PostByTenantNoteDataAccountAndAccountIdNewinstructions2ApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/data/account/${queryArg.accountId}/newinstructions2`,
        method: 'POST',
        body: queryArg.getApiNoteDataAfterInstructions
      })
    }),
    postByTenantNoteDataNewaccount: build.mutation<
      PostByTenantNoteDataNewaccountApiResponse,
      PostByTenantNoteDataNewaccountApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/note/data/newaccount`,
        method: 'POST',
        body: queryArg.getApiNoteTaxClassificationAfterNewAccount
      })
    }),
    postByTenantPerformancePortfolioBacktest: build.mutation<
      PostByTenantPerformancePortfolioBacktestApiResponse,
      PostByTenantPerformancePortfolioBacktestApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/performance/portfolio/backtest`,
        method: 'POST',
        body: queryArg.apiBacktestRequest
      })
    }),
    postByTenantPerformancePortfolioProjection: build.mutation<
      PostByTenantPerformancePortfolioProjectionApiResponse,
      PostByTenantPerformancePortfolioProjectionApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/performance/portfolio/projection`,
        method: 'POST',
        body: queryArg.apiProjectionRequest
      })
    }),
    postByTenantPerformanceTradeBacktest: build.mutation<
      PostByTenantPerformanceTradeBacktestApiResponse,
      PostByTenantPerformanceTradeBacktestApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/performance/trade/backtest`,
        method: 'POST',
        body: queryArg.apiTradePerformanceCalculation
      })
    }),
    postByTenantPerformanceTradeProjection: build.mutation<
      PostByTenantPerformanceTradeProjectionApiResponse,
      PostByTenantPerformanceTradeProjectionApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/performance/trade/projection`,
        method: 'POST',
        body: queryArg.apiTradePerformanceCalculation
      })
    }),
    postByTenantPortfolio: build.mutation<
      PostByTenantPortfolioApiResponse,
      PostByTenantPortfolioApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio`,
        method: 'POST',
        body: queryArg.apiNewPortfolio
      })
    }),
    putByTenantPortfolio: build.mutation<
      PutByTenantPortfolioApiResponse,
      PutByTenantPortfolioApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio`,
        method: 'PUT',
        body: queryArg.apiSavedPortfolio
      })
    }),
    getByTenantPortfolio: build.query<GetByTenantPortfolioApiResponse, GetByTenantPortfolioApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/portfolio` })
    }),
    getByTenantPortfolioMinimalAndBusinessUnitId: build.query<
      GetByTenantPortfolioMinimalAndBusinessUnitIdApiResponse,
      GetByTenantPortfolioMinimalAndBusinessUnitIdApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/minimal/${queryArg.businessUnitId}`
      })
    }),
    getByTenantPortfolioList: build.query<
      GetByTenantPortfolioListApiResponse,
      GetByTenantPortfolioListApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/list`,
        params: {
          WildcardString: queryArg.wildcardString,
          PortfolioStatusFilter: queryArg.portfolioStatusFilter,
          PortfolioTypes: queryArg.portfolioTypes,
          PageSize: queryArg.pageSize,
          PageNumber: queryArg.pageNumber,
          SortField: queryArg.sortField,
          SortAscending: queryArg.sortAscending
        }
      })
    }),
    getByTenantPortfolioAndModelPortfolioId: build.query<
      GetByTenantPortfolioAndModelPortfolioIdApiResponse,
      GetByTenantPortfolioAndModelPortfolioIdApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/portfolio/${queryArg.modelPortfolioId}` })
    }),
    getByTenantPortfolioAndModelPortfolioIdUsage: build.query<
      GetByTenantPortfolioAndModelPortfolioIdUsageApiResponse,
      GetByTenantPortfolioAndModelPortfolioIdUsageApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/${queryArg.modelPortfolioId}/usage`
      })
    }),
    postByTenantPortfolioCalculatemultiplier: build.mutation<
      PostByTenantPortfolioCalculatemultiplierApiResponse,
      PostByTenantPortfolioCalculatemultiplierApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/calculatemultiplier`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    putByTenantPortfolioAndModelPortfolioIdApprove: build.mutation<
      PutByTenantPortfolioAndModelPortfolioIdApproveApiResponse,
      PutByTenantPortfolioAndModelPortfolioIdApproveApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/${queryArg.modelPortfolioId}/approve`,
        method: 'PUT'
      })
    }),
    putByTenantPortfolioAndModelPortfolioIdReject: build.mutation<
      PutByTenantPortfolioAndModelPortfolioIdRejectApiResponse,
      PutByTenantPortfolioAndModelPortfolioIdRejectApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/${queryArg.modelPortfolioId}/reject`,
        method: 'PUT'
      })
    }),
    getByTenantPortfolioAndPortfolioIdPortfolioFactSheetDate: build.query<
      GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetDateApiResponse,
      GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetDateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/${queryArg.portfolioId}/portfolioFactSheet/${queryArg.date}`
      })
    }),
    getByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonth: build.query<
      GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonthApiResponse,
      GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonthApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/portfolio/${queryArg.portfolioId}/portfolioFactSheet/${queryArg.year}/${queryArg.month}`
      })
    }),
    getByTenantRiskmanagementLatestMarketdataFx: build.query<
      GetByTenantRiskmanagementLatestMarketdataFxApiResponse,
      GetByTenantRiskmanagementLatestMarketdataFxApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/latest/marketdata/fx` })
    }),
    getByTenantRiskmanagementLatestHoldingsreconciliation: build.query<
      GetByTenantRiskmanagementLatestHoldingsreconciliationApiResponse,
      GetByTenantRiskmanagementLatestHoldingsreconciliationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/latest/holdingsreconciliation`
      })
    }),
    getByTenantRiskmanagementAndDateHoldingsreconciliation: build.query<
      GetByTenantRiskmanagementAndDateHoldingsreconciliationApiResponse,
      GetByTenantRiskmanagementAndDateHoldingsreconciliationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.date}/holdingsreconciliation`
      })
    }),
    getByTenantRiskmanagementLatestAssetconcentration: build.query<
      GetByTenantRiskmanagementLatestAssetconcentrationApiResponse,
      GetByTenantRiskmanagementLatestAssetconcentrationApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/latest/assetconcentration` })
    }),
    getByTenantRiskmanagementAndDateAssetconcentration: build.query<
      GetByTenantRiskmanagementAndDateAssetconcentrationApiResponse,
      GetByTenantRiskmanagementAndDateAssetconcentrationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.date}/assetconcentration`
      })
    }),
    getByTenantRiskmanagementLatestMaxdrawdown: build.query<
      GetByTenantRiskmanagementLatestMaxdrawdownApiResponse,
      GetByTenantRiskmanagementLatestMaxdrawdownApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/latest/maxdrawdown` })
    }),
    getByTenantRiskmanagementAndDateMaxdrawdown: build.query<
      GetByTenantRiskmanagementAndDateMaxdrawdownApiResponse,
      GetByTenantRiskmanagementAndDateMaxdrawdownApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.date}/maxdrawdown`
      })
    }),
    getByTenantRiskmanagementAndTradeIdGapriskinfo: build.query<
      GetByTenantRiskmanagementAndTradeIdGapriskinfoApiResponse,
      GetByTenantRiskmanagementAndTradeIdGapriskinfoApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.tradeId}/gapriskinfo`
      })
    }),
    getByTenantRiskmanagementLatestAssetsprices: build.query<
      GetByTenantRiskmanagementLatestAssetspricesApiResponse,
      GetByTenantRiskmanagementLatestAssetspricesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/latest/assetsprices` })
    }),
    getByTenantRiskmanagementAssetpriceoverrideinfo: build.query<
      GetByTenantRiskmanagementAssetpriceoverrideinfoApiResponse,
      GetByTenantRiskmanagementAssetpriceoverrideinfoApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/assetpriceoverrideinfo` })
    }),
    postByTenantRiskmanagementUploadmarketdataset: build.mutation<
      PostByTenantRiskmanagementUploadmarketdatasetApiResponse,
      PostByTenantRiskmanagementUploadmarketdatasetApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/uploadmarketdataset`,
        method: 'POST',
        body: queryArg.apiMarketDataSet
      })
    }),
    getByTenantRiskmanagementMarketdatasets: build.query<
      GetByTenantRiskmanagementMarketdatasetsApiResponse,
      GetByTenantRiskmanagementMarketdatasetsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/marketdatasets`,
        body: queryArg.apiMarketDataSetRequest
      })
    }),
    postByTenantRiskmanagementAssetpriceoverride: build.mutation<
      PostByTenantRiskmanagementAssetpriceoverrideApiResponse,
      PostByTenantRiskmanagementAssetpriceoverrideApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/assetpriceoverride`,
        method: 'POST',
        body: queryArg.apiAssetPriceUserOverride
      })
    }),
    getByTenantRiskmanagementAssetConstituents: build.query<
      GetByTenantRiskmanagementAssetConstituentsApiResponse,
      GetByTenantRiskmanagementAssetConstituentsApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/asset/constituents` })
    }),
    getByTenantRiskmanagementExport: build.query<
      GetByTenantRiskmanagementExportApiResponse,
      GetByTenantRiskmanagementExportApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/export` })
    }),
    getByTenantRiskmanagementExportHoldingsreport: build.query<
      GetByTenantRiskmanagementExportHoldingsreportApiResponse,
      GetByTenantRiskmanagementExportHoldingsreportApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/export/holdingsreport` })
    }),
    getByTenantRiskmanagementExportStatic: build.query<
      GetByTenantRiskmanagementExportStaticApiResponse,
      GetByTenantRiskmanagementExportStaticApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/export/static` })
    }),
    getByTenantRiskmanagementLatestMarketdatasnapshot: build.query<
      GetByTenantRiskmanagementLatestMarketdatasnapshotApiResponse,
      GetByTenantRiskmanagementLatestMarketdatasnapshotApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/riskmanagement/latest/marketdatasnapshot` })
    }),
    getByTenantRiskmanagementAndDateMarketdatasnapshot: build.query<
      GetByTenantRiskmanagementAndDateMarketdatasnapshotApiResponse,
      GetByTenantRiskmanagementAndDateMarketdatasnapshotApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.date}/marketdatasnapshot`
      })
    }),
    getByTenantRiskmanagementAndDateClientgappayments: build.query<
      GetByTenantRiskmanagementAndDateClientgappaymentsApiResponse,
      GetByTenantRiskmanagementAndDateClientgappaymentsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/${queryArg.date}/clientgappayments`
      })
    }),
    getByTenantRiskmanagementLatestHoldingstransferbalancesreconciliation: build.query<
      GetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationApiResponse,
      GetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/riskmanagement/latest/holdingstransferbalancesreconciliation`
      })
    }),
    postByTenantScenariosConfigurationAllassetsladder: build.mutation<
      PostByTenantScenariosConfigurationAllassetsladderApiResponse,
      PostByTenantScenariosConfigurationAllassetsladderApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/allassetsladder`,
        method: 'POST',
        body: queryArg.allAssetsLadderScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestAllassetsladder: build.query<
      GetByTenantScenariosLatestAllassetsladderApiResponse,
      GetByTenantScenariosLatestAllassetsladderApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/allassetsladder` })
    }),
    postByTenantScenariosConfigurationSingleassetladder: build.mutation<
      PostByTenantScenariosConfigurationSingleassetladderApiResponse,
      PostByTenantScenariosConfigurationSingleassetladderApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/singleassetladder`,
        method: 'POST',
        body: queryArg.singleAssetLadderScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestSingleassetladder: build.query<
      GetByTenantScenariosLatestSingleassetladderApiResponse,
      GetByTenantScenariosLatestSingleassetladderApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/singleassetladder` })
    }),
    postByTenantScenariosConfigurationSingleassetdrawdown: build.mutation<
      PostByTenantScenariosConfigurationSingleassetdrawdownApiResponse,
      PostByTenantScenariosConfigurationSingleassetdrawdownApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/singleassetdrawdown`,
        method: 'POST',
        body: queryArg.singleAssetDrawdownScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestSingleassetdrawdown: build.query<
      GetByTenantScenariosLatestSingleassetdrawdownApiResponse,
      GetByTenantScenariosLatestSingleassetdrawdownApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/singleassetdrawdown` })
    }),
    postByTenantScenariosConfigurationFundmanagerladder: build.mutation<
      PostByTenantScenariosConfigurationFundmanagerladderApiResponse,
      PostByTenantScenariosConfigurationFundmanagerladderApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/fundmanagerladder`,
        method: 'POST',
        body: queryArg.fundManagerLadderScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestFundmanagerladder: build.query<
      GetByTenantScenariosLatestFundmanagerladderApiResponse,
      GetByTenantScenariosLatestFundmanagerladderApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/fundmanagerladder` })
    }),
    postByTenantScenariosConfigurationFundmanagerdrawdown: build.mutation<
      PostByTenantScenariosConfigurationFundmanagerdrawdownApiResponse,
      PostByTenantScenariosConfigurationFundmanagerdrawdownApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/fundmanagerdrawdown`,
        method: 'POST',
        body: queryArg.fundManagerDrawdownScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestFundmanagerdrawdown: build.query<
      GetByTenantScenariosLatestFundmanagerdrawdownApiResponse,
      GetByTenantScenariosLatestFundmanagerdrawdownApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/fundmanagerdrawdown` })
    }),
    postByTenantScenariosConfigurationCustomasset: build.mutation<
      PostByTenantScenariosConfigurationCustomassetApiResponse,
      PostByTenantScenariosConfigurationCustomassetApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/customasset`,
        method: 'POST',
        body: queryArg.customAssetScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestCustomasset: build.query<
      GetByTenantScenariosLatestCustomassetApiResponse,
      GetByTenantScenariosLatestCustomassetApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/customasset` })
    }),
    postByTenantScenariosConfigurationCustomfundmanager: build.mutation<
      PostByTenantScenariosConfigurationCustomfundmanagerApiResponse,
      PostByTenantScenariosConfigurationCustomfundmanagerApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/scenarios/configuration/customfundmanager`,
        method: 'POST',
        body: queryArg.customFundManagerScenarioConfiguration
      })
    }),
    getByTenantScenariosLatestCustomfundmanager: build.query<
      GetByTenantScenariosLatestCustomfundmanagerApiResponse,
      GetByTenantScenariosLatestCustomfundmanagerApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/scenarios/latest/customfundmanager` })
    }),
    postSchedulerByTenantRunOustanding: build.mutation<
      PostSchedulerByTenantRunOustandingApiResponse,
      PostSchedulerByTenantRunOustandingApiArg
    >({
      query: queryArg => ({ url: `/scheduler/${queryArg.tenant}/run/oustanding`, method: 'POST' })
    }),
    getSchedulerByTenantExecutions: build.query<
      GetSchedulerByTenantExecutionsApiResponse,
      GetSchedulerByTenantExecutionsApiArg
    >({
      query: queryArg => ({ url: `/scheduler/${queryArg.tenant}/executions` })
    }),
    getSchedulerByTenantRunAndTaskName: build.query<
      GetSchedulerByTenantRunAndTaskNameApiResponse,
      GetSchedulerByTenantRunAndTaskNameApiArg
    >({
      query: queryArg => ({ url: `/scheduler/${queryArg.tenant}/run/${queryArg.taskName}` })
    }),
    getSchedulerByTenantLogsAndStartSnapAsTicksIsInclusive: build.query<
      GetSchedulerByTenantLogsAndStartSnapAsTicksIsInclusiveApiResponse,
      GetSchedulerByTenantLogsAndStartSnapAsTicksIsInclusiveApiArg
    >({
      query: queryArg => ({
        url: `/scheduler/${queryArg.tenant}/logs/${queryArg.startSnapAsTicks}/${queryArg.isInclusive}`
      })
    }),
    postSchedulerByTenantReleaselockAndLockNameProcessId: build.mutation<
      PostSchedulerByTenantReleaselockAndLockNameProcessIdApiResponse,
      PostSchedulerByTenantReleaselockAndLockNameProcessIdApiArg
    >({
      query: queryArg => ({
        url: `/scheduler/${queryArg.tenant}/releaselock/${queryArg.lockName}/${queryArg.processId}`,
        method: 'POST'
      })
    }),
    postSchedulerByTenantReleaselockAll: build.mutation<
      PostSchedulerByTenantReleaselockAllApiResponse,
      PostSchedulerByTenantReleaselockAllApiArg
    >({
      query: queryArg => ({ url: `/scheduler/${queryArg.tenant}/releaselock/all`, method: 'POST' })
    }),
    postSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAll: build.mutation<
      PostSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAllApiResponse,
      PostSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAllApiArg
    >({
      query: queryArg => ({
        url: `/scheduler/${queryArg.tenant}/excecutions/unsuccessful/last/delete/all`,
        method: 'POST'
      })
    }),
    postSchedulerByTenantExcecutionsLastDeleteAndTaskName: build.mutation<
      PostSchedulerByTenantExcecutionsLastDeleteAndTaskNameApiResponse,
      PostSchedulerByTenantExcecutionsLastDeleteAndTaskNameApiArg
    >({
      query: queryArg => ({
        url: `/scheduler/${queryArg.tenant}/excecutions/last/delete/${queryArg.taskName}`,
        method: 'POST'
      })
    }),
    postSchedulerByTenantJobstatusesRevoke: build.mutation<
      PostSchedulerByTenantJobstatusesRevokeApiResponse,
      PostSchedulerByTenantJobstatusesRevokeApiArg
    >({
      query: queryArg => ({
        url: `/scheduler/${queryArg.tenant}/jobstatuses/revoke`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    postSetupResetcollectionindexes: build.mutation<
      PostSetupResetcollectionindexesApiResponse,
      PostSetupResetcollectionindexesApiArg
    >({
      query: () => ({ url: `/setup/resetcollectionindexes`, method: 'POST' })
    }),
    postSetupDropcollectionindexesByTenantName: build.mutation<
      PostSetupDropcollectionindexesByTenantNameApiResponse,
      PostSetupDropcollectionindexesByTenantNameApiArg
    >({
      query: queryArg => ({
        url: `/setup/dropcollectionindexes/${queryArg.tenantName}`,
        method: 'POST'
      })
    }),
    postSetupResetidentity: build.mutation<
      PostSetupResetidentityApiResponse,
      PostSetupResetidentityApiArg
    >({
      query: () => ({ url: `/setup/resetidentity`, method: 'POST' })
    }),
    postSetupRemovetenantByTenantName: build.mutation<
      PostSetupRemovetenantByTenantNameApiResponse,
      PostSetupRemovetenantByTenantNameApiArg
    >({
      query: queryArg => ({ url: `/setup/removetenant/${queryArg.tenantName}`, method: 'POST' })
    }),
    getSetupTenants: build.query<GetSetupTenantsApiResponse, GetSetupTenantsApiArg>({
      query: () => ({ url: `/setup/tenants` })
    }),
    postSetupCreatetenant: build.mutation<
      PostSetupCreatetenantApiResponse,
      PostSetupCreatetenantApiArg
    >({
      query: queryArg => ({
        url: `/setup/createtenant`,
        method: 'POST',
        body: queryArg.apiTenantConfiguration
      })
    }),
    postSetupUpdatetenant: build.mutation<
      PostSetupUpdatetenantApiResponse,
      PostSetupUpdatetenantApiArg
    >({
      query: queryArg => ({
        url: `/setup/updatetenant`,
        method: 'POST',
        body: queryArg.apiTenantConfiguration
      })
    }),
    postSetupUpdatetasksByTenantName: build.mutation<
      PostSetupUpdatetasksByTenantNameApiResponse,
      PostSetupUpdatetasksByTenantNameApiArg
    >({
      query: queryArg => ({
        url: `/setup/updatetasks/${queryArg.tenantName}`,
        method: 'POST',
        body: queryArg.apiSchedulingConfiguration
      })
    }),
    postSetupInitializeallcollectionsByTenantName: build.mutation<
      PostSetupInitializeallcollectionsByTenantNameApiResponse,
      PostSetupInitializeallcollectionsByTenantNameApiArg
    >({
      query: queryArg => ({
        url: `/setup/initializeallcollections/${queryArg.tenantName}`,
        method: 'POST'
      })
    }),
    getSetupExportByTenantNameAndName: build.query<
      GetSetupExportByTenantNameAndNameApiResponse,
      GetSetupExportByTenantNameAndNameApiArg
    >({
      query: queryArg => ({ url: `/setup/export/${queryArg.tenantName}/${queryArg.name}` })
    }),
    getSetupImportByTenantNameAndName: build.query<
      GetSetupImportByTenantNameAndNameApiResponse,
      GetSetupImportByTenantNameAndNameApiArg
    >({
      query: queryArg => ({ url: `/setup/import/${queryArg.tenantName}/${queryArg.name}` })
    }),
    postSetupImport: build.mutation<PostSetupImportApiResponse, PostSetupImportApiArg>({
      query: queryArg => ({
        url: `/setup/import`,
        method: 'POST',
        body: queryArg.importTenantCommand
      })
    }),
    getSetupExports: build.query<GetSetupExportsApiResponse, GetSetupExportsApiArg>({
      query: () => ({ url: `/setup/exports` })
    }),
    getSetupExportsByName: build.query<
      GetSetupExportsByNameApiResponse,
      GetSetupExportsByNameApiArg
    >({
      query: queryArg => ({ url: `/setup/exports/${queryArg.name}` })
    }),
    postSetupExportsByName: build.mutation<
      PostSetupExportsByNameApiResponse,
      PostSetupExportsByNameApiArg
    >({
      query: queryArg => ({
        url: `/setup/exports/${queryArg.name}`,
        method: 'POST',
        body: queryArg.body
      })
    }),
    deleteSetupExportsByName: build.mutation<
      DeleteSetupExportsByNameApiResponse,
      DeleteSetupExportsByNameApiArg
    >({
      query: queryArg => ({ url: `/setup/exports/${queryArg.name}`, method: 'DELETE' })
    }),
    getByTenantStaticFeetype: build.query<
      GetByTenantStaticFeetypeApiResponse,
      GetByTenantStaticFeetypeApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/feetype` })
    }),
    getByTenantStaticFeedeductionfrequency: build.query<
      GetByTenantStaticFeedeductionfrequencyApiResponse,
      GetByTenantStaticFeedeductionfrequencyApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/feedeductionfrequency` })
    }),
    getByTenantStaticFeebasis: build.query<
      GetByTenantStaticFeebasisApiResponse,
      GetByTenantStaticFeebasisApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/feebasis` })
    }),
    getByTenantStaticFeedaycount: build.query<
      GetByTenantStaticFeedaycountApiResponse,
      GetByTenantStaticFeedaycountApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/feedaycount` })
    }),
    getByTenantStaticCashinstrumentreferencerates: build.query<
      GetByTenantStaticCashinstrumentreferenceratesApiResponse,
      GetByTenantStaticCashinstrumentreferenceratesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/cashinstrumentreferencerates` })
    }),
    getByTenantStaticAssetclasses: build.query<
      GetByTenantStaticAssetclassesApiResponse,
      GetByTenantStaticAssetclassesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/assetclasses` })
    }),
    getByTenantStaticCurrencies: build.query<
      GetByTenantStaticCurrenciesApiResponse,
      GetByTenantStaticCurrenciesApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/static/currencies` })
    }),
    getByTenantStaticBusinessdatesAndFromTo: build.query<
      GetByTenantStaticBusinessdatesAndFromToApiResponse,
      GetByTenantStaticBusinessdatesAndFromToApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/static/businessdates/${queryArg.from}/${queryArg.to}`
      })
    }),
    getStatusOnline: build.query<GetStatusOnlineApiResponse, GetStatusOnlineApiArg>({
      query: () => ({ url: `/status/online` })
    }),
    getStatusAccessAdministrator: build.query<
      GetStatusAccessAdministratorApiResponse,
      GetStatusAccessAdministratorApiArg
    >({
      query: () => ({ url: `/status/access/Administrator` })
    }),
    getStatusAccessBusinessUnitUser: build.query<
      GetStatusAccessBusinessUnitUserApiResponse,
      GetStatusAccessBusinessUnitUserApiArg
    >({
      query: () => ({ url: `/status/access/BusinessUnitUser` })
    }),
    getStatusAccessServertoserver: build.query<
      GetStatusAccessServertoserverApiResponse,
      GetStatusAccessServertoserverApiArg
    >({
      query: () => ({ url: `/status/access/servertoserver` })
    }),
    getStatusAccessUser: build.query<GetStatusAccessUserApiResponse, GetStatusAccessUserApiArg>({
      query: () => ({ url: `/status/access/user` })
    }),
    postByTenantStrategy: build.mutation<
      PostByTenantStrategyApiResponse,
      PostByTenantStrategyApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/strategy`,
        method: 'POST',
        body: queryArg.apiNewStrategyTemplate
      })
    }),
    putByTenantStrategy: build.mutation<PutByTenantStrategyApiResponse, PutByTenantStrategyApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/strategy`,
        method: 'PUT',
        body: queryArg.apiStrategyTemplate
      })
    }),
    getByTenantStrategy: build.query<GetByTenantStrategyApiResponse, GetByTenantStrategyApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/strategy` })
    }),
    getByTenantConfigurationTrade: build.query<
      GetByTenantConfigurationTradeApiResponse,
      GetByTenantConfigurationTradeApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade` })
    }),
    getByTenantConfigurationScheduling: build.query<
      GetByTenantConfigurationSchedulingApiResponse,
      GetByTenantConfigurationSchedulingApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/scheduling` })
    }),
    getByTenantConfigurationUi: build.query<
      GetByTenantConfigurationUiApiResponse,
      GetByTenantConfigurationUiApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/ui` })
    }),
    getByTenantConfigurationTradeValuationcycleoverride: build.query<
      GetByTenantConfigurationTradeValuationcycleoverrideApiResponse,
      GetByTenantConfigurationTradeValuationcycleoverrideApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade/valuationcycleoverride` })
    }),
    getByTenantConfigurationTradeValuationsnapCurrent: build.query<
      GetByTenantConfigurationTradeValuationsnapCurrentApiResponse,
      GetByTenantConfigurationTradeValuationsnapCurrentApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade/valuationsnap/current` })
    }),
    getByTenantConfigurationTradeValuationcycleCurrent: build.query<
      GetByTenantConfigurationTradeValuationcycleCurrentApiResponse,
      GetByTenantConfigurationTradeValuationcycleCurrentApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade/valuationcycle/current` })
    }),
    getByTenantConfigurationTradeValuationcyclePrevious: build.query<
      GetByTenantConfigurationTradeValuationcyclePreviousApiResponse,
      GetByTenantConfigurationTradeValuationcyclePreviousApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/valuationcycle/previous`
      })
    }),
    postByTenantConfigurationTradeValuationsnapandcycleoverrideUnset: build.mutation<
      PostByTenantConfigurationTradeValuationsnapandcycleoverrideUnsetApiResponse,
      PostByTenantConfigurationTradeValuationsnapandcycleoverrideUnsetApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/valuationsnapandcycleoverride/unset`,
        method: 'POST'
      })
    }),
    getByTenantConfigurationTradeValuationsnapoverride: build.query<
      GetByTenantConfigurationTradeValuationsnapoverrideApiResponse,
      GetByTenantConfigurationTradeValuationsnapoverrideApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade/valuationsnapoverride` })
    }),
    postByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnap: build.mutation<
      PostByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnapApiResponse,
      PostByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnapApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/valuationsnapoverride/set/${queryArg.valuationSnap}`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationTradeEnable: build.mutation<
      PostByTenantConfigurationTradeEnableApiResponse,
      PostByTenantConfigurationTradeEnableApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/trade/enable`, method: 'POST' })
    }),
    postByTenantConfigurationTradeDisable: build.mutation<
      PostByTenantConfigurationTradeDisableApiResponse,
      PostByTenantConfigurationTradeDisableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/disable`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationGraphEnable: build.mutation<
      PostByTenantConfigurationGraphEnableApiResponse,
      PostByTenantConfigurationGraphEnableApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/graph/enable`, method: 'POST' })
    }),
    postByTenantConfigurationGraphDisable: build.mutation<
      PostByTenantConfigurationGraphDisableApiResponse,
      PostByTenantConfigurationGraphDisableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/graph/disable`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationCleanupEnable: build.mutation<
      PostByTenantConfigurationCleanupEnableApiResponse,
      PostByTenantConfigurationCleanupEnableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/cleanup/enable`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationCleanupDisable: build.mutation<
      PostByTenantConfigurationCleanupDisableApiResponse,
      PostByTenantConfigurationCleanupDisableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/cleanup/disable`,
        method: 'POST'
      })
    }),
    getByTenantConfigurationReconciliation: build.query<
      GetByTenantConfigurationReconciliationApiResponse,
      GetByTenantConfigurationReconciliationApiArg
    >({
      query: queryArg => ({ url: `/${queryArg.tenant}/configuration/reconciliation` })
    }),
    postByTenantConfigurationReconciliationUpdate: build.mutation<
      PostByTenantConfigurationReconciliationUpdateApiResponse,
      PostByTenantConfigurationReconciliationUpdateApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/reconciliation/update`,
        method: 'POST',
        body: queryArg.apiReconciliationConfiguration
      })
    }),
    postByTenantConfigurationFinswitchIsocurrencycodesEnable: build.mutation<
      PostByTenantConfigurationFinswitchIsocurrencycodesEnableApiResponse,
      PostByTenantConfigurationFinswitchIsocurrencycodesEnableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/finswitch/isocurrencycodes/enable`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationFinswitchIsocurrencycodesDisable: build.mutation<
      PostByTenantConfigurationFinswitchIsocurrencycodesDisableApiResponse,
      PostByTenantConfigurationFinswitchIsocurrencycodesDisableApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/finswitch/isocurrencycodes/disable`,
        method: 'POST'
      })
    }),
    postByTenantConfigurationTradeNoteDefaults: build.mutation<
      PostByTenantConfigurationTradeNoteDefaultsApiResponse,
      PostByTenantConfigurationTradeNoteDefaultsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/note/defaults`,
        method: 'POST',
        params: {
          CounterPartyIds: queryArg.counterPartyIds
        }
      })
    }),
    postByTenantConfigurationTradeAssetDefaults: build.mutation<
      PostByTenantConfigurationTradeAssetDefaultsApiResponse,
      PostByTenantConfigurationTradeAssetDefaultsApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/asset/defaults`,
        method: 'POST',
        params: {
          Fees: queryArg.fees,
          AssetClasses: queryArg.assetClasses,
          Currencies: queryArg.currencies
        }
      })
    }),
    postByTenantConfigurationTradeIdentifierConfiguration: build.mutation<
      PostByTenantConfigurationTradeIdentifierConfigurationApiResponse,
      PostByTenantConfigurationTradeIdentifierConfigurationApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/configuration/trade/identifier/configuration`,
        method: 'POST',
        params: {
          'AccountSettings.IdPrefix': queryArg['AccountSettings.IdPrefix'],
          'AccountSettings.IdPaddingLength': queryArg['AccountSettings.IdPaddingLength'],
          'AccountSettings.NextId': queryArg['AccountSettings.NextId'],
          'AccountSettings.LastUpdateTime': queryArg['AccountSettings.LastUpdateTime'],
          'PortfolioSettings.IdPrefix': queryArg['PortfolioSettings.IdPrefix'],
          'PortfolioSettings.IdPaddingLength': queryArg['PortfolioSettings.IdPaddingLength'],
          'PortfolioSettings.NextId': queryArg['PortfolioSettings.NextId'],
          'PortfolioSettings.LastUpdateTime': queryArg['PortfolioSettings.LastUpdateTime'],
          'NoteSettings.IdPrefix': queryArg['NoteSettings.IdPrefix'],
          'NoteSettings.IdPaddingLength': queryArg['NoteSettings.IdPaddingLength'],
          'NoteSettings.NextId': queryArg['NoteSettings.NextId'],
          'NoteSettings.LastUpdateTime': queryArg['NoteSettings.LastUpdateTime']
        }
      })
    }),
    getTwoFactor: build.query<GetTwoFactorApiResponse, GetTwoFactorApiArg>({
      query: () => ({ url: `/two-factor` })
    }),
    getTwoFactorSetup: build.query<GetTwoFactorSetupApiResponse, GetTwoFactorSetupApiArg>({
      query: () => ({ url: `/two-factor/setup` })
    }),
    postTwoFactorReset: build.mutation<PostTwoFactorResetApiResponse, PostTwoFactorResetApiArg>({
      query: queryArg => ({
        url: `/two-factor/reset`,
        method: 'POST',
        body: queryArg.apiResetAuthenticator
      })
    }),
    postTwoFactorRecoveryCodes: build.mutation<
      PostTwoFactorRecoveryCodesApiResponse,
      PostTwoFactorRecoveryCodesApiArg
    >({
      query: () => ({ url: `/two-factor/recovery-codes`, method: 'POST' })
    }),
    postTwoFactorVerify: build.mutation<PostTwoFactorVerifyApiResponse, PostTwoFactorVerifyApiArg>({
      query: queryArg => ({
        url: `/two-factor/verify`,
        method: 'POST',
        body: queryArg.apiVerifyAuthenticator
      })
    }),
    postTwoFactorLogin: build.mutation<PostTwoFactorLoginApiResponse, PostTwoFactorLoginApiArg>({
      query: queryArg => ({
        url: `/two-factor/login`,
        method: 'POST',
        body: queryArg.apiTwoFactorLoginUser,
        params: {
          rememberMachine: queryArg.rememberMachine
        }
      })
    }),
    postTwoFactorEnable: build.mutation<PostTwoFactorEnableApiResponse, PostTwoFactorEnableApiArg>({
      query: queryArg => ({
        url: `/two-factor/enable`,
        method: 'POST',
        body: queryArg.apiSetTwoFactorEnabled
      })
    }),
    getUsermanager: build.query<GetUsermanagerApiResponse, GetUsermanagerApiArg>({
      query: () => ({ url: `/usermanager` })
    }),
    putUsermanager: build.mutation<PutUsermanagerApiResponse, PutUsermanagerApiArg>({
      query: queryArg => ({ url: `/usermanager`, method: 'PUT', body: queryArg.apiEditUser })
    }),
    getUsermanagerBankAll: build.query<
      GetUsermanagerBankAllApiResponse,
      GetUsermanagerBankAllApiArg
    >({
      query: () => ({ url: `/usermanager/bank/all` })
    }),
    getUsermanagerClientAll: build.query<
      GetUsermanagerClientAllApiResponse,
      GetUsermanagerClientAllApiArg
    >({
      query: () => ({ url: `/usermanager/client/all` })
    }),
    getUsermanagerGetbyidByUserId: build.query<
      GetUsermanagerGetbyidByUserIdApiResponse,
      GetUsermanagerGetbyidByUserIdApiArg
    >({
      query: queryArg => ({ url: `/usermanager/getbyid/${queryArg.userId}` })
    }),
    getUsermanagerRoles: build.query<GetUsermanagerRolesApiResponse, GetUsermanagerRolesApiArg>({
      query: () => ({ url: `/usermanager/roles` })
    }),
    getUsermanagerRolesAll: build.query<
      GetUsermanagerRolesAllApiResponse,
      GetUsermanagerRolesAllApiArg
    >({
      query: () => ({ url: `/usermanager/roles/all` })
    }),
    getUsermanagerRolesBankAll: build.query<
      GetUsermanagerRolesBankAllApiResponse,
      GetUsermanagerRolesBankAllApiArg
    >({
      query: () => ({ url: `/usermanager/roles/bank/all` })
    }),
    getUsermanagerRolesClientAll: build.query<
      GetUsermanagerRolesClientAllApiResponse,
      GetUsermanagerRolesClientAllApiArg
    >({
      query: () => ({ url: `/usermanager/roles/client/all` })
    }),
    getUsermanagerCurrent: build.query<
      GetUsermanagerCurrentApiResponse,
      GetUsermanagerCurrentApiArg
    >({
      query: () => ({ url: `/usermanager/current` })
    }),
    postUsermanagerCreate: build.mutation<
      PostUsermanagerCreateApiResponse,
      PostUsermanagerCreateApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/create`,
        method: 'POST',
        body: queryArg.newUserCommand
      })
    }),
    postUsermanagerConfirmEmail: build.mutation<
      PostUsermanagerConfirmEmailApiResponse,
      PostUsermanagerConfirmEmailApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/confirmEmail`,
        method: 'POST',
        body: queryArg.apiConfirmEmail
      })
    }),
    postUsermanagerOnboard: build.mutation<
      PostUsermanagerOnboardApiResponse,
      PostUsermanagerOnboardApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/onboard`,
        method: 'POST',
        body: queryArg.apiOnboardingDetails
      })
    }),
    getUsermanagerRecaptchaDisabled: build.query<
      GetUsermanagerRecaptchaDisabledApiResponse,
      GetUsermanagerRecaptchaDisabledApiArg
    >({
      query: () => ({ url: `/usermanager/recaptcha/disabled` })
    }),
    postUsermanagerForgotPassword: build.mutation<
      PostUsermanagerForgotPasswordApiResponse,
      PostUsermanagerForgotPasswordApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/forgotPassword`,
        method: 'POST',
        body: queryArg.apiForgotPassword
      })
    }),
    postUsermanagerReset: build.mutation<
      PostUsermanagerResetApiResponse,
      PostUsermanagerResetApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/reset`,
        method: 'POST',
        body: queryArg.resetPasswordCommand
      })
    }),
    postUsermanagerChangepwd: build.mutation<
      PostUsermanagerChangepwdApiResponse,
      PostUsermanagerChangepwdApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/changepwd`,
        method: 'POST',
        body: queryArg.changePasswordCommand
      })
    }),
    postUsermanagerAddtorole: build.mutation<
      PostUsermanagerAddtoroleApiResponse,
      PostUsermanagerAddtoroleApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/addtorole`,
        method: 'POST',
        body: queryArg.addUserRoleCommand
      })
    }),
    postUsermanagerRemovefromrole: build.mutation<
      PostUsermanagerRemovefromroleApiResponse,
      PostUsermanagerRemovefromroleApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/removefromrole`,
        method: 'POST',
        body: queryArg.removeUserFromRoleCommand
      })
    }),
    deleteUsermanagerRemoveByUsername: build.mutation<
      DeleteUsermanagerRemoveByUsernameApiResponse,
      DeleteUsermanagerRemoveByUsernameApiArg
    >({
      query: queryArg => ({ url: `/usermanager/remove/${queryArg.username}`, method: 'DELETE' })
    }),
    getUsermanagerUnlockByUsername: build.query<
      GetUsermanagerUnlockByUsernameApiResponse,
      GetUsermanagerUnlockByUsernameApiArg
    >({
      query: queryArg => ({ url: `/usermanager/unlock/${queryArg.username}` })
    }),
    getUsermanagerEnabledisablelockoutByUsernameAndIsEnabled: build.query<
      GetUsermanagerEnabledisablelockoutByUsernameAndIsEnabledApiResponse,
      GetUsermanagerEnabledisablelockoutByUsernameAndIsEnabledApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/enabledisablelockout/${queryArg.username}/${queryArg.isEnabled}`
      })
    }),
    postUsermanagerDeactivateByUsername: build.mutation<
      PostUsermanagerDeactivateByUsernameApiResponse,
      PostUsermanagerDeactivateByUsernameApiArg
    >({
      query: queryArg => ({ url: `/usermanager/deactivate/${queryArg.username}`, method: 'POST' })
    }),
    postUsermanagerActivateByUsername: build.mutation<
      PostUsermanagerActivateByUsernameApiResponse,
      PostUsermanagerActivateByUsernameApiArg
    >({
      query: queryArg => ({ url: `/usermanager/activate/${queryArg.username}`, method: 'POST' })
    }),
    getUsermanagerExport: build.query<GetUsermanagerExportApiResponse, GetUsermanagerExportApiArg>({
      query: () => ({ url: `/usermanager/export` })
    }),
    getUsermanagerExportBank: build.query<
      GetUsermanagerExportBankApiResponse,
      GetUsermanagerExportBankApiArg
    >({
      query: () => ({ url: `/usermanager/export/bank` })
    }),
    getUsermanagerExportClient: build.query<
      GetUsermanagerExportClientApiResponse,
      GetUsermanagerExportClientApiArg
    >({
      query: () => ({ url: `/usermanager/export/client` })
    }),
    getUsermanagerExportClientByCliendId: build.query<
      GetUsermanagerExportClientByCliendIdApiResponse,
      GetUsermanagerExportClientByCliendIdApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/export/client/${queryArg.cliendId}`,
        params: {
          clientId: queryArg.clientId
        }
      })
    }),
    getUsermanagerExportBusinessunitByBusinessUnitId: build.query<
      GetUsermanagerExportBusinessunitByBusinessUnitIdApiResponse,
      GetUsermanagerExportBusinessunitByBusinessUnitIdApiArg
    >({
      query: queryArg => ({ url: `/usermanager/export/businessunit/${queryArg.businessUnitId}` })
    }),
    postUsermanagerUsernameGenerate: build.mutation<
      PostUsermanagerUsernameGenerateApiResponse,
      PostUsermanagerUsernameGenerateApiArg
    >({
      query: queryArg => ({
        url: `/usermanager/username/generate`,
        method: 'POST',
        body: queryArg.getUserNameCommand
      })
    }),
    getIndexStatus: build.query<GetIndexStatusApiResponse, GetIndexStatusApiArg>({
      query: queryArg => ({ url: `/${queryArg.tenant}/v/index/${queryArg.date}/status` })
    }),
    restoreObsoleteBlockChain: build.mutation<
      RestoreObsoleteBlockChainApiResponse,
      RestoreObsoleteBlockChainApiArg
    >({
      query: queryArg => ({
        url: `/${queryArg.tenant}/v/index/obsolete/restore/${queryArg.base58StateRootAddress}`,
        method: 'POST'
      })
    }),
    getReportingStatus: build.query<GetReportingStatusApiResponse, GetReportingStatusApiArg>({
      query: queryArg => ({
        url: `/${queryArg.tenant}/r/index/${queryArg.date}/${queryArg.reportType}/status`
      })
    })
  }),
  overrideExisting: false
})
export { injectedRtkApi as api }
export type PostByTenantAccountSaveApiResponse =
  /** status 200 OK */ ApiSaveNewAccountActionResultRead
export type PostByTenantAccountSaveApiArg = {
  apiUnapprovedAccount: ApiUnapprovedAccount
  tenant: string
}
export type PostByTenantAccountUpdateSaveApiResponse =
  /** status 200 OK */ ApiUpdateAccountActionResultRead
export type PostByTenantAccountUpdateSaveApiArg = {
  apiUnapprovedAccountUpdate: ApiUnapprovedAccountUpdate
  tenant: string
}
export type PostByTenantAccountSubmitAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountSubmitAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type PostByTenantAccountApproveEconomicsAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountApproveEconomicsAndAccountIdentifierApiArg = {
  accountIdentifier: string
  apiTradeEconomics: ApiTradeEconomics
  tenant: string
}
export type PostByTenantAccountApproveAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountApproveAndAccountIdentifierApiArg = {
  accountIdentifier: string
  apiTradeApproval: ApiTradeApproval
  tenant: string
}
export type PostByTenantAccountRejectAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountRejectAndAccountIdentifierApiArg = {
  accountIdentifier: string
  apiTradeRejection: ApiTradeRejection
  tenant: string
}
export type PostByTenantAccountCommitAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountCommitAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type PostByTenantAccountCommitClientAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountCommitClientAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type PostByTenantAccountConfirmAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountConfirmAndAccountIdentifierApiArg = {
  accountIdentifier: string
  apiConfirmSettlementRequest: ApiConfirmSettlementRequest
  tenant: string
}
export type PostByTenantAccountActivateAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountActivateAndAccountIdentifierApiArg = {
  accountIdentifier: string
  apiTradeActivation: ApiTradeActivation
  tenant: string
}
export type PostByTenantAccountCloseAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountCloseAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type PostByTenantAccountDeleteAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountDeleteAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type PostByTenantAccountDeleterevertdraftAndAccountIdentifierApiResponse = unknown
export type PostByTenantAccountDeleterevertdraftAndAccountIdentifierApiArg = {
  accountIdentifier: string
  tenant: string
}
export type GetByTenantAccountAndAccountSourceAccountIdentifierApiResponse =
  /** status 200 OK */ ApiAccountHistoryReportWithNoteDataRead
export type GetByTenantAccountAndAccountSourceAccountIdentifierApiArg = {
  accountIdentifier: string
  accountSource: string
  tenant: string
}
export type GetByTenantAccountSummaryAndAccountSourceAccountIdentifierApiResponse =
  /** status 200 OK */ ApiAccountHistoryReportRead
export type GetByTenantAccountSummaryAndAccountSourceAccountIdentifierApiArg = {
  accountIdentifier: string
  accountSource: string
  tenant: string
}
export type GetByTenantAccountApiResponse = /** status 200 OK */ ApiDashboard
export type GetByTenantAccountApiArg = {
  accountRunningStatus?: ApiAccountRunningStatus
  clientType?: ApiClientType
  currencyCode?: string
  isNoteCollateralized?: boolean
  noteIds?: string
  portfolioType?: ApiPortfolioType
  strategyType?: ApiStrategyType
  tenant: string
}
export type GetByTenantAccountDashboardApiResponse = /** status 200 OK */ ApiAccountDashboardRead
export type GetByTenantAccountDashboardApiArg = {
  clientType?: ApiClientType
  currencyCode?: string
  isNoteCollateralized?: boolean
  noteIds?: string
  sortAscending?: boolean
  sortField?: string
  tenant: string
}
export type GetByTenantAccountRunningApiResponse =
  /** status 200 OK */ ApiAccountDashboardAccountApiPaginationResult
export type GetByTenantAccountRunningApiArg = {
  businessUnits?: string
  businessUnitsList?: string[]
  clients?: string
  clientsList?: string[]
  currencies?: string
  currenciesList?: string[]
  notes?: string
  notesList?: string[]
  pageNumber?: number
  pageSize?: number
  portfolios?: string
  portfoliosList?: string[]
  sortAscending?: boolean
  sortField?: string
  strategies?: string
  strategiesList?: string[]
  tenant: string
}
export type PostByTenantAccountExportApiResponse = /** status 200 OK */ Blob
export type PostByTenantAccountExportApiArg = {
  /** The filters to apply. */
  getAccountsFilters: GetAccountsFilters
  tenant: string
}
export type PostByTenantAccountAccrualsExportApiResponse = /** status 200 OK */ Blob
export type PostByTenantAccountAccrualsExportApiArg = {
  /** The filters to apply. */
  apiGetAccountAccrualsFilter: ApiGetAccountAccrualsFilter
  tenant: string
}
export type PostByTenantAccountExportJsonApiResponse = /** status 200 OK */ AccountExportReport[]
export type PostByTenantAccountExportJsonApiArg = {
  /** The filters to apply. */
  getAccountsFilters: GetAccountsFilters
  tenant: string
}
export type GetByTenantAccountInprogressApiResponse =
  /** status 200 OK */ ApiTradingAccountApiPaginationResultRead
export type GetByTenantAccountInprogressApiArg = {
  filterNewAccounts?: boolean
  pageNumber?: number
  pageSize?: number
  sortAscending?: boolean
  sortField?: string
  status?: string
  tenant: string
  wildcardString?: string
}
export type GetByTenantAccountInprogressAndAccountIdentifierApiResponse =
  /** status 200 OK */ ApiTradingAccountRead
export type GetByTenantAccountInprogressAndAccountIdentifierApiArg = {
  /** The account identifier. */
  accountIdentifier: string
  tenant: string
}
export type GetByTenantAccountFirstaccountdateApiResponse = /** status 200 OK */ string
export type GetByTenantAccountFirstaccountdateApiArg = {
  tenant: string
}
export type GetByTenantAccountAllaccountdetailsApiResponse =
  /** status 200 OK */ ApiAccountDetails[]
export type GetByTenantAccountAllaccountdetailsApiArg = {
  tenant: string
}
export type GetByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDateApiResponse =
  /** status 200 OK */ ApiAccountSnapshotRead[]
export type GetByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDateApiArg = {
  accountId: string
  accountSource: string
  endDate: string
  startDate: string
  tenant: string
}
export type GetByTenantAccountSnapshotsAndDateApiResponse =
  /** status 200 OK */ ApiAccountSnapshotRead[]
export type GetByTenantAccountSnapshotsAndDateApiArg = {
  date: string
  tenant: string
}
export type GetByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatestApiResponse =
  /** status 200 OK */ ApiAccountSnapshotRead
export type GetByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatestApiArg = {
  accountIdentifier: string
  accountSource: string
  tenant: string
}
export type GetByTenantAccountStaticApiResponse = /** status 200 OK */ ApiTradingAccountRead[]
export type GetByTenantAccountStaticApiArg = {
  tenant: string
}
export type GetByTenantAccountStaticAndAccountNameApiResponse =
  /** status 200 OK */ ApiTradingAccountRead
export type GetByTenantAccountStaticAndAccountNameApiArg = {
  /** The account name. */
  accountName: string
  tenant: string
}
export type PostByTenantAccountPricesAndAccountIdApiResponse = /** status 200 OK */ ApiNotePrices
export type PostByTenantAccountPricesAndAccountIdApiArg = {
  /** The account identifier. */
  accountId: string
  /** The transfer of units details. */
  body: ApiTransferOfUnits[]
  tenant: string
}
export type PostByTenantAccountLocksAndAccountIdLockTypeRemoveApiResponse = unknown
export type PostByTenantAccountLocksAndAccountIdLockTypeRemoveApiArg = {
  /** Account identifier of the account */
  accountId: string
  /** Lock type to remove */
  lockType: ApiAccountLockType
  tenant: string
}
export type GetByTenantAccountExportPendingfeesApiResponse = /** status 200 OK */ string
export type GetByTenantAccountExportPendingfeesApiArg = {
  tenant: string
}
export type GetByTenantVAndDateAccountAccountIdApiResponse =
  /** status 200 OK */ AccountValuationBlock[]
export type GetByTenantVAndDateAccountAccountIdApiArg = {
  accountId: string
  date: string
  tenant: string
}
export type GetByTenantVAndAccountIdHistoryApiResponse =
  /** status 200 OK */ AccountValuationBlock[]
export type GetByTenantVAndAccountIdHistoryApiArg = {
  accountId: string
  tenant: string
}
export type GetByTenantVDatesApiResponse = /** status 200 OK */ string[]
export type GetByTenantVDatesApiArg = {
  tenant: string
}
export type GetByTenantAssetApiResponse = /** status 200 OK */ (
  | ApiMutualFundAssetRead
  | ApiSegregatedPortfolioAssetRead
)[]
export type GetByTenantAssetApiArg = {
  tenant: string
}
export type GetByTenantAssetListApiResponse =
  /** status 200 OK */ ApiAssetDetailsApiPaginationResultRead
export type GetByTenantAssetListApiArg = {
  pageNumber?: number
  pageSize?: number
  sortAscending?: boolean
  sortField?: string
  tenant: string
  wildcardString?: string
}
export type GetByTenantAssetAndAssetIdDetailsApiResponse = /** status 200 OK */ ApiAssetDetailsRead
export type GetByTenantAssetAndAssetIdDetailsApiArg = {
  /** The asset identifier. */
  assetId: string
  tenant: string
}
export type GetByTenantAssetAndAssetIdHistoryApiResponse =
  /** status 200 OK */ ApiAssetPriceWithHistory
export type GetByTenantAssetAndAssetIdHistoryApiArg = {
  /** The asset identifier. */
  assetId: string
  tenant: string
}
export type GetByTenantAssetMutualfundsApiResponse = /** status 200 OK */ (
  | ApiMutualFundAssetRead
  | ApiSegregatedPortfolioAssetRead
)[]
export type GetByTenantAssetMutualfundsApiArg = {
  tenant: string
}
export type GetByTenantAssetSegregatedportfoliosApiResponse =
  /** status 200 OK */ ApiSegregatedPortfolioAssetRead[]
export type GetByTenantAssetSegregatedportfoliosApiArg = {
  tenant: string
}
export type GetByTenantAssetAndAssetIdApiResponse =
  /** status 200 OK */
  ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
export type GetByTenantAssetAndAssetIdApiArg = {
  /** The asset identifier. */
  assetId: string
  tenant: string
}
export type PostByTenantAssetMutualfundApiResponse = unknown
export type PostByTenantAssetMutualfundApiArg = {
  /** The mutual fund asset. */
  apiMutualFundAsset: ApiMutualFundAsset
  tenant: string
}
export type PutByTenantAssetMutualfundApiResponse = unknown
export type PutByTenantAssetMutualfundApiArg = {
  /** The API mutual fund asset. */
  apiMutualFundAsset: ApiMutualFundAsset
  tenant: string
}
export type PutByTenantAssetFundManagerApiResponse = /** status 200 OK */ ApiRenameFundManagerResult
export type PutByTenantAssetFundManagerApiArg = {
  /** The ManCo code and the new fund manager name. */
  apiRenameFundManagerRequest: ApiRenameFundManagerRequest
  tenant: string
}
export type PutByTenantAssetAndAssetIdTradingProviderNewTradingProviderApiResponse = unknown
export type PutByTenantAssetAndAssetIdTradingProviderNewTradingProviderApiArg = {
  /** The asset id. */
  assetId: string
  /** The new trading provider type */
  newTradingProvider: ApiTradingProviderType
  tenant: string
}
export type PutByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProviderApiResponse = unknown
export type PutByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProviderApiArg = {
  /** The asset id. */
  assetId: string
  /** The new trading provider type */
  newMarketDataProvider: ApiMarketDataProviderType
  tenant: string
}
export type PostByTenantAssetSegregatedportfolioApiResponse = unknown
export type PostByTenantAssetSegregatedportfolioApiArg = {
  /** The segregated portfolio asset. */
  apiSegregatedPortfolioAsset: ApiSegregatedPortfolioAsset
  tenant: string
}
export type PutByTenantAssetSegregatedportfolioApiResponse = unknown
export type PutByTenantAssetSegregatedportfolioApiArg = {
  /** The API segregated portfolio asset. */
  apiSegregatedPortfolioAsset: ApiSegregatedPortfolioAsset
  tenant: string
}
export type GetByTenantAssetDefaultsApiResponse = /** status 200 OK */ ApiAssetDefaultConfiguration
export type GetByTenantAssetDefaultsApiArg = {
  tenant: string
}
export type PostByTenantAssetUploadApiResponse = unknown
export type PostByTenantAssetUploadApiArg = {
  tenant: string
}
export type PostByTenantAssetAndAssetIdExdatesAddApiResponse = unknown
export type PostByTenantAssetAndAssetIdExdatesAddApiArg = {
  /** The API asset ex dates. */
  apiAssetExDates: ApiAssetExDates
  /** The asset id. */
  assetId: string
  tenant: string
}
export type GetByTenantAssetIndexesApiResponse = /** status 200 OK */ ApiIndex[]
export type GetByTenantAssetIndexesApiArg = {
  tenant: string
}
export type PostByTenantAssetIndexApiResponse = unknown
export type PostByTenantAssetIndexApiArg = {
  /** The index instrument to add. */
  apiIndex: ApiIndex
  tenant: string
}
export type GetByTenantAssetListOrderAlertApiResponse =
  /** status 200 OK */ ApiAssetWithOrderAlertApiPaginationResultRead
export type GetByTenantAssetListOrderAlertApiArg = {
  pageNumber?: number
  pageSize?: number
  tenant: string
  wildcardString?: string
}
export type PostByTenantAssetAndAssetIdMarketdatareadyApiResponse = unknown
export type PostByTenantAssetAndAssetIdMarketdatareadyApiArg = {
  /** The asset ID. */
  assetId: string
  tenant: string
}
export type PostByTenantAssetAndAssetIdSoftdeleteApiResponse = unknown
export type PostByTenantAssetAndAssetIdSoftdeleteApiArg = {
  /** The asset ID. */
  assetId: string
  tenant: string
}
export type PostByTenantAssetAndAssetIdRestoreApiResponse = unknown
export type PostByTenantAssetAndAssetIdRestoreApiArg = {
  /** The asset ID. */
  assetId: string
  tenant: string
}
export type GetSystemAuditAfterByDateApiResponse = /** status 200 OK */ AuditLog[]
export type GetSystemAuditAfterByDateApiArg = {
  /** The date. */
  date: string
}
export type PostAuthLoginApiResponse = unknown
export type PostAuthLoginApiArg = {
  /** The API login user model. */
  apiLoginUser: ApiLoginUser
}
export type PostAuthLogoutApiResponse = unknown
export type PostAuthLogoutApiArg = void
export type GetAuthAuthConfigJsApiResponse = /** status 200 OK */ SsoConfig
export type GetAuthAuthConfigJsApiArg = void
export type GetByTenantBusinessunitAndBusinessUnitIdApiResponse =
  /** status 200 OK */ ApiBusinessUnit
export type GetByTenantBusinessunitAndBusinessUnitIdApiArg = {
  /** The business unit identifier. */
  businessUnitId: string
  tenant: string
}
export type PostByTenantBusinessunitAndBusinessUnitIdUsersApiResponse = unknown
export type PostByTenantBusinessunitAndBusinessUnitIdUsersApiArg = {
  /** The API add business unit user. */
  apiAddBusinessUnitUser: ApiAddBusinessUnitUser
  /** The business unit identifier. */
  businessUnitId: string
  tenant: string
}
export type GetByTenantBusinessunitAndBusinessUnitIdUsersApiResponse =
  /** status 200 OK */ ApiBusinessUnitWithUsers
export type GetByTenantBusinessunitAndBusinessUnitIdUsersApiArg = {
  /** The business unit identifier. */
  businessUnitId: string
  tenant: string
}
export type PostByTenantBusinessunitTransferApiResponse =
  /** status 200 OK */ ApiTransferBusinessUnitOwnershipResult
export type PostByTenantBusinessunitTransferApiArg = {
  /** The API transfer business unit ownership. */
  apiTransferBusinessUnitOwnership: ApiTransferBusinessUnitOwnership
  tenant: string
}
export type GetByTenantCashinstrumentApiResponse = /** status 200 OK */ (
  | ApiLoan
  | ApiDeposit
  | ApiZcbCurve
)[]
export type GetByTenantCashinstrumentApiArg = {
  tenant: string
}
export type GetByTenantCashinstrumentListApiResponse =
  /** status 200 OK */ ApiCashInstrumentApiPaginationResult
export type GetByTenantCashinstrumentListApiArg = {
  cashInstrumentType?: ApiCashInstrumentType
  pageNumber?: number
  pageSize?: number
  sortAscending?: boolean
  sortField?: string
  tenant: string
  wildcardString?: string
}
export type PostByTenantCashinstrumentLoanApiResponse = unknown
export type PostByTenantCashinstrumentLoanApiArg = {
  /** The loan to add. */
  apiLoan: ApiLoan
  tenant: string
}
export type PostByTenantCashinstrumentLoanUpdateApiResponse = unknown
export type PostByTenantCashinstrumentLoanUpdateApiArg = {
  /** The new version of the loan. */
  apiLoan: ApiLoan
  tenant: string
}
export type PostByTenantCashinstrumentDepositApiResponse = unknown
export type PostByTenantCashinstrumentDepositApiArg = {
  /** The deposit to add. */
  apiDeposit: ApiDeposit
  tenant: string
}
export type PostByTenantCashinstrumentDepositUpdateApiResponse = unknown
export type PostByTenantCashinstrumentDepositUpdateApiArg = {
  /** The new version of the deposit. */
  apiDeposit: ApiDeposit
  tenant: string
}
export type PostByTenantCashinstrumentZcbcurveApiResponse = unknown
export type PostByTenantCashinstrumentZcbcurveApiArg = {
  /** The curve to add. */
  apiZcbCurve: ApiZcbCurve
  tenant: string
}
export type PostByTenantCashinstrumentZcbcurveUpdateApiResponse = unknown
export type PostByTenantCashinstrumentZcbcurveUpdateApiArg = {
  /** The new version of the ZCB curve. */
  apiZcbCurve: ApiZcbCurve
  tenant: string
}
export type PostByTenantClientApiResponse = /** status 200 OK */ string
export type PostByTenantClientApiArg = {
  /** The new client. */
  apiNewClient: ApiNewClient
  tenant: string
}
export type GetByTenantClientApiResponse = /** status 200 OK */ ApiClient[]
export type GetByTenantClientApiArg = {
  tenant: string
}
export type PutByTenantClientApiResponse = unknown
export type PutByTenantClientApiArg = {
  /** The API client. */
  apiClient: ApiClient
  tenant: string
}
export type GetByTenantClientUsersApiResponse = /** status 200 OK */ ApiClientWithUsers[]
export type GetByTenantClientUsersApiArg = {
  tenant: string
}
export type GetByTenantClientAndClientIdApiResponse = /** status 200 OK */ ApiClient
export type GetByTenantClientAndClientIdApiArg = {
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type GetByTenantClientAndClientIdUsersApiResponse = /** status 200 OK */ ApiClientWithUsers
export type GetByTenantClientAndClientIdUsersApiArg = {
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type PostByTenantClientAndClientIdUsersApiResponse = unknown
export type PostByTenantClientAndClientIdUsersApiArg = {
  /** The API add client user. */
  apiAddClientUser: ApiAddClientUser
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type PostByTenantClientAndClientIdBusinessUnitsApiResponse = unknown
export type PostByTenantClientAndClientIdBusinessUnitsApiArg = {
  /** The API add business unit to client. */
  apiAddBusinessUnitToClient: ApiAddBusinessUnitToClient
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type PutByTenantClientAndClientIdBusinessUnitsApiResponse = unknown
export type PutByTenantClientAndClientIdBusinessUnitsApiArg = {
  /** The API business unit. */
  apiBusinessUnit: ApiBusinessUnit
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type DeleteByTenantClientAndClientIdBusinessUnitsBusinessUnitIdApiResponse = unknown
export type DeleteByTenantClientAndClientIdBusinessUnitsBusinessUnitIdApiArg = {
  /** The business unit identifier. */
  businessUnitId: string
  /** The client identifier. */
  clientId: string
  tenant: string
}
export type GetByTenantCounterpartyCounterpartyidsApiResponse = /** status 200 OK */ string[]
export type GetByTenantCounterpartyCounterpartyidsApiArg = {
  tenant: string
}
export type GetByTenantCounterpartyAllApiResponse = /** status 200 OK */ ApiCounterparty[]
export type GetByTenantCounterpartyAllApiArg = {
  tenant: string
}
export type PostByTenantCounterpartyAddApiResponse = unknown
export type PostByTenantCounterpartyAddApiArg = {
  /** The counterparty. */
  apiCounterparty: ApiCounterparty
  tenant: string
}
export type PutByTenantCounterpartyUpdateApiResponse = unknown
export type PutByTenantCounterpartyUpdateApiArg = {
  /** The counterparty. */
  apiCounterparty: ApiCounterparty
  tenant: string
}
export type PostByTenantUploadModelparametersApiResponse = unknown
export type PostByTenantUploadModelparametersApiArg = {
  apiModelParametersMessage: ApiModelParametersMessage
  tenant: string
}
export type PostByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDateApiResponse =
  /** status 200 OK */ any
export type PostByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDateApiArg = {
  contentType: string
  fileName: string
  fileType: ExchangeFileType
  referenceDate: string
  tenant: string
}
export type PostByTenantDfmApiResponse = /** status 200 OK */ string
export type PostByTenantDfmApiArg = {
  /** The new DFM. */
  apiNewDfm: ApiNewDfm
  tenant: string
}
export type PutByTenantDfmApiResponse = unknown
export type PutByTenantDfmApiArg = {
  /** The DFM. */
  apiDfm: ApiDfm
  tenant: string
}
export type PostByTenantDfmAndDfmIdUsersApiResponse = unknown
export type PostByTenantDfmAndDfmIdUsersApiArg = {
  /** The API add DFM user. */
  apiAddDfmUser: ApiAddDfmUser
  /** The DFM identifier. */
  dfmId: string
  tenant: string
}
export type GetByTenantDfmAndDfmIdUsersApiResponse = /** status 200 OK */ ApiDfmWithUsers
export type GetByTenantDfmAndDfmIdUsersApiArg = {
  /** The DFM identifier. */
  dfmId: string
  tenant: string
}
export type GetDiagnosticsTaxclassifierApiResponse = /** status 200 OK */ string
export type GetDiagnosticsTaxclassifierApiArg = void
export type GetDiagnosticsByTenantTaxclassifierApiResponse = /** status 200 OK */ TaxClassification
export type GetDiagnosticsByTenantTaxclassifierApiArg = {
  tenant: string
}
export type GetDiagnosticsErrorApiResponse = unknown
export type GetDiagnosticsErrorApiArg = void
export type PostDiagnosticsErrorApiResponse = unknown
export type PostDiagnosticsErrorApiArg = {
  body: {
    [key: string]: JsonNode
  }
}
export type GetDiagnosticsMediatrApiResponse = /** status 200 OK */ string
export type GetDiagnosticsMediatrApiArg = void
export type GetDiagnosticsMediatrSendApiResponse = /** status 200 OK */ TestResult
export type GetDiagnosticsMediatrSendApiArg = void
export type GetDiagnosticsRolesApiResponse = /** status 200 OK */ string[]
export type GetDiagnosticsRolesApiArg = void
export type GetDiagnosticsApiResponse = /** status 200 OK */ DiagnosticsInformation
export type GetDiagnosticsApiArg = void
export type GetDiagnosticsServiceApiResponse = /** status 200 OK */ ServiceInformation
export type GetDiagnosticsServiceApiArg = void
export type GetDiagnosticsTenantByTenantApiResponse = /** status 200 OK */ DiagnosticsInformation
export type GetDiagnosticsTenantByTenantApiArg = {
  tenant: string
}
export type PostDiagnosticsLogsByTenantNameCleanApiResponse = unknown
export type PostDiagnosticsLogsByTenantNameCleanApiArg = {
  tenantName: string
}
export type PostDiagnosticsLogsApiResponse = /** status 200 OK */ ApiLogEventSimple[]
export type PostDiagnosticsLogsApiArg = {
  apiLogRequest: ApiLogRequest
}
export type GetDiagnosticsBackupByPartIndexesdescriptionApiResponse =
  /** status 200 OK */ IndexDescription[]
export type GetDiagnosticsBackupByPartIndexesdescriptionApiArg = {
  part: string
}
export type GetDiagnosticsBackupByPartIndexesApiResponse = /** status 200 OK */ string[]
export type GetDiagnosticsBackupByPartIndexesApiArg = {
  part: string
}
export type GetDiagnosticsBackupByPartApiResponse = /** status 200 OK */ any
export type GetDiagnosticsBackupByPartApiArg = {
  part: string
}
export type PostDiagnosticsBackupByPartApiResponse = /** status 200 OK */ any
export type PostDiagnosticsBackupByPartApiArg = {
  body: string[]
  part: string
}
export type GetDiagnosticsBackupPartialByPartApiResponse = /** status 200 OK */ any
export type GetDiagnosticsBackupPartialByPartApiArg = {
  apiBackUpRequest: ApiBackUpRequest
  part: string
}
export type PostDiagnosticsRestoreByPartApiResponse = /** status 200 OK */ any
export type PostDiagnosticsRestoreByPartApiArg = {
  part: string
}
export type PostDiagnosticsRestorePartialByPartApiResponse = /** status 200 OK */ any
export type PostDiagnosticsRestorePartialByPartApiArg = {
  part: string
}
export type PostDiagnosticsRestoreByPartIndexesApiResponse = /** status 200 OK */ any
export type PostDiagnosticsRestoreByPartIndexesApiArg = {
  part: string
}
export type PostDiagnosticsDropByPartIndexesApiResponse = /** status 200 OK */ boolean
export type PostDiagnosticsDropByPartIndexesApiArg = {
  part: string
}
export type PostDiagnosticsDropByPartIndexAndIndexApiResponse = /** status 200 OK */ boolean
export type PostDiagnosticsDropByPartIndexAndIndexApiArg = {
  index: string
  part: string
}
export type PostDiagnosticsCreateindexApiResponse = /** status 200 OK */ boolean
export type PostDiagnosticsCreateindexApiArg = {
  indexDescription: IndexDescription
}
export type GetDiagnosticsCheckindexesByTenantApiResponse = /** status 200 OK */ string[]
export type GetDiagnosticsCheckindexesByTenantApiArg = {
  tenant: string
}
export type PostDiagnosticsEmailApiResponse = unknown
export type PostDiagnosticsEmailApiArg = {
  /** The email request. */
  apiEmailRequest: ApiEmailRequest
}
export type GetDiagnosticsWaitByNumberSecondsApiResponse = unknown
export type GetDiagnosticsWaitByNumberSecondsApiArg = {
  numberSeconds: number
}
export type GetDiagnosticsStopApiResponse = unknown
export type GetDiagnosticsStopApiArg = void
export type PostByTenantDistributionsAddApiResponse = unknown
export type PostByTenantDistributionsAddApiArg = {
  /** The distribution. */
  body: ApiDistributionData[]
  tenant: string
}
export type GetByTenantDistributionsAndAssetIdApiResponse =
  /** status 200 OK */ ApiDistributionData[]
export type GetByTenantDistributionsAndAssetIdApiArg = {
  /** The asset id. */
  assetId: string
  tenant: string
}
export type PostByTenantDistributionsReinvestmentsAddApiResponse = unknown
export type PostByTenantDistributionsReinvestmentsAddApiArg = {
  /** The confirmation. */
  apiNewReinvestmentConfirmation: ApiNewReinvestmentConfirmation
  tenant: string
}
export type GetByTenantDistributionsReinvestmentsAndAssetIdApiResponse =
  /** status 200 OK */ ApiReinvestmentConfirmation[]
export type GetByTenantDistributionsReinvestmentsAndAssetIdApiArg = {
  /** The asset id. */
  assetId: string
  tenant: string
}
export type GetByTenantDistributionsReinvestmentsDataAndAssetIdExDateApiResponse =
  /** status 200 OK */ ApiExpectedReinvestmentData
export type GetByTenantDistributionsReinvestmentsDataAndAssetIdExDateApiArg = {
  /** Asset identifier */
  assetId: string
  /** Ex date */
  exDate: string
  tenant: string
}
export type PutByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDateApiResponse = unknown
export type PutByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDateApiArg = {
  /** The confirmation id. */
  confirmationId: string
  exDate: string
  tenant: string
}
export type GetByTenantDistributionsAssetswithalertsApiResponse =
  /** status 200 OK */ ApiDistributionAlert[]
export type GetByTenantDistributionsAssetswithalertsApiArg = {
  tenant: string
}
export type GetByTenantDocumentationAccountAndAccountIdSummaryApiResponse =
  /** status 200 OK */ ApiAccountDocumentationInfo[]
export type GetByTenantDocumentationAccountAndAccountIdSummaryApiArg = {
  accountId: string
  tenant: string
}
export type GetByTenantDocumentationNoteAndNoteIdSummaryApiResponse =
  /** status 200 OK */ ApiAccountDocumentationInfo[]
export type GetByTenantDocumentationNoteAndNoteIdSummaryApiArg = {
  noteId: string
  tenant: string
}
export type GetByTenantDocumentationAccountAndAccountIdDocumentNumberApiResponse =
  /** status 200 OK */ StreamedResult
export type GetByTenantDocumentationAccountAndAccountIdDocumentNumberApiArg = {
  accountId: string
  documentNumber: number
  tenant: string
}
export type GetByTenantDocumentationAndFileNameApiResponse = /** status 200 OK */ StreamedResult
export type GetByTenantDocumentationAndFileNameApiArg = {
  fileName: string
  tenant: string
}
export type PostByTenantDocumentationAndFileNameApiResponse = unknown
export type PostByTenantDocumentationAndFileNameApiArg = {
  fileName: string
  tenant: string
}
export type GetEmailListByDateApiResponse = /** status 200 OK */ ApiEmailDetails[]
export type GetEmailListByDateApiArg = {
  /** The date to list emails for. */
  date: string
}
export type GetEmailByIdApiResponse = /** status 200 OK */ StreamedResult
export type GetEmailByIdApiArg = {
  /** The id of the email to retrieve. */
  id: string
}
export type GetExchangefileByTenantAndFilenameTypeApiResponse = /** status 200 OK */ any
export type GetExchangefileByTenantAndFilenameTypeApiArg = {
  filename: string
  tenant: string
  type: ExchangeFileType
}
export type PostExchangefileByTenantAndFilenameTypeDateApiResponse = unknown
export type PostExchangefileByTenantAndFilenameTypeDateApiArg = {
  date: string
  filename: string
  tenant: string
  type: ExchangeFileType
}
export type GetExchangefileLastByTenantAndTypeMaxDateInclusiveApiResponse =
  /** status 200 OK */ Blob
export type GetExchangefileLastByTenantAndTypeMaxDateInclusiveApiArg = {
  maxDateInclusive: string
  tenant: string
  type: ExchangeFileType
}
export type PostByTenantOrderCorrectionApiResponse = unknown
export type PostByTenantOrderCorrectionApiArg = {
  apiNewAggregatedOrderCorrection: ApiNewAggregatedOrderCorrection
  tenant: string
}
export type PostByTenantOrderConfirmationApiResponse = unknown
export type PostByTenantOrderConfirmationApiArg = {
  /** The order completion */
  apiNewAggregatedOrderConfirmation: ApiNewAggregatedOrderConfirmation
  tenant: string
}
export type GetByTenantOrderOutstandingAndAssetIdApiResponse =
  /** status 200 OK */ ApiOutstandingAggregatedOrder[]
export type GetByTenantOrderOutstandingAndAssetIdApiArg = {
  /** The asset identifier. */
  assetId: string
  tenant: string
}
export type GetByTenantOrderConfirmedApiResponse =
  /** status 200 OK */ ApiConfirmedAggregatedOrderApiPaginationResult
export type GetByTenantOrderConfirmedApiArg = {
  assetId?: string
  creationEndDateInclusive?: string
  creationStartDateInclusive?: string
  includeRedemptionOrders?: boolean
  includeSubscriptionOrders?: boolean
  pageNumber?: number
  pageSize?: number
  tenant: string
}
export type GetMediatRSendApiResponse = /** status 200 OK */ TestResult
export type GetMediatRSendApiArg = {
  /** The name. */
  name?: string
  /** The value. */
  value?: number
}
export type GetByTenantNomQueueAndDateDepthApiResponse = /** status 200 OK */ number
export type GetByTenantNomQueueAndDateDepthApiArg = {
  date: string
  tenant: string
}
export type PostByTenantNomOneApiResponse = unknown
export type PostByTenantNomOneApiArg = {
  tenant: string
}
export type PostByTenantNomManyApiResponse = unknown
export type PostByTenantNomManyApiArg = {
  tenant: string
}
export type PostByTenantNomInstructionApiResponse = unknown
export type PostByTenantNomInstructionApiArg = {
  body:
    | ApiNewAccountInstruction
    | ApiDepositInstruction
    | ApiPortfolioChangeInstruction
    | ApiAccountClosureInstruction
    | ApiWithdrawalInstruction
    | ApiProtectedValueChangeInstruction
    | ApiStrategyChangeInstruction
    | ApiProtectionPortfolioChangeInstruction
    | ApiAncillaryAssetsChangeInstruction
    | ApiSwitchInInstruction
    | ApiSwitchOutInstruction
    | ApiDividendInstruction
    | ApiReinvestmentConfirmationInstruction
    | ApiNoteChangeInstruction
  tenant: string
}
export type PostByTenantNoteExportApiResponse = /** status 200 OK */ Blob
export type PostByTenantNoteExportApiArg = {
  /** The note filters. */
  apiGetNoteExportFilters: ApiGetNoteExportFilters
  tenant: string
}
export type GetByTenantNoteHoldingsAndDateExportApiResponse = /** status 200 OK */ Blob
export type GetByTenantNoteHoldingsAndDateExportApiArg = {
  /** The date. */
  date: string
  tenant: string
}
export type GetByTenantNoteExportFilterApiResponse = /** status 200 OK */ Blob
export type GetByTenantNoteExportFilterApiArg = {
  counterpartyIds?: string[]
  endDateInclusive?: string
  maximumNumberResults?: number
  startDateInclusive?: string
  tenant: string
}
export type GetByTenantNoteAndNoteIdStatementLatestApiResponse = /** status 200 OK */ StreamedResult
export type GetByTenantNoteAndNoteIdStatementLatestApiArg = {
  noteId: string
  tenant: string
}
export type GetByTenantNoteAndNoteIdStatementDateApiResponse = /** status 200 OK */ StreamedResult
export type GetByTenantNoteAndNoteIdStatementDateApiArg = {
  date: string
  noteId: string
  tenant: string
}
export type GetByTenantNoteAndNoteIdStatementYearMonthApiResponse =
  /** status 200 OK */ StreamedResult
export type GetByTenantNoteAndNoteIdStatementYearMonthApiArg = {
  month: number
  noteId: string
  tenant: string
  year: number
}
export type GetByTenantNoteStatementsApiResponse = /** status 200 OK */ StreamedResult
export type GetByTenantNoteStatementsApiArg = {
  ids?: string
  tenant: string
}
export type GetByTenantNoteAndNoteIdStatementsPreviousApiResponse =
  /** status 200 OK */ StreamedResult
export type GetByTenantNoteAndNoteIdStatementsPreviousApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteDataAccountAndAccountIdNewinstructionsApiResponse =
  /** status 200 OK */ ApiNoteData
export type PostByTenantNoteDataAccountAndAccountIdNewinstructionsApiArg = {
  /** The account identifier. */
  accountId: string
  apiInstructionSet: ApiInstructionSet
  tenant: string
}
export type GetByTenantNoteInstructionValidateApiResponse = /** status 200 OK */ BasicApiResult
export type GetByTenantNoteInstructionValidateApiArg = {
  apiNoteInstructionSubmission: ApiNoteInstructionSubmission
  tenant: string
}
export type PostByTenantNoteInstructionSubmitApiResponse = /** status 200 OK */ BasicApiResult
export type PostByTenantNoteInstructionSubmitApiArg = {
  apiNoteInstructionSubmission: ApiNoteInstructionSubmission
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionRejectApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionRejectApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionApproveApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionApproveApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionApproveCommitmentApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionApproveCommitmentApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionApproveCommitmentClientApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionApproveCommitmentClientApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionApproveSettlementApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionApproveSettlementApiArg = {
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdInstructionActivateApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdInstructionActivateApiArg = {
  noteId: string
  tenant: string
}
export type GetByTenantNoteInprogressApiResponse =
  /** status 200 OK */ ApiNoteInProgressApiPaginationResult
export type GetByTenantNoteInprogressApiArg = {
  pageNumber?: number
  pageSize?: number
  tenant: string
}
export type GetByTenantNoteInprogressCountApiResponse =
  /** status 200 OK */ ApiAccountsAndNotesInProgress
export type GetByTenantNoteInprogressCountApiArg = {
  tenant: string
}
export type PostByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitIdApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitIdApiArg = {
  newBusinessUnitId: string
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyIdApiResponse =
  /** status 200 OK */ BasicApiResult
export type PostByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyIdApiArg = {
  newCounterpartyId: string
  noteId: string
  tenant: string
}
export type PostByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoanApiResponse =
  unknown
export type PostByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoanApiArg = {
  isCollateralForLoan: boolean
  noteId: string
  tenant: string
}
export type PostByTenantNoteApiResponse = /** status 200 OK */ ApiNote
export type PostByTenantNoteApiArg = {
  addNote: AddNote
  tenant: string
}
export type GetByTenantNoteApiResponse = /** status 200 OK */ ApiNote[]
export type GetByTenantNoteApiArg = {
  tenant: string
}
export type PostByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassificationApiResponse =
  /** status 200 OK */ ActionResult
export type PostByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassificationApiArg = {
  changeNoteApiTaxClassification: ChangeNoteApiTaxClassification
  newTaxClassification: string
  noteId: string
  tenant: string
}
export type GetByTenantNoteAndNoteIdCloseApiResponse = unknown
export type GetByTenantNoteAndNoteIdCloseApiArg = {
  noteId: string
  tenant: string
}
export type GetByTenantNoteBusinessunitAndIdApiResponse = /** status 200 OK */ ApiNote[]
export type GetByTenantNoteBusinessunitAndIdApiArg = {
  id: string
  tenant: string
}
export type GetByTenantNoteDataAccountAndAccountIdPendingchangesApiResponse =
  /** status 200 OK */ ApiNoteData
export type GetByTenantNoteDataAccountAndAccountIdPendingchangesApiArg = {
  accountId: string
  tenant: string
}
export type PostByTenantNoteDataAccountAndAccountIdNewinstructions2ApiResponse =
  /** status 200 OK */ ApiNoteData
export type PostByTenantNoteDataAccountAndAccountIdNewinstructions2ApiArg = {
  accountId: string
  getApiNoteDataAfterInstructions: GetApiNoteDataAfterInstructions
  tenant: string
}
export type PostByTenantNoteDataNewaccountApiResponse = /** status 200 OK */ ApiNoteData
export type PostByTenantNoteDataNewaccountApiArg = {
  getApiNoteTaxClassificationAfterNewAccount: GetApiNoteTaxClassificationAfterNewAccount
  tenant: string
}
export type PostByTenantPerformancePortfolioBacktestApiResponse =
  /** status 200 OK */ ApiBacktestResponse
export type PostByTenantPerformancePortfolioBacktestApiArg = {
  /** The API back-test request. */
  apiBacktestRequest: ApiBacktestRequest
  tenant: string
}
export type PostByTenantPerformancePortfolioProjectionApiResponse =
  /** status 200 OK */ ApiProjectionResponse
export type PostByTenantPerformancePortfolioProjectionApiArg = {
  /** The API projection request. */
  apiProjectionRequest: ApiProjectionRequest
  tenant: string
}
export type PostByTenantPerformanceTradeBacktestApiResponse =
  /** status 200 OK */ ApiTradeBacktestResponse
export type PostByTenantPerformanceTradeBacktestApiArg = {
  /** The API trade performance calculation. */
  apiTradePerformanceCalculation: ApiTradePerformanceCalculation
  tenant: string
}
export type PostByTenantPerformanceTradeProjectionApiResponse =
  /** status 200 OK */ ApiProjectionResponse
export type PostByTenantPerformanceTradeProjectionApiArg = {
  /** The API trade performance calculation. */
  apiTradePerformanceCalculation: ApiTradePerformanceCalculation
  tenant: string
}
export type PostByTenantPortfolioApiResponse = /** status 200 OK */ string
export type PostByTenantPortfolioApiArg = {
  /** The API new model portfolio. */
  apiNewPortfolio: ApiNewPortfolio
  tenant: string
}
export type PutByTenantPortfolioApiResponse = unknown
export type PutByTenantPortfolioApiArg = {
  /** The API model portfolio. */
  apiSavedPortfolio: ApiSavedPortfolio
  tenant: string
}
export type GetByTenantPortfolioApiResponse = /** status 200 OK */ ApiSavedPortfolioRead[]
export type GetByTenantPortfolioApiArg = {
  tenant: string
}
export type GetByTenantPortfolioMinimalAndBusinessUnitIdApiResponse =
  /** status 200 OK */ ApiModelPortfolioMinimal[]
export type GetByTenantPortfolioMinimalAndBusinessUnitIdApiArg = {
  /** Business unit it that should be in the model portfolio AllowedBusinessUnitIds */
  businessUnitId: string
  tenant: string
}
export type GetByTenantPortfolioListApiResponse =
  /** status 200 OK */ ApiModelPortfolioApiPaginationResultRead
export type GetByTenantPortfolioListApiArg = {
  pageNumber?: number
  pageSize?: number
  portfolioStatusFilter?: ApiPortfolioStatusFilter
  portfolioTypes?: ApiPortfolioType[]
  sortAscending?: boolean
  sortField?: string
  tenant: string
  wildcardString?: string
}
export type GetByTenantPortfolioAndModelPortfolioIdApiResponse =
  /** status 200 OK */ ApiModelPortfolioRead
export type GetByTenantPortfolioAndModelPortfolioIdApiArg = {
  /** The model portfolio identifier. */
  modelPortfolioId: string
  tenant: string
}
export type GetByTenantPortfolioAndModelPortfolioIdUsageApiResponse =
  /** status 200 OK */ ApiModelPortfolioUsage
export type GetByTenantPortfolioAndModelPortfolioIdUsageApiArg = {
  /** The model portfolio identifier. */
  modelPortfolioId: string
  tenant: string
}
export type PostByTenantPortfolioCalculatemultiplierApiResponse =
  /** status 200 OK */ ApiCalculatedPortfolioMultiplier
export type PostByTenantPortfolioCalculatemultiplierApiArg = {
  /** The portfolio. */
  body: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio
  tenant: string
}
export type PutByTenantPortfolioAndModelPortfolioIdApproveApiResponse = unknown
export type PutByTenantPortfolioAndModelPortfolioIdApproveApiArg = {
  /** The model portfolio ID to approve. */
  modelPortfolioId: string
  tenant: string
}
export type PutByTenantPortfolioAndModelPortfolioIdRejectApiResponse = unknown
export type PutByTenantPortfolioAndModelPortfolioIdRejectApiArg = {
  /** The model portfolio ID to reject. */
  modelPortfolioId: string
  tenant: string
}
export type GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetDateApiResponse =
  /** status 200 OK */ StreamedResult
export type GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetDateApiArg = {
  date: string
  portfolioId: string
  tenant: string
}
export type GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonthApiResponse =
  /** status 200 OK */ StreamedResult
export type GetByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonthApiArg = {
  month: number
  portfolioId: string
  tenant: string
  year: number
}
export type GetByTenantRiskmanagementLatestMarketdataFxApiResponse =
  /** status 200 OK */ ApiFxData[]
export type GetByTenantRiskmanagementLatestMarketdataFxApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementLatestHoldingsreconciliationApiResponse =
  /** status 200 OK */ HoldingReconciliationReport
export type GetByTenantRiskmanagementLatestHoldingsreconciliationApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementAndDateHoldingsreconciliationApiResponse =
  /** status 200 OK */ HoldingReconciliationReport
export type GetByTenantRiskmanagementAndDateHoldingsreconciliationApiArg = {
  /** Specific date */
  date: string
  tenant: string
}
export type GetByTenantRiskmanagementLatestAssetconcentrationApiResponse =
  /** status 200 OK */ AssetConcentrationReportRead
export type GetByTenantRiskmanagementLatestAssetconcentrationApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementAndDateAssetconcentrationApiResponse =
  /** status 200 OK */ AssetConcentrationReportRead
export type GetByTenantRiskmanagementAndDateAssetconcentrationApiArg = {
  /** Specific date. */
  date: string
  tenant: string
}
export type GetByTenantRiskmanagementLatestMaxdrawdownApiResponse =
  /** status 200 OK */ MaxDrawdownReport
export type GetByTenantRiskmanagementLatestMaxdrawdownApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementAndDateMaxdrawdownApiResponse =
  /** status 200 OK */ MaxDrawdownReport
export type GetByTenantRiskmanagementAndDateMaxdrawdownApiArg = {
  /** Specific date */
  date: string
  tenant: string
}
export type GetByTenantRiskmanagementAndTradeIdGapriskinfoApiResponse =
  /** status 200 OK */ ApiGapRiskInfoRead
export type GetByTenantRiskmanagementAndTradeIdGapriskinfoApiArg = {
  tenant: string
  /** Trade id */
  tradeId: string
}
export type GetByTenantRiskmanagementLatestAssetspricesApiResponse =
  /** status 200 OK */ ApiAssetPriceWithHistory[]
export type GetByTenantRiskmanagementLatestAssetspricesApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementAssetpriceoverrideinfoApiResponse =
  /** status 200 OK */ ApiOverrideInfo
export type GetByTenantRiskmanagementAssetpriceoverrideinfoApiArg = {
  tenant: string
}
export type PostByTenantRiskmanagementUploadmarketdatasetApiResponse = unknown
export type PostByTenantRiskmanagementUploadmarketdatasetApiArg = {
  /** The market data set */
  apiMarketDataSet: ApiMarketDataSet
  tenant: string
}
export type GetByTenantRiskmanagementMarketdatasetsApiResponse =
  /** status 200 OK */ ApiMarketDataSet[]
export type GetByTenantRiskmanagementMarketdatasetsApiArg = {
  apiMarketDataSetRequest: ApiMarketDataSetRequest
  tenant: string
}
export type PostByTenantRiskmanagementAssetpriceoverrideApiResponse =
  /** status 200 OK */ ApiOverridenAssetPrice
export type PostByTenantRiskmanagementAssetpriceoverrideApiArg = {
  /** The asset price override */
  apiAssetPriceUserOverride: ApiAssetPriceUserOverride
  tenant: string
}
export type GetByTenantRiskmanagementAssetConstituentsApiResponse =
  /** status 200 OK */ ApiAssetWithConstituents[]
export type GetByTenantRiskmanagementAssetConstituentsApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementExportApiResponse = /** status 200 OK */ Blob
export type GetByTenantRiskmanagementExportApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementExportHoldingsreportApiResponse = /** status 200 OK */ Blob
export type GetByTenantRiskmanagementExportHoldingsreportApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementExportStaticApiResponse = /** status 200 OK */ Blob
export type GetByTenantRiskmanagementExportStaticApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementLatestMarketdatasnapshotApiResponse =
  /** status 200 OK */ ApiMarketDataSnapshot
export type GetByTenantRiskmanagementLatestMarketdatasnapshotApiArg = {
  tenant: string
}
export type GetByTenantRiskmanagementAndDateMarketdatasnapshotApiResponse =
  /** status 200 OK */ ApiMarketDataSnapshot
export type GetByTenantRiskmanagementAndDateMarketdatasnapshotApiArg = {
  /** The date for which retrieve the market data snapshot. */
  date: string
  tenant: string
}
export type GetByTenantRiskmanagementAndDateClientgappaymentsApiResponse =
  /** status 200 OK */ ApiGapPayments[]
export type GetByTenantRiskmanagementAndDateClientgappaymentsApiArg = {
  /** The date. */
  date: string
  tenant: string
}
export type GetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationApiResponse =
  /** status 200 OK */ HoldingsAndTransferBalancesReconciliation
export type GetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationAllassetsladderApiResponse = unknown
export type PostByTenantScenariosConfigurationAllassetsladderApiArg = {
  allAssetsLadderScenarioConfiguration: AllAssetsLadderScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestAllassetsladderApiResponse =
  /** status 200 OK */ AllAssetsLadderScenarioResultRead
export type GetByTenantScenariosLatestAllassetsladderApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationSingleassetladderApiResponse = unknown
export type PostByTenantScenariosConfigurationSingleassetladderApiArg = {
  singleAssetLadderScenarioConfiguration: SingleAssetLadderScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestSingleassetladderApiResponse =
  /** status 200 OK */ SingleAssetLadderScenarioResultRead
export type GetByTenantScenariosLatestSingleassetladderApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationSingleassetdrawdownApiResponse = unknown
export type PostByTenantScenariosConfigurationSingleassetdrawdownApiArg = {
  singleAssetDrawdownScenarioConfiguration: SingleAssetDrawdownScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestSingleassetdrawdownApiResponse =
  /** status 200 OK */ SingleAssetDrawdownScenarioResultRead
export type GetByTenantScenariosLatestSingleassetdrawdownApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationFundmanagerladderApiResponse = unknown
export type PostByTenantScenariosConfigurationFundmanagerladderApiArg = {
  fundManagerLadderScenarioConfiguration: FundManagerLadderScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestFundmanagerladderApiResponse =
  /** status 200 OK */ FundManagerLadderScenarioResultRead
export type GetByTenantScenariosLatestFundmanagerladderApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationFundmanagerdrawdownApiResponse = unknown
export type PostByTenantScenariosConfigurationFundmanagerdrawdownApiArg = {
  fundManagerDrawdownScenarioConfiguration: FundManagerDrawdownScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestFundmanagerdrawdownApiResponse =
  /** status 200 OK */ FundManagerDrawdownScenarioResultRead
export type GetByTenantScenariosLatestFundmanagerdrawdownApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationCustomassetApiResponse = unknown
export type PostByTenantScenariosConfigurationCustomassetApiArg = {
  customAssetScenarioConfiguration: CustomAssetScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestCustomassetApiResponse =
  /** status 200 OK */ CustomAssetScenarioResultRead
export type GetByTenantScenariosLatestCustomassetApiArg = {
  tenant: string
}
export type PostByTenantScenariosConfigurationCustomfundmanagerApiResponse = unknown
export type PostByTenantScenariosConfigurationCustomfundmanagerApiArg = {
  customFundManagerScenarioConfiguration: CustomFundManagerScenarioConfiguration
  tenant: string
}
export type GetByTenantScenariosLatestCustomfundmanagerApiResponse =
  /** status 200 OK */ CustomFundManagerScenarioResultRead
export type GetByTenantScenariosLatestCustomfundmanagerApiArg = {
  tenant: string
}
export type PostSchedulerByTenantRunOustandingApiResponse = unknown
export type PostSchedulerByTenantRunOustandingApiArg = {
  /** The tenant to run the scheduler for. */
  tenant: string
}
export type GetSchedulerByTenantExecutionsApiResponse = /** status 200 OK */ ApiTaskExecution[]
export type GetSchedulerByTenantExecutionsApiArg = {
  /** The tenant to get the latest task executions for. */
  tenant: string
}
export type GetSchedulerByTenantRunAndTaskNameApiResponse = unknown
export type GetSchedulerByTenantRunAndTaskNameApiArg = {
  /** Name of the task. */
  taskName: string
  /** The tenant to schedule the task for. */
  tenant: string
}
export type GetSchedulerByTenantLogsAndStartSnapAsTicksIsInclusiveApiResponse =
  /** status 200 OK */ ApiTaskLog[]
export type GetSchedulerByTenantLogsAndStartSnapAsTicksIsInclusiveApiArg = {
  /** True if this is inclusive. */
  isInclusive: boolean
  /** The start snap as ticks. */
  startSnapAsTicks: number
  /** The tenant to get the task logs for. */
  tenant: string
}
export type PostSchedulerByTenantReleaselockAndLockNameProcessIdApiResponse =
  /** status 200 OK */ boolean
export type PostSchedulerByTenantReleaselockAndLockNameProcessIdApiArg = {
  /** Name of the lock to be released. */
  lockName: string
  /** The process id */
  processId: string
  /** The tenant to release the lock for. */
  tenant: string
}
export type PostSchedulerByTenantReleaselockAllApiResponse = /** status 200 OK */ number
export type PostSchedulerByTenantReleaselockAllApiArg = {
  /** The tenant to release the locks for. */
  tenant: string
}
export type PostSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAllApiResponse =
  /** status 200 OK */ number
export type PostSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAllApiArg = {
  /** The tenant to delete unsuccessful executions for. */
  tenant: string
}
export type PostSchedulerByTenantExcecutionsLastDeleteAndTaskNameApiResponse =
  /** status 200 OK */ boolean
export type PostSchedulerByTenantExcecutionsLastDeleteAndTaskNameApiArg = {
  /** The name of the task. */
  taskName: string
  /** The tenant to delete the last execution for. */
  tenant: string
}
export type PostSchedulerByTenantJobstatusesRevokeApiResponse = /** status 200 OK */ number
export type PostSchedulerByTenantJobstatusesRevokeApiArg = {
  /** The Metadata.DocumentId values of the documents to revoke */
  body: string[]
  /** The tenant to revoke the job status documents for. */
  tenant: string
}
export type PostSetupResetcollectionindexesApiResponse = unknown
export type PostSetupResetcollectionindexesApiArg = void
export type PostSetupDropcollectionindexesByTenantNameApiResponse = unknown
export type PostSetupDropcollectionindexesByTenantNameApiArg = {
  tenantName: string
}
export type PostSetupResetidentityApiResponse = unknown
export type PostSetupResetidentityApiArg = void
export type PostSetupRemovetenantByTenantNameApiResponse = unknown
export type PostSetupRemovetenantByTenantNameApiArg = {
  tenantName: string
}
export type GetSetupTenantsApiResponse = /** status 200 OK */ string[]
export type GetSetupTenantsApiArg = void
export type PostSetupCreatetenantApiResponse = unknown
export type PostSetupCreatetenantApiArg = {
  apiTenantConfiguration: ApiTenantConfiguration
}
export type PostSetupUpdatetenantApiResponse = unknown
export type PostSetupUpdatetenantApiArg = {
  apiTenantConfiguration: ApiTenantConfiguration
}
export type PostSetupUpdatetasksByTenantNameApiResponse = unknown
export type PostSetupUpdatetasksByTenantNameApiArg = {
  /** The API task configuration. */
  apiSchedulingConfiguration: ApiSchedulingConfiguration
  /** Name of the tenant. */
  tenantName: string
}
export type PostSetupInitializeallcollectionsByTenantNameApiResponse = unknown
export type PostSetupInitializeallcollectionsByTenantNameApiArg = {
  tenantName: string
}
export type GetSetupExportByTenantNameAndNameApiResponse = unknown
export type GetSetupExportByTenantNameAndNameApiArg = {
  /** The export name. */
  name: string
  /** The tenant name. */
  tenantName: string
}
export type GetSetupImportByTenantNameAndNameApiResponse = unknown
export type GetSetupImportByTenantNameAndNameApiArg = {
  /** The export name. */
  name: string
  /** The tenant name. */
  tenantName: string
}
export type PostSetupImportApiResponse = unknown
export type PostSetupImportApiArg = {
  importTenantCommand: ImportTenantCommand
}
export type GetSetupExportsApiResponse = /** status 200 OK */ string[]
export type GetSetupExportsApiArg = void
export type GetSetupExportsByNameApiResponse = /** status 200 OK */ Blob
export type GetSetupExportsByNameApiArg = {
  /** The name of the export to return. */
  name: string
}
export type PostSetupExportsByNameApiResponse = unknown
export type PostSetupExportsByNameApiArg = {
  body: {
    File?: Blob
    Overwrite?: boolean
  }
  /** The name to extract the export as. */
  name: string
}
export type DeleteSetupExportsByNameApiResponse = unknown
export type DeleteSetupExportsByNameApiArg = {
  /** The name of the export to delete. */
  name: string
}
export type GetByTenantStaticFeetypeApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticFeetypeApiArg = {
  tenant: string
}
export type GetByTenantStaticFeedeductionfrequencyApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticFeedeductionfrequencyApiArg = {
  tenant: string
}
export type GetByTenantStaticFeebasisApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticFeebasisApiArg = {
  tenant: string
}
export type GetByTenantStaticFeedaycountApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticFeedaycountApiArg = {
  tenant: string
}
export type GetByTenantStaticCashinstrumentreferenceratesApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticCashinstrumentreferenceratesApiArg = {
  tenant: string
}
export type GetByTenantStaticAssetclassesApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticAssetclassesApiArg = {
  tenant: string
}
export type GetByTenantStaticCurrenciesApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticCurrenciesApiArg = {
  tenant: string
}
export type GetByTenantStaticBusinessdatesAndFromToApiResponse = /** status 200 OK */ string[]
export type GetByTenantStaticBusinessdatesAndFromToApiArg = {
  from: string
  tenant: string
  to: string
}
export type GetStatusOnlineApiResponse = /** status 200 OK */ boolean
export type GetStatusOnlineApiArg = void
export type GetStatusAccessAdministratorApiResponse = /** status 200 OK */ boolean
export type GetStatusAccessAdministratorApiArg = void
export type GetStatusAccessBusinessUnitUserApiResponse = /** status 200 OK */ boolean
export type GetStatusAccessBusinessUnitUserApiArg = void
export type GetStatusAccessServertoserverApiResponse = /** status 200 OK */ boolean
export type GetStatusAccessServertoserverApiArg = void
export type GetStatusAccessUserApiResponse = /** status 200 OK */ string
export type GetStatusAccessUserApiArg = void
export type PostByTenantStrategyApiResponse = /** status 200 OK */ string
export type PostByTenantStrategyApiArg = {
  /** The API new strategy template. */
  apiNewStrategyTemplate: ApiNewStrategyTemplate
  tenant: string
}
export type PutByTenantStrategyApiResponse = /** status 200 OK */ string
export type PutByTenantStrategyApiArg = {
  /** The API strategy template. */
  apiStrategyTemplate: ApiStrategyTemplate
  tenant: string
}
export type GetByTenantStrategyApiResponse = /** status 200 OK */ ApiStrategyTemplate[]
export type GetByTenantStrategyApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeApiResponse = /** status 200 OK */ TradeConfiguration
export type GetByTenantConfigurationTradeApiArg = {
  tenant: string
}
export type GetByTenantConfigurationSchedulingApiResponse =
  /** status 200 OK */ SchedulingConfiguration
export type GetByTenantConfigurationSchedulingApiArg = {
  tenant: string
}
export type GetByTenantConfigurationUiApiResponse = /** status 200 OK */ TradeConfiguration
export type GetByTenantConfigurationUiApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeValuationcycleoverrideApiResponse =
  /** status 200 OK */ string
export type GetByTenantConfigurationTradeValuationcycleoverrideApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeValuationsnapCurrentApiResponse =
  /** status 200 OK */ string
export type GetByTenantConfigurationTradeValuationsnapCurrentApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeValuationcycleCurrentApiResponse =
  /** status 200 OK */ string
export type GetByTenantConfigurationTradeValuationcycleCurrentApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeValuationcyclePreviousApiResponse =
  /** status 200 OK */ string
export type GetByTenantConfigurationTradeValuationcyclePreviousApiArg = {
  tenant: string
}
export type PostByTenantConfigurationTradeValuationsnapandcycleoverrideUnsetApiResponse =
  /** status 200 OK */ ApiTradeConfiguration
export type PostByTenantConfigurationTradeValuationsnapandcycleoverrideUnsetApiArg = {
  tenant: string
}
export type GetByTenantConfigurationTradeValuationsnapoverrideApiResponse =
  /** status 200 OK */ string
export type GetByTenantConfigurationTradeValuationsnapoverrideApiArg = {
  tenant: string
}
export type PostByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnapApiResponse =
  /** status 200 OK */ ApiTimeOverrideStatus
export type PostByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnapApiArg = {
  tenant: string
  valuationSnap: string
}
export type PostByTenantConfigurationTradeEnableApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationTradeEnableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationTradeDisableApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationTradeDisableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationGraphEnableApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationGraphEnableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationGraphDisableApiResponse =
  /** status 200 OK */ SchedulingConfiguration
export type PostByTenantConfigurationGraphDisableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationCleanupEnableApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationCleanupEnableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationCleanupDisableApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationCleanupDisableApiArg = {
  tenant: string
}
export type GetByTenantConfigurationReconciliationApiResponse =
  /** status 200 OK */ ReconciliationConfiguration
export type GetByTenantConfigurationReconciliationApiArg = {
  tenant: string
}
export type PostByTenantConfigurationReconciliationUpdateApiResponse =
  /** status 200 OK */ ReconciliationConfiguration
export type PostByTenantConfigurationReconciliationUpdateApiArg = {
  apiReconciliationConfiguration: ApiReconciliationConfiguration
  tenant: string
}
export type PostByTenantConfigurationFinswitchIsocurrencycodesEnableApiResponse =
  /** status 200 OK */ boolean
export type PostByTenantConfigurationFinswitchIsocurrencycodesEnableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationFinswitchIsocurrencycodesDisableApiResponse =
  /** status 200 OK */ boolean
export type PostByTenantConfigurationFinswitchIsocurrencycodesDisableApiArg = {
  tenant: string
}
export type PostByTenantConfigurationTradeNoteDefaultsApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationTradeNoteDefaultsApiArg = {
  counterPartyIds?: string[]
  tenant: string
}
export type PostByTenantConfigurationTradeAssetDefaultsApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationTradeAssetDefaultsApiArg = {
  assetClasses?: string[]
  currencies?: string[]
  fees?: ApiFee[]
  tenant: string
}
export type PostByTenantConfigurationTradeIdentifierConfigurationApiResponse =
  /** status 200 OK */ TradeConfiguration
export type PostByTenantConfigurationTradeIdentifierConfigurationApiArg = {
  'AccountSettings.IdPaddingLength'?: number
  'AccountSettings.IdPrefix'?: string
  'AccountSettings.LastUpdateTime'?: string
  'AccountSettings.NextId'?: number
  'NoteSettings.IdPaddingLength'?: number
  'NoteSettings.IdPrefix'?: string
  'NoteSettings.LastUpdateTime'?: string
  'NoteSettings.NextId'?: number
  'PortfolioSettings.IdPaddingLength'?: number
  'PortfolioSettings.IdPrefix'?: string
  'PortfolioSettings.LastUpdateTime'?: string
  'PortfolioSettings.NextId'?: number
  tenant: string
}
export type GetTwoFactorApiResponse = /** status 200 OK */ ApiAccountUserDetails
export type GetTwoFactorApiArg = void
export type GetTwoFactorSetupApiResponse = /** status 200 OK */ ApiAuthenticatorDetails
export type GetTwoFactorSetupApiArg = void
export type PostTwoFactorResetApiResponse = /** status 200 OK */ ApiResult
export type PostTwoFactorResetApiArg = {
  apiResetAuthenticator: ApiResetAuthenticator
}
export type PostTwoFactorRecoveryCodesApiResponse = /** status 200 OK */ ApiResult
export type PostTwoFactorRecoveryCodesApiArg = void
export type PostTwoFactorVerifyApiResponse = /** status 200 OK */ ApiResult
export type PostTwoFactorVerifyApiArg = {
  /** The verify authenticator model. */
  apiVerifyAuthenticator: ApiVerifyAuthenticator
}
export type PostTwoFactorLoginApiResponse = /** status 200 OK */ ApiResult
export type PostTwoFactorLoginApiArg = {
  /** The 2FA login user model. */
  apiTwoFactorLoginUser: ApiTwoFactorLoginUser
  /** Set to true to remember this machine. */
  rememberMachine?: boolean
}
export type PostTwoFactorEnableApiResponse = /** status 200 OK */ ApiResult
export type PostTwoFactorEnableApiArg = {
  apiSetTwoFactorEnabled: ApiSetTwoFactorEnabled
}
export type GetUsermanagerApiResponse = /** status 200 OK */ UserInformation[]
export type GetUsermanagerApiArg = void
export type PutUsermanagerApiResponse = unknown
export type PutUsermanagerApiArg = {
  apiEditUser: ApiEditUser
}
export type GetUsermanagerBankAllApiResponse = /** status 200 OK */ UserInformationBasic[]
export type GetUsermanagerBankAllApiArg = void
export type GetUsermanagerClientAllApiResponse = /** status 200 OK */ UserInformationBasic[]
export type GetUsermanagerClientAllApiArg = void
export type GetUsermanagerGetbyidByUserIdApiResponse = /** status 200 OK */ UserInformation
export type GetUsermanagerGetbyidByUserIdApiArg = {
  /** The user id. */
  userId: string
}
export type GetUsermanagerRolesApiResponse = /** status 200 OK */ string[]
export type GetUsermanagerRolesApiArg = void
export type GetUsermanagerRolesAllApiResponse = /** status 200 OK */ string[]
export type GetUsermanagerRolesAllApiArg = void
export type GetUsermanagerRolesBankAllApiResponse = /** status 200 OK */ string[]
export type GetUsermanagerRolesBankAllApiArg = void
export type GetUsermanagerRolesClientAllApiResponse = /** status 200 OK */ string[]
export type GetUsermanagerRolesClientAllApiArg = void
export type GetUsermanagerCurrentApiResponse = /** status 200 OK */ UserInformation
export type GetUsermanagerCurrentApiArg = void
export type PostUsermanagerCreateApiResponse = unknown
export type PostUsermanagerCreateApiArg = {
  newUserCommand: NewUserCommand
}
export type PostUsermanagerConfirmEmailApiResponse = /** status 200 OK */ ApiConfirmEmailResult
export type PostUsermanagerConfirmEmailApiArg = {
  /** The confirm-email model. */
  apiConfirmEmail: ApiConfirmEmail
}
export type PostUsermanagerOnboardApiResponse = /** status 200 OK */ ApiAuthenticatorDetails
export type PostUsermanagerOnboardApiArg = {
  /** The onboarding details. */
  apiOnboardingDetails: ApiOnboardingDetails
}
export type GetUsermanagerRecaptchaDisabledApiResponse =
  /** status 200 OK */ ApiRecaptchaConfiguration
export type GetUsermanagerRecaptchaDisabledApiArg = void
export type PostUsermanagerForgotPasswordApiResponse = unknown
export type PostUsermanagerForgotPasswordApiArg = {
  /** The forgotten password model. */
  apiForgotPassword: ApiForgotPassword
}
export type PostUsermanagerResetApiResponse = unknown
export type PostUsermanagerResetApiArg = {
  resetPasswordCommand: ResetPasswordCommand
}
export type PostUsermanagerChangepwdApiResponse = unknown
export type PostUsermanagerChangepwdApiArg = {
  changePasswordCommand: ChangePasswordCommand
}
export type PostUsermanagerAddtoroleApiResponse = unknown
export type PostUsermanagerAddtoroleApiArg = {
  addUserRoleCommand: AddUserRoleCommand
}
export type PostUsermanagerRemovefromroleApiResponse = unknown
export type PostUsermanagerRemovefromroleApiArg = {
  removeUserFromRoleCommand: RemoveUserFromRoleCommand
}
export type DeleteUsermanagerRemoveByUsernameApiResponse = unknown
export type DeleteUsermanagerRemoveByUsernameApiArg = {
  username: string
}
export type GetUsermanagerUnlockByUsernameApiResponse = unknown
export type GetUsermanagerUnlockByUsernameApiArg = {
  username: string
}
export type GetUsermanagerEnabledisablelockoutByUsernameAndIsEnabledApiResponse = unknown
export type GetUsermanagerEnabledisablelockoutByUsernameAndIsEnabledApiArg = {
  isEnabled: boolean
  username: string
}
export type PostUsermanagerDeactivateByUsernameApiResponse = unknown
export type PostUsermanagerDeactivateByUsernameApiArg = {
  username: string
}
export type PostUsermanagerActivateByUsernameApiResponse = unknown
export type PostUsermanagerActivateByUsernameApiArg = {
  username: string
}
export type GetUsermanagerExportApiResponse = /** status 200 OK */ Blob
export type GetUsermanagerExportApiArg = void
export type GetUsermanagerExportBankApiResponse = /** status 200 OK */ Blob
export type GetUsermanagerExportBankApiArg = void
export type GetUsermanagerExportClientApiResponse = /** status 200 OK */ Blob
export type GetUsermanagerExportClientApiArg = void
export type GetUsermanagerExportClientByCliendIdApiResponse = /** status 200 OK */ Blob
export type GetUsermanagerExportClientByCliendIdApiArg = {
  cliendId: string
  /** Client Id */
  clientId?: string
}
export type GetUsermanagerExportBusinessunitByBusinessUnitIdApiResponse = /** status 200 OK */ Blob
export type GetUsermanagerExportBusinessunitByBusinessUnitIdApiArg = {
  /** Business Unit Id */
  businessUnitId: string
}
export type PostUsermanagerUsernameGenerateApiResponse = /** status 200 OK */ GetUserNameResponse
export type PostUsermanagerUsernameGenerateApiArg = {
  /** The get user name command. */
  getUserNameCommand: GetUserNameCommand
}
export type GetIndexStatusApiResponse = /** status 200 OK */ ValuationIndexStatus
export type GetIndexStatusApiArg = {
  date: string
  tenant: string
}
export type RestoreObsoleteBlockChainApiResponse = unknown
export type RestoreObsoleteBlockChainApiArg = {
  /** Base 58 encoded address with checksum. */
  base58StateRootAddress: string
  tenant: string
}
export type GetReportingStatusApiResponse = /** status 200 OK */ ValuationReportingStatus
export type GetReportingStatusApiArg = {
  date: string
  reportType: string
  tenant: string
}
export type ApiAccountStatus =
  | 'Draft'
  | 'Rejected'
  | 'Expired'
  | 'PendingEconomicsApproval'
  | 'PendingApproval'
  | 'PendingCommitment'
  | 'PendingClientCommitment'
  | 'PendingSettlement'
  | 'PendingActivation'
  | 'PendingClosure'
  | 'Activating'
  | 'Active'
  | 'Inactive'
  | 'Deleted'
export type ApiPortfolioType = 'None' | 'ModelPortfolio' | 'SelfSelect' | 'FundOfFunds'
export type ApiRebalancingType = 'None' | 'Frequency' | 'Weight' | 'CalendarFrequency'
export type ApiRebalancingFrequency = 'None' | 'Monthly' | 'Quarterly' | 'SemiAnnually' | 'Annually'
export type ApiRebalancingDefinition = {
  frequency?: ApiRebalancingFrequency
  type: ApiRebalancingType
  weightsTolerance?: number | null
}
export type ApiAssetType = 'MutualFund' | 'SegregatedPortfolio'
export type ApiAssetDealingFrequency = 'Monthly' | 'Daily' | 'Hourly'
export type ApiAssetDealingState = 'Active' | 'SoftClosed' | 'HardClosed'
export type ApiAssetProtectionClassification = 'Performance' | 'Protection'
export type ApiDealingPeriodExpectation = {
  confirmationRedemption: string
  confirmationSubscription: string
  executionRedemption: string
  executionSubscription: string
  navPublication: string
  settlementRedemption: number
  settlementSubscription: number
}
export type ApiHolidayCalendarAssumptions = 'None' | 'Weekends'
export type ApiDealingHolidayCalendar = {
  assumptions: ApiHolidayCalendarAssumptions
  dealingPeriodExpectation: ApiDealingPeriodExpectation
  endDate: string
  holidays: string[]
  startDate: string
}
export type ApiMultiplierType = 'Variable' | 'Fixed'
export type ApiMultiplierConfigurationBase = {
  longLambda: number
  multiplierType: ApiMultiplierType
  shortLambda: number
}
export type ApiFixedMultiplier = {
  multiplierType: 'Fixed'
} & ApiMultiplierConfigurationBase & {
    multiplier: number
    multiplierType: ApiMultiplierType
  }
export type ApiVariableMultiplier = {
  multiplierType: 'Variable'
} & ApiMultiplierConfigurationBase & {
    longTermVolatilityWindow: number
    multiplierType: ApiMultiplierType
    reducedMultiplier: number
    shortTermVolatilityWindow: number
    standardMultiplier: number
    volatilityTrigger: number
  }
export type ApiTaxClassification = 'Yield' | 'Capital'
export type ApiFeeType =
  | 'GapProtectionPremium'
  | 'LoanFee'
  | 'DistributionFee'
  | 'StrategyFee'
  | 'PlatformFee'
  | 'PortfolioManagementFee'
  | 'NoteFee'
  | 'ExitFee'
  | 'TransactionFee'
  | 'Delta1PremiumFee'
  | 'RiskControlledPremiumFee'
  | 'HedgingPremiumFee'
  | 'OngoingPremium'
  | 'LifeCompanyFee'
  | 'AdviceFee'
  | 'DiscretionaryFundManagementFee'
  | 'StrategyAdviceFee'
export type ApiFeeDeductionFrequency =
  | 'None'
  | 'Quarterly'
  | 'Monthly'
  | 'Annually'
  | 'UpFront'
  | 'Exit'
export type ApiFeeBasis = 'TotalTradeValue' | 'RiskyAssetExposure' | 'LoanAmount'
export type ApiFeeDayCount = 'Act_365' | 'Act_Act' | 'Act_360' | 'Thirty_360' | 'Thirty_365'
export type ApiFee = {
  counterPartyId: string
  feeBasis: ApiFeeBasis
  feeDayCount: ApiFeeDayCount
  feeDeductionFrequency: ApiFeeDeductionFrequency
  feeId: string
  feeRate: number
  feeType: ApiFeeType
  isVATApplicable: boolean
}
export type ApiTradingStatus = 'Open' | 'SubscriptionOnly' | 'RedemptionOnly' | 'Closed'
export type ApiMarketDataProviderType = 'FinSwitch' | 'Absa' | 'Dominion' | 'AlphaVantage' | 'None'
export type ApiExDate = {
  date: string
  provider: ApiMarketDataProviderType
}
export type ApiSource = 'Absa' | 'Dominion'
export type ApiAssetBase = {
  assetClass: string
  assetId: string
  assetRebalancingStatus?: ApiTradingStatus
  assetTradeStatus?: ApiTradingStatus
  currencyIso: string
  cutoffTimeHours: number
  cutoffTimeMinutes: number
  dealingCalendar: ApiDealingHolidayCalendar
  dealingFrequency?: ApiAssetDealingFrequency
  dealingState?: ApiAssetDealingState
  disallowedStrategies: string[]
  exDates?: ApiExDate[] | null
  fees?: ApiFee[] | null
  isDeleted?: boolean
  isExternal?: boolean
  isMarketDataReady: boolean
  marketDataProvider?: string | null
  maxLeverageRatio?: number | null
  multiplier?: (ApiFixedMultiplier | ApiVariableMultiplier) | null
  name: string
  noticePeriodDays: number
  priceScalingFactor: number
  protectionClassification: ApiAssetProtectionClassification
  sharePrecisionScale: number
  source?: ApiSource
  targetVolatility?: number | null
  taxClassification: ApiTaxClassification
  tradingProvider?: string | null
  type: ApiAssetType
}
export type ApiAssetBaseRead = {
  assetClass: string
  assetId: string
  assetRebalancingStatus?: ApiTradingStatus
  assetTradeStatus?: ApiTradingStatus
  currencyIso: string
  cutoffTimeHours: number
  cutoffTimeMinutes: number
  dealingCalendar: ApiDealingHolidayCalendar
  dealingFrequency?: ApiAssetDealingFrequency
  dealingState?: ApiAssetDealingState
  disallowedStrategies: string[]
  exDates?: ApiExDate[] | null
  fees?: ApiFee[] | null
  isDeleted?: boolean
  isExternal?: boolean
  isMarketDataReady: boolean
  isinCode: string
  marketDataProvider?: string | null
  maxLeverageRatio?: number | null
  multiplier?: (ApiFixedMultiplier | ApiVariableMultiplier) | null
  name: string
  noticePeriodDays: number
  priceScalingFactor: number
  protectionClassification: ApiAssetProtectionClassification
  sharePrecisionScale: number
  source?: ApiSource
  targetVolatility?: number | null
  taxClassification: ApiTaxClassification
  tradingProvider?: string | null
  type: ApiAssetType
}
export type ApiFundExternalIdentifiers = {
  accountNumber?: string | null
  fundCode?: string | null
  fundManagerCounterpartyId?: string | null
  managementCompanyCode?: string | null
  productCode?: string | null
}
export type ApiMutualFundAsset = {
  type: 'MutualFund'
} & ApiAssetBase & {
    externalIdentifiers?: ApiFundExternalIdentifiers
    fundManager?: string | null
    type: ApiAssetType
  }
export type ApiMutualFundAssetRead = {
  type: 'MutualFund'
} & ApiAssetBaseRead & {
    externalIdentifiers?: ApiFundExternalIdentifiers
    fundManager?: string | null
    type: ApiAssetType
  }
export type ApiSegregatedPortfolioAsset = {
  type: 'SegregatedPortfolio'
} & ApiAssetBase & {
    clientId: string
    startDate: string
    type: ApiAssetType
  }
export type ApiSegregatedPortfolioAssetRead = {
  type: 'SegregatedPortfolio'
} & ApiAssetBaseRead & {
    clientId: string
    startDate: string
    type: ApiAssetType
  }
export type ApiAssetWeight = {
  asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset
  weight: number
}
export type ApiAssetWeightRead = {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  weight: number
}
export type PortfolioAuditEventType = 'NewSubmission' | 'EditSubmission' | 'Approval' | 'Rejection'
export type ApiPortfolioStatus =
  | 'Active'
  | 'PendingApprovalNew'
  | 'PendingApprovalEdit'
  | 'RejectedNew'
  | 'RejectedEdit'
export type ApiSavedPortfolio = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  fees?: ApiFee[] | null
  multiplier?: number | null
  pendingChange?: ApiPortfolioAuditEvent
  portfolioId: string
  portfolioName?: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  status?: ApiPortfolioStatus
  targetWeights: ApiAssetWeight[]
  taxClassification?: ApiTaxClassification
  type: ApiPortfolioType
}
export type ApiSavedPortfolioRead = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  fees?: ApiFee[] | null
  multiplier?: number | null
  pendingChange?: ApiPortfolioAuditEvent
  portfolioId: string
  portfolioName?: string | null
  rebalancingDefinition: ApiRebalancingDefinition
  status?: ApiPortfolioStatus
  targetWeights: ApiAssetWeightRead[]
  taxClassification?: ApiTaxClassification
  type: ApiPortfolioType
}
export type ApiPortfolioAuditEvent = {
  auditedPortfolioData?: ApiSavedPortfolio
  eventDate?: string
  eventType?: PortfolioAuditEventType
  userName?: string | null
}
export type ApiPortfolioAuditEventRead = {
  auditedPortfolioData?: ApiSavedPortfolioRead
  eventDate?: string
  eventType?: PortfolioAuditEventType
  userName?: string | null
}
export type ApiPortfolioBase = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  fees?: ApiFee[] | null
  multiplier?: number | null
  pendingChange?: ApiPortfolioAuditEvent
  rebalancingDefinition: ApiRebalancingDefinition
  targetWeights: ApiAssetWeight[]
  taxClassification?: ApiTaxClassification
  type: ApiPortfolioType
}
export type ApiPortfolioBaseRead = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  fees?: ApiFee[] | null
  multiplier?: number | null
  pendingChange?: ApiPortfolioAuditEventRead
  rebalancingDefinition: ApiRebalancingDefinition
  targetWeights: ApiAssetWeightRead[]
  taxClassification?: ApiTaxClassification
  type: ApiPortfolioType
}
export type ApiModelPortfolio = {
  type: 'ModelPortfolio'
} & ApiPortfolioBase & {
    portfolioOwnerId?: string | null
    type: ApiPortfolioType
  }
export type ApiModelPortfolioRead = {
  type: 'ModelPortfolio'
} & ApiPortfolioBaseRead & {
    portfolioOwnerId?: string | null
    type: ApiPortfolioType
  }
export type ApiPortfolioInvestment = {
  assetId: string
  weight: number
}
export type ApiFundOfFundsPortfolio = {
  type: 'FundOfFunds'
} & ApiPortfolioBase & {
    investmentWeights?: ApiPortfolioInvestment[] | null
    portfolioOwnerId?: string | null
    startDate?: string | null
    type: ApiPortfolioType
  }
export type ApiFundOfFundsPortfolioRead = {
  type: 'FundOfFunds'
} & ApiPortfolioBaseRead & {
    investmentWeights?: ApiPortfolioInvestment[] | null
    portfolioOwnerId?: string | null
    startDate?: string | null
    type: ApiPortfolioType
  }
export type ApiSelfSelectPortfolio = {
  type: 'SelfSelect'
} & ApiPortfolioBase & {
    type: ApiPortfolioType
  }
export type ApiSelfSelectPortfolioRead = {
  type: 'SelfSelect'
} & ApiPortfolioBaseRead & {
    type: ApiPortfolioType
  }
export type ApiStrategyType = 'PassThrough' | 'TIPP' | 'CPPI' | 'VolControl'
export type ApiStrategyBase = {
  fees?: ApiFee[] | null
  leverageRatio?: number | null
  type: ApiStrategyType
}
export type ApiPassThroughStrategy = {
  type: 'PassThrough'
} & ApiStrategyBase & {
    shortCircuitMaxAllocation?: number | null
    type: ApiStrategyType
    volatilityIndexTriggerLevel?: number | null
  }
export type ApiObservationFrequency =
  | 'None'
  | 'Daily'
  | 'Weekly'
  | 'Monthly'
  | 'Quarterly'
  | 'SemiAnnually'
  | 'Annually'
export type ApiCppiStrategy = {
  type: 'CPPI'
} & ApiStrategyBase & {
    hasBankGuarantee: boolean
    highWatermarkObservationFrequency: ApiObservationFrequency
    maturityDate?: string
    protectionPercentage?: number | null
    shortCircuitMaxAllocation?: number | null
    shortCircuitReducedMultiplier?: number | null
    targetVolatility?: number | null
    type: ApiStrategyType
    volatilityIndexTriggerLevel?: number | null
  }
export type ApiTippStrategy = {
  type: 'TIPP'
} & ApiStrategyBase & {
    hasBankGuarantee: boolean
    highWatermarkObservationFrequency: ApiObservationFrequency
    protectionPercentage?: number | null
    shortCircuitMaxAllocation?: number | null
    shortCircuitReducedMultiplier?: number | null
    targetVolatility?: number | null
    type: ApiStrategyType
    volatilityIndexTriggerLevel?: number | null
  }
export type ApiVolControlStrategy = {
  type: 'VolControl'
} & ApiStrategyBase & {
    shortCircuitMaxAllocation?: number | null
    targetVolatility?: number | null
    type: ApiStrategyType
    volatilityIndexTriggerLevel?: number | null
  }
export type ApiAccountState = {
  accountName: string
  businessUnitId?: string | null
  clientId?: string | null
  depositId?: string | null
  investment?: number
  loanId?: string | null
  noteId?: string | null
  portfolio?: (ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio) | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  zcbInstrumentId?: string | null
}
export type ApiAccountStateRead = {
  accountName: string
  businessUnitId?: string | null
  clientId?: string | null
  depositId?: string | null
  investment?: number
  loanId?: string | null
  noteId?: string | null
  portfolio?:
    | (ApiModelPortfolioRead | ApiFundOfFundsPortfolioRead | ApiSelfSelectPortfolioRead)
    | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  zcbInstrumentId?: string | null
}
export type ApiTransferOfUnits = {
  assetId?: string | null
  originalPurchasePrice?: number | null
  units?: number
}
export type ApiAccountSwitchRequest = {
  isFullSwitch: boolean
  isProcessed?: boolean | null
  originatingAccountId: string
  switchAmount?: number | null
}
export type ApiDividendProcessing = 'Reinvested' | 'Paid'
export type ApiAccountRunningStatus = 'New' | 'Running' | 'Suspended' | 'Closing' | 'Closed'
export type ApiAssociatedAccount = {
  accountId: string
  accountName: string
  accountReturn: number
  accountSource: string
  accountStatus: ApiAccountRunningStatus
  accountValue: number
  capitalPercentage: number
  netContributions: number
  yieldPercentage: number
}
export type ApiNote = {
  associatedTrades?: ApiAssociatedAccount[] | null
  businessUnitId: string
  counterPartyId: string
  dividendProcessing: ApiDividendProcessing
  endDate?: string | null
  fees?: ApiFee[] | null
  isCollateralForLoan?: boolean
  isExternal: boolean
  noteId: string
  noteName: string
  startDate: string
  taxClassification?: ApiTaxClassification
  topupNumber?: number | null
}
export type ApiCompetencyType = 'Entry' | 'Experienced' | 'Expert'
export type ApiBusinessUnit = {
  businessUnitId: string
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
}
export type ApiClientType = 'Institutional' | 'Retail'
export type ApiReinvestmentType = 'ReinvestOnly' | 'ReinvestAndDividend'
export type ApiClientStrategyFeeCriteria = {
  fees: ApiFee[]
  hasBankGuarantee?: boolean
  isLeveraged?: boolean
  strategyTemplateId: string
}
export type ApiClientDefaultFees = {
  defaultNoteFees?: ApiFee[] | null
  defaultPortfolioFees?: ApiFee[] | null
  defaultStrategyFees?: ApiClientStrategyFeeCriteria[] | null
}
export type ApiClientDefaultCashInstruments = {
  depositId: string
  loanId: string
}
export type ApiClientTradeBuildingSettings = {
  defaultNoteCounterpartyId?: string | null
  minimumAdditionalTradeSize: number
  minimumNoteSize: number
  minimumTopUpSize: number
  minimumWithdrawalSize: number
}
export type ApiClient = {
  businessUnits: ApiBusinessUnit[]
  clientId: string
  clientName: string
  clientType: ApiClientType
  defaultCashInstruments: ApiClientDefaultCashInstruments
  defaultFees?: ApiClientDefaultFees
  disallowedStrategies?: string[] | null
  isExternal: boolean
  reinvestmentType: ApiReinvestmentType
  tradeBuildingSettings: ApiClientTradeBuildingSettings
}
export type ApiAccountBuilderState = {
  accountName?: string | null
  businessUnit?: ApiBusinessUnit
  client?: ApiClient
  closeAccount?: boolean
  deposit?: number | null
  depositId?: string | null
  lastModified?: string | null
  loanId?: string | null
  note?: ApiNote
  noteOverrideFees?: ApiFee[] | null
  portfolio?: (ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio) | null
  portfolioOverrideFees?: ApiFee[] | null
  protectedValue?: number | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyOverrideFees?: ApiFee[] | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  updateDoesNotRequireFullApproval?: boolean
  withdrawal?: number | null
  zcbInstrumentId?: string | null
}
export type ApiAccountBuilderStateRead = {
  accountName?: string | null
  businessUnit?: ApiBusinessUnit
  client?: ApiClient
  closeAccount?: boolean
  deposit?: number | null
  depositId?: string | null
  lastModified?: string | null
  loanId?: string | null
  note?: ApiNote
  noteOverrideFees?: ApiFee[] | null
  portfolio?:
    | (ApiModelPortfolioRead | ApiFundOfFundsPortfolioRead | ApiSelfSelectPortfolioRead)
    | null
  portfolioOverrideFees?: ApiFee[] | null
  protectedValue?: number | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyOverrideFees?: ApiFee[] | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  updateDoesNotRequireFullApproval?: boolean
  withdrawal?: number | null
  zcbInstrumentId?: string | null
}
export type ApiAccountApprovalEvent = {
  comments?: string | null
  firstName?: string | null
  lastName?: string | null
  organisation?: string | null
  statusAfter?: ApiAccountStatus
  statusBefore?: ApiAccountStatus
  time?: string
  userId?: string | null
}
export type ApiAccountApprovalState = {
  approvalEvents?: ApiAccountApprovalEvent[] | null
}
export type ApiTradeDocumentation = {
  displayName?: string | null
  fileName?: string | null
  relativeUrl?: string | null
  size?: number | null
}
export type ApiTradingAccount = {
  accountId: string
  accountName: string
  approvalState?: ApiAccountApprovalState
  businessUnit: ApiBusinessUnit
  canBeRejectedByUser: boolean
  client: ApiClient
  currency?: string | null
  currentAccountState?: ApiAccountState
  dateActionIsRequiredBy?: string | null
  dateOpened?: string | null
  hasInProgressOperations: boolean
  isActionRequiredByCurrentUser: boolean
  isLockedForUpdates: boolean
  newAccount?: boolean
  note: ApiNote
  pendingAccountState?: ApiAccountBuilderState
  requestedStartDate?: string | null
  status: ApiAccountStatus
  tradeDocumentation?: ApiTradeDocumentation[] | null
  version: number
}
export type ApiTradingAccountRead = {
  accountId: string
  accountName: string
  approvalState?: ApiAccountApprovalState
  businessUnit: ApiBusinessUnit
  canBeRejectedByUser: boolean
  client: ApiClient
  currency?: string | null
  currentAccountState?: ApiAccountStateRead
  dateActionIsRequiredBy?: string | null
  dateOpened?: string | null
  hasInProgressOperations: boolean
  isActionRequiredByCurrentUser: boolean
  isLockedForUpdates: boolean
  newAccount?: boolean
  note: ApiNote
  pendingAccountState?: ApiAccountBuilderStateRead
  requestedStartDate?: string | null
  status: ApiAccountStatus
  tradeDocumentation?: ApiTradeDocumentation[] | null
  version: number
}
export type ApiSaveNewAccountActionResult = {
  newAccountId?: string | null
  success?: boolean
  updatedAccount?: ApiTradingAccount
  validationErrors?: string[] | null
}
export type ApiSaveNewAccountActionResultRead = {
  newAccountId?: string | null
  success?: boolean
  updatedAccount?: ApiTradingAccountRead
  validationErrors?: string[] | null
}
export type ApiUnapprovedAccount = {
  accountId?: string | null
  accountName: string
  depositId?: string | null
  investment?: number | null
  loanId?: string | null
  noteId: string
  portfolioId?: string | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  requestedStartDate?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  version?: number | null
  zcbInstrumentId?: string | null
}
export type ApiUnapprovedAccountRead = {
  accountId?: string | null
  accountName: string
  depositId?: string | null
  investment?: number | null
  loanId?: string | null
  noteId: string
  portfolioId?: string | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  requestedStartDate?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolioRead
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  version?: number | null
  zcbInstrumentId?: string | null
}
export type ApiUpdateAccountActionResult = {
  success?: boolean
  updatedAccount?: ApiTradingAccount
  validationErrors?: string[] | null
}
export type ApiUpdateAccountActionResultRead = {
  success?: boolean
  updatedAccount?: ApiTradingAccountRead
  validationErrors?: string[] | null
}
export type ApiInstructionType =
  | 'Unknown'
  | 'NewAccount'
  | 'Deposit'
  | 'Dividend'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'ExternalTransfer'
  | 'StrategyChange'
  | 'PortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionReset'
  | 'ProtectionPortfolioChange'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'ReinvestmentConfirmation'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'OrderCorrection'
export type ApiInstructionBase = {
  accountId: string
  type: ApiInstructionType
  valuationCycle: string
}
export type ApiSwitchOutInstruction = {
  type: 'SwitchOut'
} & ApiInstructionBase & {
    isFullSwitch: boolean
    switchAmount?: number | null
    targetAccountId: string
    type: ApiInstructionType
  }
export type ApiUnapprovedAccountUpdate = {
  accountId?: string | null
  accountName?: string | null
  depositId?: string | null
  depositValue?: number | null
  loanId?: string | null
  noteId?: string | null
  portfolioId?: string | null
  protectedValue?: number | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchOut?: ApiSwitchOutInstruction
  switchRequest?: ApiAccountSwitchRequest
  version?: number | null
  withdrawalValue?: number | null
  zcbInstrumentId?: string | null
}
export type ApiUnapprovedAccountUpdateRead = {
  accountId?: string | null
  accountName?: string | null
  depositId?: string | null
  depositValue?: number | null
  loanId?: string | null
  noteId?: string | null
  portfolioId?: string | null
  protectedValue?: number | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  selfSelectPortfolio?: ApiSelfSelectPortfolioRead
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchOut?: ApiSwitchOutInstruction
  switchRequest?: ApiAccountSwitchRequest
  version?: number | null
  withdrawalValue?: number | null
  zcbInstrumentId?: string | null
}
export type ApiTradeEconomics = {
  depositIdOverride?: string | null
  loanIdOverride?: string | null
  noteCounterpartyId?: string | null
  noteOverrideFees?: ApiFee[] | null
  portfolioOverrideFees?: ApiFee[] | null
  strategyOverrideFees?: ApiFee[] | null
}
export type ApiTradeApproval = {
  comments?: string | null
}
export type ApiTradeRejection = {
  comments?: string | null
}
export type ApiConfirmSettlementRequest = {
  transferOfUnits?: ApiTransferOfUnits[] | null
}
export type ApiTradeActivation = {
  comments?: string | null
}
export type ApiNoteValueSummary = {
  numberActiveTrades?: number
  numberClosedTrades?: number
  totalValues?: {
    [key: string]: number
  } | null
}
export type ApiRunningAccount = {
  accountId: string
  accountName: string
  accountSource: string
  businessUnit?: ApiBusinessUnit
  client?: ApiClient
  currentlyApproving: boolean
  currentlyClosing: boolean
  currentlyUpdating: boolean
  dateOpened?: string
  note?: ApiNote
  portfolio?: (ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio) | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  status: ApiAccountRunningStatus
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateName?: string | null
  tradeDocumentation?: ApiTradeDocumentation[] | null
}
export type ApiRunningAccountRead = {
  accountId: string
  accountName: string
  accountSource: string
  businessUnit?: ApiBusinessUnit
  client?: ApiClient
  currentlyApproving: boolean
  currentlyClosing: boolean
  currentlyUpdating: boolean
  dateOpened?: string
  note?: ApiNote
  portfolio?:
    | (ApiModelPortfolioRead | ApiFundOfFundsPortfolioRead | ApiSelfSelectPortfolioRead)
    | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  status: ApiAccountRunningStatus
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateName?: string | null
  tradeDocumentation?: ApiTradeDocumentation[] | null
}
export type ApiAccountDetails = {
  accountId: string
  accountSource: string
}
export type ApiInvestmentAmount = {
  amount: number
  assetClass: string
  assetId: string
  assetName: string
  units: number
}
export type ApiCurrencyHolding = {
  balance?: number | null
  currency: string
  depositReferenceId: string
  units?: number | null
  value?: number | null
}
export type ApiLoanHolding = {
  currency: string
  loanId: string
  units: number
  value?: number | null
}
export type ApiOperationType =
  | 'Unknown'
  | 'Deposit'
  | 'PortfolioChange'
  | 'PortfolioSubstitution'
  | 'FeeRateChange'
  | 'FeeDeduction'
  | 'Dividend'
  | 'ReinvestmentConfirmation'
  | 'SyntheticTransfer'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'StrategyChange'
  | 'ExternalTransfer'
  | 'Rebalancing'
  | 'Redemption'
  | 'Defeasance'
  | 'ReconciliationTransfer'
  | 'TriggeredFeeDeduction'
  | 'TargetVolatilityChange'
  | 'ProtectionPortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionPercentageChange'
  | 'ProtectionReset'
  | 'ProtectedFeeDeduction'
  | 'ProtectedWithdrawal'
  | 'ProtectedAccountClosure'
  | 'GapPayment'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'ProtectedSwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'
export type ApiOperationState = 'Queued' | 'Processing' | 'Completed' | 'Rejected'
export type ApiOrderBatchAggregateState = 'New' | 'InProgress' | 'Complete'
export type ApiOrderLegDirection = 'Subscription' | 'Redemption'
export type ApiOrderLegState =
  | 'New'
  | 'Requested'
  | 'Placed'
  | 'Confirmed'
  | 'Settled'
  | 'Rejected'
  | 'Cancelled'
export type ApiContractNoteIssuer = 'Market' | 'Contractual'
export type ApiContractNoteAdjustmentReason = 'BalancedBatch'
export type ApiContractNoteAdjustment = {
  adjustedShares: number
  adjustedValue: number
  reason: ApiContractNoteAdjustmentReason
}
export type ApiContractNote = {
  adjustment?: ApiContractNoteAdjustment
  confirmedShares: number
  confirmedValue: number
  executedDate: string
  executedFxRate?: number | null
  executedPrice: number
  issuedDate: string
  issuer: ApiContractNoteIssuer
  reference?: string | null
}
export type ApiOrderLeg = {
  assetId: string
  contractNote?: ApiContractNote
  createdDate: string
  currency?: string | null
  direction: ApiOrderLegDirection
  estimatedValue?: number | null
  expectedExecutionDate?: string | null
  placedDate?: string | null
  requestedEffectiveDate?: string | null
  requestedExecutionDate?: string | null
  shares?: number | null
  state: ApiOrderLegState
  value?: number | null
}
export type ApiOrderBatch = {
  aggregateState: ApiOrderBatchAggregateState
  alignmentDate?: string | null
  createdDate: string
  legs: ApiOrderLeg[]
  orderBatchId: string
}
export type ApiCashInstrumentType = 'Loan' | 'Deposit' | 'ZcbCurve'
export type ApiCashInstrumentTransaction = {
  createdDate: string
  currency: string
  direction: ApiOrderLegDirection
  instrumentId: string
  instrumentType: ApiCashInstrumentType
  maturityDate?: string | null
  price?: number | null
  shares: number
  transactionId: string
  value: number
}
export type ApiDepositInstruction = {
  type: 'Deposit'
} & ApiInstructionBase & {
    requestedValue: number
    type: ApiInstructionType
  }
export type ApiPortfolioChangeInstruction = {
  type: 'PortfolioChange'
} & ApiInstructionBase & {
    portfolioId?: string | null
    selfSelectPortfolio?: ApiSelfSelectPortfolio
    type: ApiInstructionType
  }
export type ApiPortfolioChangeInstructionRead = {
  type: 'PortfolioChange'
} & ApiInstructionBase & {
    portfolioId?: string | null
    selfSelectPortfolio?: ApiSelfSelectPortfolioRead
    type: ApiInstructionType
  }
export type ApiAccountClosureInstruction = {
  type: 'AccountClosure'
} & ApiInstructionBase & {
    effectiveDate?: string | null
    reason?: string | null
    type: ApiInstructionType
  }
export type ApiWithdrawalInstruction = {
  type: 'Withdrawal'
} & ApiInstructionBase & {
    requestedValue: number
    type: ApiInstructionType
  }
export type ApiProtectedValueChangeInstruction = {
  type: 'ProtectedValueChange'
} & ApiInstructionBase & {
    type: ApiInstructionType
    value: number
  }
export type ApiStrategyChangeInstruction = {
  type: 'StrategyChange'
} & ApiInstructionBase & {
    strategy: ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy
    type: ApiInstructionType
  }
export type ApiProtectionPortfolioChangeInstruction = {
  type: 'ProtectionPortfolioChange'
} & ApiInstructionBase & {
    targetWeights: ApiPortfolioInvestment[]
    type: ApiInstructionType
  }
export type ApiAncillaryAssetsChangeInstruction = {
  type: 'AncillaryAssetsChange'
} & ApiInstructionBase & {
    newDepositReferenceId?: string | null
    newLoanReferenceId?: string | null
    newZcbInstrumentId?: string | null
    type: ApiInstructionType
  }
export type ApiTransferredFee = {
  definition: ApiFee
  value: number
  vatValue: number
}
export type ApiSwitchInInstruction = {
  type: 'SwitchIn'
} & ApiInstructionBase & {
    originatingAccountId: string
    switchAmount: number
    transferredFees?: ApiTransferredFee[] | null
    type: ApiInstructionType
  }
export type ApiDistributionType = 'Dividend' | 'Interest' | 'Capital'
export type ApiDividendInstruction = {
  type: 'Dividend'
} & ApiInstructionBase & {
    assetId: string
    distributionType?: ApiDistributionType
    dividendAmountPerShare?: number
    exDividendDate: string
    heldShares?: number | null
    isCorrection?: boolean
    previousDividendAmountPerShare?: number | null
    previousReinvestmentDate?: string | null
    referenceId: string
    reinvestmentDate?: string | null
    type: ApiInstructionType
  }
export type ApiReinvestmentConfirmationInstruction = {
  type: 'ReinvestmentConfirmation'
} & ApiInstructionBase & {
    assetId: string
    exDate: string
    reinvestmentDate: string
    shares: number
    type: ApiInstructionType
  }
export type ApiNoteChangeRequest = {
  dividendProcessing: ApiDividendProcessing
  fees?: ApiFee[] | null
  noteId: string
}
export type ApiNoteChangeInstruction = {
  type: 'NoteChange'
} & ApiInstructionBase & {
    note: ApiNoteChangeRequest
    type: ApiInstructionType
  }
export type ApiNewAccountInstruction = {
  type: 'NewAccount'
} & ApiInstructionBase & {
    initialisation?:
      | (
          | ApiNewAccountInstruction
          | ApiDepositInstruction
          | ApiPortfolioChangeInstruction
          | ApiAccountClosureInstruction
          | ApiWithdrawalInstruction
          | ApiProtectedValueChangeInstruction
          | ApiStrategyChangeInstruction
          | ApiProtectionPortfolioChangeInstruction
          | ApiAncillaryAssetsChangeInstruction
          | ApiSwitchInInstruction
          | ApiSwitchOutInstruction
          | ApiDividendInstruction
          | ApiReinvestmentConfirmationInstruction
          | ApiNoteChangeInstruction
        )[]
      | null
    type: ApiInstructionType
  }
export type ApiNewAccountInstructionRead = {
  type: 'NewAccount'
} & ApiInstructionBase & {
    initialisation?:
      | (
          | ApiNewAccountInstructionRead
          | ApiDepositInstruction
          | ApiPortfolioChangeInstructionRead
          | ApiAccountClosureInstruction
          | ApiWithdrawalInstruction
          | ApiProtectedValueChangeInstruction
          | ApiStrategyChangeInstruction
          | ApiProtectionPortfolioChangeInstruction
          | ApiAncillaryAssetsChangeInstruction
          | ApiSwitchInInstruction
          | ApiSwitchOutInstruction
          | ApiDividendInstruction
          | ApiReinvestmentConfirmationInstruction
          | ApiNoteChangeInstruction
        )[]
      | null
    type: ApiInstructionType
  }
export type ApiOperationBase = {
  associatedInstruction?:
    | (
        | ApiNewAccountInstruction
        | ApiDepositInstruction
        | ApiPortfolioChangeInstruction
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )
    | null
  cashTransactions?: ApiCashInstrumentTransaction[] | null
  generatedDate: string
  information?: string | null
  operationId: string
  orders?: ApiOrderBatch[] | null
  state: ApiOperationState
  targetDate?: string | null
  type: ApiOperationType
}
export type ApiOperationBaseRead = {
  associatedInstruction?:
    | (
        | ApiNewAccountInstructionRead
        | ApiDepositInstruction
        | ApiPortfolioChangeInstructionRead
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )
    | null
  cashTransactions?: ApiCashInstrumentTransaction[] | null
  generatedDate: string
  information?: string | null
  operationId: string
  orders?: ApiOrderBatch[] | null
  state: ApiOperationState
  targetDate?: string | null
  type: ApiOperationType
}
export type ApiDepositReason = 'None' | 'Deposit' | 'Rebate'
export type ApiDepositOperation = {
  type: 'Deposit'
} & ApiOperationBase & {
    reason?: ApiDepositReason
    type: ApiOperationType
  }
export type ApiDepositOperationRead = {
  type: 'Deposit'
} & ApiOperationBaseRead & {
    reason?: ApiDepositReason
    type: ApiOperationType
  }
export type ApiStrategyChangeOperation = {
  type: 'StrategyChange'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiStrategyChangeOperationRead = {
  type: 'StrategyChange'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiPortfolioChangeOperation = {
  type: 'PortfolioChange'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiPortfolioChangeOperationRead = {
  type: 'PortfolioChange'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiPortfolioFeeChangeOperation = {
  type: 'PortfolioFeeChange'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiPortfolioFeeChangeOperationRead = {
  type: 'PortfolioFeeChange'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiWithdrawalOperation = {
  type: 'Withdrawal'
} & ApiOperationBase & {
    completedValue?: number | null
    type: ApiOperationType
  }
export type ApiWithdrawalOperationRead = {
  type: 'Withdrawal'
} & ApiOperationBaseRead & {
    completedValue?: number | null
    type: ApiOperationType
  }
export type ApiRebalancingOperation = {
  type: 'Rebalancing'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiRebalancingOperationRead = {
  type: 'Rebalancing'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiProtectionPortfolioChangeOperation = {
  type: 'ProtectionPortfolioChange'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiProtectionPortfolioChangeOperationRead = {
  type: 'ProtectionPortfolioChange'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiProtectedWithdrawalOperation = {
  type: 'ProtectedWithdrawal'
} & ApiOperationBase & {
    completedValue?: number | null
    gapAmount?: number | null
    protectedValue: number
    type: ApiOperationType
  }
export type ApiProtectedWithdrawalOperationRead = {
  type: 'ProtectedWithdrawal'
} & ApiOperationBaseRead & {
    completedValue?: number | null
    gapAmount?: number | null
    protectedValue: number
    type: ApiOperationType
  }
export type ApiProtectedAccountClosureOperation = {
  type: 'ProtectedAccountClosure'
} & ApiOperationBase & {
    completedValue?: number | null
    gapAmount?: number | null
    protectedValue: number
    type: ApiOperationType
  }
export type ApiProtectedAccountClosureOperationRead = {
  type: 'ProtectedAccountClosure'
} & ApiOperationBaseRead & {
    completedValue?: number | null
    gapAmount?: number | null
    protectedValue: number
    type: ApiOperationType
  }
export type ApiSwitchInOperation = {
  type: 'SwitchIn'
} & ApiOperationBase & {
    type: ApiOperationType
  }
export type ApiSwitchInOperationRead = {
  type: 'SwitchIn'
} & ApiOperationBaseRead & {
    type: ApiOperationType
  }
export type ApiSwitchOutOperation = {
  type: 'SwitchOut'
} & ApiOperationBase & {
    completedValue?: number | null
    isFullSwitchOut?: boolean
    transferredFees?: ApiTransferredFee[] | null
    type: ApiOperationType
  }
export type ApiSwitchOutOperationRead = {
  type: 'SwitchOut'
} & ApiOperationBaseRead & {
    completedValue?: number | null
    isFullSwitchOut?: boolean
    transferredFees?: ApiTransferredFee[] | null
    type: ApiOperationType
  }
export type ApiProtectedSwitchOutOperation = {
  type: 'ProtectedSwitchOut'
} & ApiOperationBase & {
    completedValue?: number | null
    gapAmount?: number | null
    isFullSwitchOut?: boolean
    protectedValue: number
    transferredFees?: ApiTransferredFee[] | null
    type: ApiOperationType
  }
export type ApiProtectedSwitchOutOperationRead = {
  type: 'ProtectedSwitchOut'
} & ApiOperationBaseRead & {
    completedValue?: number | null
    gapAmount?: number | null
    isFullSwitchOut?: boolean
    protectedValue: number
    transferredFees?: ApiTransferredFee[] | null
    type: ApiOperationType
  }
export type ApiAccountSnapshot = {
  accountDetails: ApiAccountDetails
  accountValue: number
  accruedFees?: number | null
  amountInflightDepositOrders?: number | null
  bondFloor: number | null
  cashAllocation?: number | null
  currencyHoldings?: ApiCurrencyHolding[] | null
  currentStrategy:
    | ApiPassThroughStrategy
    | ApiCppiStrategy
    | ApiTippStrategy
    | ApiVolControlStrategy
  dividendAccrualValue?: number | null
  gapAmount?: number | null
  growthAssets?: ApiInvestmentAmount[] | null
  growthExposure?: number | null
  growthFactor?: number | null
  highWatermark?: number | null
  impliedMultiplier?: number | null
  loanAllocation?: number | null
  loanAmount?: number | null
  loanHoldings?: ApiLoanHolding[] | null
  netContributions?: number
  notionalCurrency?: string | null
  operations?:
    | (
        | ApiDepositOperation
        | ApiStrategyChangeOperation
        | ApiPortfolioChangeOperation
        | ApiPortfolioFeeChangeOperation
        | ApiWithdrawalOperation
        | ApiRebalancingOperation
        | ApiProtectionPortfolioChangeOperation
        | ApiProtectedWithdrawalOperation
        | ApiProtectedAccountClosureOperation
        | ApiSwitchInOperation
        | ApiSwitchOutOperation
        | ApiProtectedSwitchOutOperation
      )[]
    | null
  pendingPerformanceAllocation?: number | null
  pendingProtectionAllocation?: number | null
  performanceAllocation?: number | null
  protectedAmount?: number
  protectedAssets?: ApiInvestmentAmount[] | null
  protectedExposure?: number | null
  protectedLevel?: number | null
  protectionAllocation?: number | null
  strategyTemplateId?: string | null
  targetLeverageRatio?: number | null
  targetMultiplier?: number | null
  targetPerformanceAllocation?: number | null
  targetProtectionAllocation?: number | null
  targetVolatility?: number | null
  valuationDate: string
  zcbAllocation?: number | null
}
export type ApiAccountSnapshotRead = {
  accountDetails: ApiAccountDetails
  accountValue: number
  accruedFees?: number | null
  amountInflightDepositOrders?: number | null
  bondFloor: number | null
  cashAllocation?: number | null
  currencyHoldings?: ApiCurrencyHolding[] | null
  currentStrategy:
    | ApiPassThroughStrategy
    | ApiCppiStrategy
    | ApiTippStrategy
    | ApiVolControlStrategy
  dividendAccrualValue?: number | null
  gapAmount?: number | null
  growthAssets?: ApiInvestmentAmount[] | null
  growthExposure?: number | null
  growthFactor?: number | null
  highWatermark?: number | null
  impliedMultiplier?: number | null
  loanAllocation?: number | null
  loanAmount?: number | null
  loanHoldings?: ApiLoanHolding[] | null
  netContributions?: number
  notionalCurrency?: string | null
  operations?:
    | (
        | ApiDepositOperationRead
        | ApiStrategyChangeOperationRead
        | ApiPortfolioChangeOperationRead
        | ApiPortfolioFeeChangeOperationRead
        | ApiWithdrawalOperationRead
        | ApiRebalancingOperationRead
        | ApiProtectionPortfolioChangeOperationRead
        | ApiProtectedWithdrawalOperationRead
        | ApiProtectedAccountClosureOperationRead
        | ApiSwitchInOperationRead
        | ApiSwitchOutOperationRead
        | ApiProtectedSwitchOutOperationRead
      )[]
    | null
  pendingPerformanceAllocation?: number | null
  pendingProtectionAllocation?: number | null
  performanceAllocation?: number | null
  protectedAmount?: number
  protectedAssets?: ApiInvestmentAmount[] | null
  protectedExposure?: number | null
  protectedLevel?: number | null
  protectionAllocation?: number | null
  strategyTemplateId?: string | null
  targetLeverageRatio?: number | null
  targetMultiplier?: number | null
  targetPerformanceAllocation?: number | null
  targetProtectionAllocation?: number | null
  targetVolatility?: number | null
  valuationDate: string
  zcbAllocation?: number | null
}
export type ApiAccountHistoryReportWithNoteData = {
  account?: ApiRunningAccount
  accountSnapShots: ApiAccountSnapshot[]
  noteValueSummary: ApiNoteValueSummary
}
export type ApiAccountHistoryReportWithNoteDataRead = {
  account?: ApiRunningAccountRead
  accountSnapShots: ApiAccountSnapshotRead[]
  noteValueSummary: ApiNoteValueSummary
}
export type ApiAccountHistoryReport = {
  account?: ApiRunningAccount
  accountSnapShots: ApiAccountSnapshot[]
}
export type ApiAccountHistoryReportRead = {
  account?: ApiRunningAccountRead
  accountSnapShots: ApiAccountSnapshotRead[]
}
export type ApiDashboardClient = {
  clientId: string
  clientName: string
}
export type ApiDashboardBusinessUnit = {
  businessUnitId: string
  businessUnitName: string
}
export type ApiDashboardFeeDefinition = {
  feeRate: number
  feeType: ApiFeeType
}
export type ApiDashboardInvestmentAmount = {
  assetId: string
  value: number
}
export type AccountPerformanceOnDay = {
  date?: string
  growthFactor?: number | null
  value?: number
}
export type ApiDashboardAccount = {
  accountId: string
  accountName: string
  accountSource: string
  accountValue: number
  businessUnit: ApiDashboardBusinessUnit
  client: ApiDashboardClient
  currentlyApproving: boolean
  currentlyClosing: boolean
  currentlyUpdating: boolean
  growthAssets?: ApiDashboardInvestmentAmount[] | null
  isLockedForUpdates: boolean
  last30DaysPeformancePercent: number
  last30DaysPerformance: AccountPerformanceOnDay[]
  latestValuationDate: string
  leverageRatio?: number | null
  noteFees?: ApiDashboardFeeDefinition[] | null
  noteId: string
  noteName: string
  notionalCurrency: string
  portfolioFees?: ApiDashboardFeeDefinition[] | null
  portfolioId: string
  portfolioName: string
  portfolioType: ApiPortfolioType
  protectedAssets?: ApiDashboardInvestmentAmount[] | null
  protectedLevel?: number | null
  status: ApiAccountRunningStatus
  strategyFees?: ApiDashboardFeeDefinition[] | null
  strategyTemplateName?: string | null
  strategyType: ApiStrategyType
  targetVolatility?: number | null
}
export type ApiDashboardAsset = {
  assetClass: string
  assetId: string
  currency: string
  name: string
}
export type ApiDashboardPortfolio = {
  portfolioId: string
  portfolioName: string
}
export type ApiDashboardNote = {
  fees?: ApiDashboardFeeDefinition[] | null
  isCollateralForLoan: boolean
  isLocked: boolean
  noteId: string
  noteName: string
}
export type ApiDashboardFxRate = {
  currencyBase: string
  currencyCounter: string
  spotRate: number
}
export type ApiDashboard = {
  accounts?: ApiDashboardAccount[] | null
  assets?: ApiDashboardAsset[] | null
  fxRates?: ApiDashboardFxRate[] | null
  notes?: ApiDashboardNote[] | null
  performanceLogs?: string[] | null
  portfolios?: ApiDashboardPortfolio[] | null
}
export type ApiAccountDashboardStrategyTrade = {
  leverageRatio?: number | null
  localCurrencyValue?: number
  notionalCurrency?: string | null
  protectedPercentage?: number | null
  targetVolatility?: number | null
  zarValue?: number
}
export type ApiAccountDashboardStrategy = {
  localCurrencyValue?: number | null
  notionalCurrency?: string | null
  numberOfActiveAccounts: number
  strategyName?: string | null
  trades?: ApiAccountDashboardStrategyTrade[] | null
  zarValue?: number
}
export type ApiAccountDashboardAsset = {
  assetClass: string
  assetId: string
  localCurrencyValue: number
  name: string
  notionalCurrency: string
  numberOfActiveAccounts: number
  performancePercentage12Months?: number | null
  performancePercentageYTD?: number | null
  zarValue: number
}
export type ApiAccountDashboardModelPortfolio = {
  localCurrencyValue: number
  notionalCurrency: string | null
  numberOfActiveAccounts: number
  portfolioId: string
  portfolioName: string
  portfolioType: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  taxClassification?: ApiTaxClassification
  totalFees: number
  zarValue: number
}
export type ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummary = {
  name: string
  portfolios?: ApiAccountDashboardModelPortfolio[] | null
}
export type ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummaryRead = {
  localCurrencyValue?: number | null
  name: string
  notionalCurrency?: string | null
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardModelPortfolio[] | null
  zarValue?: number | null
}
export type ApiAccountDashboardSelfSelectPortfolio = {
  localCurrencyValue: number
  notionalCurrency: string | null
  numberOfActiveAccounts: number
  portfolioType: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  taxClassification?: ApiTaxClassification
  totalFees: number
  zarValue: number
}
export type ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummary = {
  name: string
  portfolios?: ApiAccountDashboardSelfSelectPortfolio[] | null
}
export type ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummaryRead = {
  localCurrencyValue?: number | null
  name: string
  notionalCurrency?: string | null
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardSelfSelectPortfolio[] | null
  zarValue?: number | null
}
export type ApiAccountDashboardFundOfFundsPortfolio = {
  lastRebalance?: string | null
  localCurrencyValue: number
  notionalCurrency: string | null
  numberOfActiveAccounts: number
  portfolioId: string
  portfolioName: string
  portfolioType: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  startDate?: string | null
  taxClassification?: ApiTaxClassification
  totalFees: number
  zarValue: number
}
export type ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummary = {
  name: string
  portfolios?: ApiAccountDashboardFundOfFundsPortfolio[] | null
}
export type ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummaryRead = {
  localCurrencyValue?: number | null
  name: string
  notionalCurrency?: string | null
  numberOfActiveTrades: number
  portfolios?: ApiAccountDashboardFundOfFundsPortfolio[] | null
  zarValue?: number | null
}
export type ApiAccountDashboardPortfolios = {
  fundOfFunds?: ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummary
  model?: ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummary
  selfSelect?: ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummary
}
export type ApiAccountDashboardPortfoliosRead = {
  fundOfFunds?: ApiAccountDashboardFundOfFundsPortfolioApiAccountDashboardPortfolioSummaryRead
  model?: ApiAccountDashboardModelPortfolioApiAccountDashboardPortfolioSummaryRead
  selfSelect?: ApiAccountDashboardSelfSelectPortfolioApiAccountDashboardPortfolioSummaryRead
}
export type ApiAccountDashboardNote = {
  businessUnit?: string | null
  client?: string | null
  localCurrencyValue: number
  noteId: string
  noteName?: string | null
  notionalCurrency?: string | null
  numberOfActiveAccounts: number
  taxClassification?: ApiTaxClassification
  zarValue?: number
}
export type ApiAccountDashboardCurrency = {
  localCurrencyValue: number
  notionalCurrency: string
  numberOfActiveAccounts: number
  zarValue: number
}
export type ApiAccountDashboardFeeDefinition = {
  feeType: ApiFeeType
  localCurrencyValue?: number | null
  notionalCurrency?: string | null
  totalsByCurrency: {
    [key: string]: number
  }
  zarValue: number
}
export type ApiAggregateAccountHistory = {
  dates?: string[] | null
  netContributions?: number[] | null
  totalValues?: number[] | null
}
export type ApiAccountDashboard = {
  aggregateAccountHistory?: ApiAggregateAccountHistory
  assets?: ApiAccountDashboardAsset[] | null
  currencies?: ApiAccountDashboardCurrency[] | null
  fees?: ApiAccountDashboardFeeDefinition[] | null
  localCurrencyValue?: number | null
  notes?: ApiAccountDashboardNote[] | null
  notionalCurrency?: string | null
  numberOfActiveAccounts?: number
  portfolios?: ApiAccountDashboardPortfolios
  strategies?: ApiAccountDashboardStrategy[] | null
  zarValue?: number
}
export type ApiAccountDashboardRead = {
  aggregateAccountHistory?: ApiAggregateAccountHistory
  assets?: ApiAccountDashboardAsset[] | null
  currencies?: ApiAccountDashboardCurrency[] | null
  fees?: ApiAccountDashboardFeeDefinition[] | null
  localCurrencyValue?: number | null
  notes?: ApiAccountDashboardNote[] | null
  notionalCurrency?: string | null
  numberOfActiveAccounts?: number
  portfolios?: ApiAccountDashboardPortfoliosRead
  strategies?: ApiAccountDashboardStrategy[] | null
  zarValue?: number
}
export type ApiAccountDashboardAccount = {
  accountId: string
  accountName: string
  accountSource: string
  accountValue: number
  latestValuationDate: string
  leverageRatio?: number | null
  noteId: string
  notionalCurrency: string
  portfolioId: string
  protectedLevel?: number | null
  status: ApiAccountRunningStatus
  strategyFees?: ApiFee[] | null
  strategyTemplateName?: string | null
  strategyType: ApiStrategyType
  targetVolatility?: number | null
}
export type ApiAccountDashboardAccountApiPaginationResult = {
  data: ApiAccountDashboardAccount[]
  totalDocuments: number
}
export type ClientType = 'Institutional' | 'Retail'
export type AccountRunningStatus = 'New' | 'Running' | 'Suspended' | 'Closing' | 'Closed'
export type PortfolioType = 'None' | 'ModelPortfolio' | 'SelfSelect' | 'FundOfFunds'
export type StrategyType = 'PassThrough' | 'TIPP' | 'CPPI' | 'VolControl'
export type GetAccountsFilters = {
  accountRunningStatus?: AccountRunningStatus
  clientType?: ClientType
  currencyCode?: string | null
  ids?: string[] | null
  isNoteCollateralized?: boolean | null
  portfolioType?: PortfolioType
  strategyType?: StrategyType
}
export type ApiGetAccountAccrualsFilter = {
  endDateInclusive?: string
  feeType?: ApiFeeType
  noteIds?: string[] | null
  startDateInclusive?: string
}
export type AccountExportReport = {
  cash: number
  currency: string
  hasBankGuarantee: boolean | null
  loan: number
  netContributions: number
  noteName: string
  performanceAssetValue: number
  portfolioName?: string | null
  protectedAmount: number
  protectionAssetValue: number
  tradeId: string
  tradeName: string
  tradeValue: number
}
export type ApiTradingAccountApiPaginationResult = {
  data: ApiTradingAccount[]
  totalDocuments: number
}
export type ApiTradingAccountApiPaginationResultRead = {
  data: ApiTradingAccountRead[]
  totalDocuments: number
}
export type ApiNotePrices = {
  baseCostPerUnit?: number
  basePortfolioValue?: number
  currentPortfolioValue?: number
  notePrice?: number
  noteUnits?: number
}
export type ApiAccountLockType = 'SwitchInProgress'
export type ValuationCycleIdentifier = {
  juncture: string
}
export type ValuationCycleExpiryIdentifier = {
  expires: string
}
export type ValuationSnapIdentifier = {
  snapDate: string
}
export type AccountOwnerType = 'HedgingCounterparty' | 'Distributor'
export type AccountOwner = {
  ownerId: string
  type: AccountOwnerType
}
export type InvestmentHolding = {
  accruedFeeShares?: number | null
  assetId: string
  ringfencedShares?: number | null
  shares: number
  syntheticShares?: number | null
  syntheticValue?: number | null
  value?: number | null
  varianceLong?: number | null
  varianceShort?: number | null
}
export type CurrencyHolding = {
  balance?: number | null
  currency?: string
  depositReferenceId?: string | null
  units?: number | null
  value?: number | null
}
export type LoanHolding = {
  currency?: string
  loanId?: string | null
  units?: number
  value?: number | null
}
export type ZcbHolding = {
  askPrice?: number | null
  bidPrice?: number | null
  instrumentId?: string | null
  units?: number
  value?: number | null
}
export type PortfolioState = {
  currencyHoldings?: CurrencyHolding[] | null
  holdings?: InvestmentHolding[] | null
  loanHoldings?: LoanHolding[] | null
  zcbHoldings?: ZcbHolding[] | null
}
export type RebalancingType = 'None' | 'Frequency' | 'Weight' | 'CalendarFrequency'
export type RebalancingFrequency = 'None' | 'Monthly' | 'Quarterly' | 'SemiAnnually' | 'Annually'
export type RebalancingDefinition = {
  frequency?: RebalancingFrequency
  type: RebalancingType
  weightsTolerance?: number | null
}
export type InvestmentWeight = {
  assetId: string
  weight: number
}
export type FeeType =
  | 'GapProtectionPremium'
  | 'LoanFee'
  | 'DistributionFee'
  | 'StrategyFee'
  | 'PlatformFee'
  | 'PortfolioManagementFee'
  | 'NoteFee'
  | 'ExitFee'
  | 'TransactionFee'
  | 'Delta1PremiumFee'
  | 'RiskControlledPremiumFee'
  | 'HedgingPremiumFee'
  | 'OngoingPremium'
  | 'LifeCompanyFee'
  | 'AdviceFee'
  | 'DiscretionaryFundManagementFee'
  | 'StrategyAdviceFee'
export type FeeDeductionFrequency =
  | 'None'
  | 'Quarterly'
  | 'Monthly'
  | 'Annually'
  | 'UpFront'
  | 'Exit'
export type FeeBasis = 'TotalTradeValue' | 'RiskyAssetExposure' | 'LoanAmount'
export type FeeDayCount = 'Act_365' | 'Act_Act' | 'Act_360' | 'Thirty_360' | 'Thirty_365'
export type Fee = {
  counterPartyId: string
  feeBasis: FeeBasis
  feeDayCount: FeeDayCount
  feeDeductionFrequency: FeeDeductionFrequency
  feeId: string
  feeRate: number
  feeType: FeeType
  isVATApplicable: boolean
}
export type PortfolioDefinition = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  fees?: Fee[] | null
  multiplier?: number | null
  rebalancingDefinition: RebalancingDefinition
  targetWeights: InvestmentWeight[]
  type: PortfolioType
}
export type StrategyDefinition = {
  fees?: Fee[] | null
  leverageRatio?: number | null
  type: StrategyType
}
export type DividendProcessing = 'Reinvested' | 'Paid'
export type NoteEconomics = {
  dividendProcessing: DividendProcessing
  noteId: string
}
export type AncillaryAssetsDefinition = {
  depositReferenceId?: string | null
  loanReferenceId?: string | null
  zcbInstrumentId?: string | null
}
export type AccountEconomics = {
  accountValue: number
  cashAllocation?: number | null
  cashLockClosureDate?: string | null
  dividendAccrualValue?: number | null
  impliedLeverageRatio?: number | null
  loanAllocation?: number | null
  pendingCashAllocation?: number | null
  pendingLoanAllocation?: number | null
  pendingPerformanceAllocation?: number | null
  pendingProtectionAllocation?: number | null
  performanceAllocation?: number
  protectionAllocation?: number
  runningStatus: AccountRunningStatus
  targetPerformanceAllocation?: number | null
  targetProtectionAllocation?: number | null
  zcbAllocation?: number | null
}
export type FeeDeductionState = {
  counter: number
  nextDeductionDate: string
  startDate: string
}
export type FeeLevel = 'Note' | 'Strategy' | 'Portfolio'
export type FeeState = {
  accrual?: number | null
  accrualPaymentDate?: string | null
  accruedFee: number
  deductionState?: FeeDeductionState
  definition: Fee
  feeInstanceId?: string | null
  isActive: boolean
  level: FeeLevel
  vatAccrual?: number | null
  vatAccruedFee?: number | null
}
export type FeeEconomics = {
  accruedFee?: number | null
  states?: FeeState[] | null
}
export type AccountProtectedStatus = 'Protected' | 'Unprotected' | 'CashLocked' | 'GapEvent'
export type HighWatermarkObservationStatus = {
  nextObservation?: string
  observationCounter?: number
  startDate?: string
}
export type AdjustmentReason =
  | 'TransferToleranceBreach'
  | 'AggregateTransferToleranceBreach'
  | 'SyntheticBuybackToleranceBreach'
  | 'AggregateSyntheticBuybackToleranceBreach'
  | 'ModifiedPortfolioState'
  | 'ScalingFactorChange'
  | 'FeeChangeToleranceBreach'
  | 'FeeProportionToleranceBreach'
  | 'OfficialHighWatermarkToleranceBreach'
  | 'WithdrawalHasOutstandingOrderBatches'
  | 'ActivePremiumToleranceBreach'
  | 'ProtectedValueToleranceBreach'
export type AdjustmentOngoingReason =
  | 'NewAdjustmentRebalancing'
  | 'PortfolioNotRunning'
  | 'WithdrawalPresent'
  | 'OrderBatchBeforeRiskNormalizationDate'
  | 'AdjustmentOrdersNotComplete'
  | 'AdjustmentInstructionsNotComplete'
export type ProtectionAdjustment = {
  issuedDate: string
  ongoingReasons?: AdjustmentOngoingReason[] | null
  reasons?: AdjustmentReason[] | null
  riskNormalizationDate?: string | null
}
export type ProtectionEconomics = {
  adjustments?: ProtectionAdjustment[] | null
  bondFloor?: number | null
  defeasedAccountValue?: number | null
  gapAmount?: number | null
  gapAmountDue?: number | null
  highWatermark?: number | null
  highWatermarkObservationStatus?: HighWatermarkObservationStatus
  impliedMultiplier?: number | null
  protectedValue?: number
  status: AccountProtectedStatus
  targetMultiplier?: number | null
  targetProtectionWeights?: InvestmentWeight[] | null
}
export type RebalancingStatus = {
  nextRebalancing?: string | null
  rebalancingCounter: number
  rebalancingDefinition: RebalancingDefinition
  startDate?: string | null
}
export type OperationType =
  | 'Unknown'
  | 'Deposit'
  | 'PortfolioChange'
  | 'PortfolioSubstitution'
  | 'FeeRateChange'
  | 'FeeDeduction'
  | 'AccruedFee'
  | 'Dividend'
  | 'ReinvestmentConfirmation'
  | 'SyntheticTransfer'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'StrategyChange'
  | 'ExternalTransfer'
  | 'Rebalancing'
  | 'Redemption'
  | 'Defeasance'
  | 'ReconciliationTransfer'
  | 'TriggeredFeeDeduction'
  | 'ActivePremiumReconciliation'
  | 'ProtectedValueReconciliation'
  | 'TargetVolatilityChange'
  | 'ProtectedValueChange'
  | 'ProtectionPercentageChange'
  | 'ProtectionReset'
  | 'ProtectedFeeDeduction'
  | 'ProtectedWithdrawal'
  | 'ProtectedAccountClosure'
  | 'ProtectionPortfolioChange'
  | 'GapPayment'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'ProtectedSwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'
export type OperationState = 'Queued' | 'Processing' | 'Completed' | 'Rejected'
export type OrderBatchAggregateState = 'New' | 'InProgress' | 'Complete'
export type OrderLegState =
  | 'New'
  | 'Requested'
  | 'Placed'
  | 'Confirmed'
  | 'Settled'
  | 'Rejected'
  | 'Cancelled'
export type OrderLegDirection = 'Subscription' | 'Redemption'
export type ContractNoteIssuer = 'Market' | 'Contractual'
export type ContractNote = {
  confirmedShares: number
  confirmedValue: number
  executedDate: string
  executedFxRate?: number | null
  executedPrice: number
  issuedDate: string
  issuer: ContractNoteIssuer
  reference?: string | null
}
export type OrderLeg = {
  assetId: string
  cashCostUnits?: number | null
  cashShares?: number | null
  cashValue?: number | null
  contractNote?: ContractNote
  createdDate: string
  currency?: string | null
  depositReferenceId?: string | null
  direction: OrderLegDirection
  estimatedPrice?: number
  expectedExecutionDate?: string | null
  loanCostUnits?: number | null
  loanReferenceId?: string | null
  loanShares?: number | null
  loanValue?: number | null
  orderId: string
  placedValuationCycle?: string | null
  requestedEffectiveDate?: string | null
  requestedExecutionDate?: string | null
  shares?: number | null
  state: OrderLegState
  value?: number | null
}
export type OrderBatch = {
  aggregateState: OrderBatchAggregateState
  alignmentDate?: string | null
  createdDate: string
  legs: OrderLeg[]
  orderBatchId: string
}
export type CashInstrumentType = 'Loan' | 'Deposit' | 'ZcbCurve'
export type CashInstrumentTransaction = {
  createdDate: string
  currency: string
  direction: OrderLegDirection
  instrumentId: string
  instrumentType: CashInstrumentType
  maturityDate?: string | null
  price?: number | null
  shares: number
  transactionId: string
  value: number
}
export type Operation = {
  cashTransactions?: CashInstrumentTransaction[] | null
  generatedDate: string
  information?: string | null
  operationId: string
  orders?: OrderBatch[] | null
  state: OperationState
  targetDate?: string | null
  type: OperationType
}
export type InitialAccountState = {
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics?: AccountEconomics
  fees?: FeeEconomics
  lastActivity?: ValuationCycleIdentifier
  lastValuationCycle?: ValuationCycleIdentifier
  note?: NoteEconomics
  operations?: Operation[] | null
  portfolioDefinition?: PortfolioDefinition
  portfolioState?: PortfolioState
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  strategyDefinition?: StrategyDefinition
}
export type ValuationInputType =
  | 'Invalid'
  | 'MarketData'
  | 'MarketDataModifications'
  | 'ModelParameters'
  | 'ExternalView'
  | 'ReplayDefinition'
  | 'Instructions'
  | 'ContractNotes'
export type InformationSource =
  | 'Custodian'
  | 'Distributor'
  | 'HedgingCounterparty'
  | 'Internal'
  | 'PreviousState'
export type JsonBlob = {
  json: string
}
export type ValuationInput = {
  error?: string | null
  origin?: JsonBlob
  originResponse?: JsonBlob
  processingDate?: ValuationCycleIdentifier
  source: InformationSource
  submitted: string
  type: ValuationInputType
}
export type ReplayAudience = 'All' | 'ValuationOnly'
export type ReplayActionType = 'ManualAdjustment' | 'CancelOperation'
export type ReplayAction = {
  actionId: string
  generatedDate: string
  type: ReplayActionType
  valuationDate: string
}
export type ReplayInstructionMethod = 'Inject' | 'Replace' | 'Revoke'
export type ReplayWaitMethodology =
  | 'Default'
  | 'WaitUntilAfterActivity'
  | 'Immediate'
  | 'RejectIfActivity'
export type ReplayReconciliationMethodology = 'Default' | 'RaiseOrders' | 'SuppressOrders'
export type ReplayOperationState = 'New' | 'Deferred' | 'Applied' | 'Rejected'
export type InstructionType =
  | 'Unknown'
  | 'NewAccount'
  | 'Deposit'
  | 'Dividend'
  | 'Withdrawal'
  | 'AccountClosure'
  | 'ExternalTransfer'
  | 'StrategyChange'
  | 'PortfolioChange'
  | 'ProtectedValueChange'
  | 'ProtectionReset'
  | 'ProtectionPortfolioChange'
  | 'NoteChange'
  | 'AncillaryAssetsChange'
  | 'ReinvestmentConfirmation'
  | 'SwitchIn'
  | 'SwitchOut'
  | 'OrderCorrection'
  | 'PortfolioFeeChange'
export type InstructionRevocationFilter = {
  externalId?: string | null
  instructionId?: string | null
  types?: InstructionType[] | null
  valuationCycle?: ValuationCycleIdentifier
}
export type Instruction = {
  instructionId: string
  type: InstructionType
  valuationCycle: ValuationCycleIdentifier
}
export type ReplayInstruction = {
  audience?: ReplayAudience
  method: ReplayInstructionMethod
  reason?: string | null
  reconciliationMethodology?: ReplayReconciliationMethodology
  replacementInstruction?: Instruction
  revocationFilter?: InstructionRevocationFilter
  state: ReplayOperationState
  valuationCycle: ValuationCycleIdentifier
  waitMethodology?: ReplayWaitMethodology
}
export type ReplayedAccountState = {
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics?: AccountEconomics
  fees?: FeeEconomics
  lastActivity?: ValuationCycleIdentifier
  note?: NoteEconomics
  operations?: Operation[] | null
  portfolioDefinition?: PortfolioDefinition
  portfolioState?: PortfolioState
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  strategyDefinition?: StrategyDefinition
}
export type ReplayReconciliationOperation = {
  accountId: string
  operation?: Operation
}
export type InvestmentShares = {
  assetId: string
  shares: number
  value?: number | null
}
export type TransferOperation = {
  cashTransactions?: CashInstrumentTransaction[] | null
  generatedDate: string
  information?: string | null
  operationId: string
  orders?: OrderBatch[] | null
  shares: InvestmentShares[]
  state: OperationState
  targetDate?: string | null
  type: OperationType
}
export type AccountReplayResult = {
  audience?: ReplayAudience
  cancelledOperations?: Operation[] | null
  intermediateStates?: ReplayedAccountState[] | null
  log: string[]
  raiseOrdersImmediately?: boolean
  reconciliationOperations?: ReplayReconciliationOperation[] | null
  replayedAccountState?: ReplayedAccountState
  replayedActions?: ReplayAction[] | null
  replayedInstructions?: ReplayInstruction[] | null
  transfers?: TransferOperation[] | null
}
export type ReconciliationResult = 'Accepted' | 'NotRequired' | 'Deferred' | 'Rejected'
export type ReconciliationWarning = 'None' | 'SignificantDifference'
export type ReconciledAccountState = {
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  economics?: AccountEconomics
  fees?: FeeEconomics
  lastActivity?: ValuationCycleIdentifier
  note?: NoteEconomics
  operations?: Operation[] | null
  portfolioDefinition?: PortfolioDefinition
  portfolioState?: PortfolioState
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  strategyDefinition?: StrategyDefinition
}
export type AccountReconciliationResult = {
  difference?: number | null
  outstandingOperations?: boolean | null
  reason?: string | null
  reconciledAccountState?: ReconciledAccountState
  result: ReconciliationResult
  sharesDifference?: InvestmentShares[] | null
  viewSourceTimeStamp?: string | null
  warning?: ReconciliationWarning
}
export type ComponentChangedState = 'Changed' | 'Unchanged'
export type ExternalContractNote = {
  assetId: string
  confirmedShares: number
  confirmedValue: number
  executedDate: string
  executedFxRate?: number | null
  executedPrice: number
  issuedDate: string
  issuer: ContractNoteIssuer
  orderBatchId: string
  orderId: string
  reference?: string | null
}
export type DealingState = {
  changedState?: ComponentChangedState
  displacedContractNotes?: ContractNote[] | null
  operations?: Operation[] | null
  orphanedContractNotes?: ExternalContractNote[] | null
  overriddenContractNotes?: ExternalContractNote[] | null
}
export type ValuationResultType = 'Primary' | 'Secondary' | 'Replayed'
export type ValuationModelIdentity = {
  modelName: string
  modelVersion: string
}
export type ValuationResultState = 'Accepted' | 'Overridden' | 'Faulted' | 'Rejected'
export type ErrorSource = 'Instruction' | 'MarketData' | 'Valuation' | 'Other'
export type ErrorReason = 'None' | 'UnableToCompleteInstruction'
export type ErrorSeverity = 'Warning' | 'Error' | 'Fatal'
export type ErrorVisibility = 'Private' | 'Public'
export type ValuationError = {
  message: string
  reason?: ErrorReason
  referenceIdentifier?: string | null
  severity: ErrorSeverity
  source: ErrorSource
  visibility?: ErrorVisibility
}
export type DocumentDataType = 'Json' | 'Bson' | 'Xml'
export type ValuationDiagnosticsState = {
  data: string
  dataType: DocumentDataType
}
export type ValuedAccountState = {
  ancillaryAssetsDefinition?: AncillaryAssetsDefinition
  diagnosticState?: ValuationDiagnosticsState
  economics: AccountEconomics
  errors?: ValuationError[] | null
  fees?: FeeEconomics
  lastActivity?: ValuationCycleIdentifier
  note?: NoteEconomics
  operations?: Operation[] | null
  portfolioDefinition?: PortfolioDefinition
  portfolioState?: PortfolioState
  protection?: ProtectionEconomics
  rebalancingStatus?: RebalancingStatus
  resultState: ValuationResultState
  resultType: ValuationResultType
  strategyDefinition?: StrategyDefinition
  timeStamp: string
  valuationModel: ValuationModelIdentity
}
export type ValuationOutputType = 'Generic'
export type ValuationOutput = {
  type: ValuationOutputType
}
export type AccountValuationStage =
  | 'None'
  | 'Creation'
  | 'Fetch'
  | 'InputProcessing'
  | 'Replay'
  | 'Reconciliation'
  | 'Dealing'
  | 'Valuation'
export type AccountValuationBlockError = {
  error: string
  severity: ErrorSeverity
  stage?: AccountValuationStage
  visibility?: ErrorVisibility
}
export type BlockType = 'Default' | 'Genesis' | 'Termination' | 'Invalid'
export type BlockHeader = {
  nonce: string
  number: number
  ommerHash?: string | null
  parentHash: string
  stateRoot: string
  type: BlockType
  version: number
}
export type DocumentState = 'Ok' | 'Revoked' | 'Draft'
export type DocumentMetadata = {
  batchId: string
  created: string
  documentId: string
  modified: string
  state?: DocumentState
  version?: number
}
export type AccountValuationBlock = {
  accountId: string
  blockHeader: BlockHeader
  dealingState?: DealingState
  errors?: AccountValuationBlockError[] | null
  initialState?: InitialAccountState
  inputs?: ValuationInput[] | null
  metadata?: DocumentMetadata
  outputs?: ValuationOutput[] | null
  owners?: AccountOwner[] | null
  reconciliationState?: AccountReconciliationResult
  replayState?: AccountReplayResult
  valuationCycle: ValuationCycleIdentifier
  valuationCycleExpiry: ValuationCycleExpiryIdentifier
  valuationSnap: ValuationSnapIdentifier
  valuationState?: ValuedAccountState
}
export type ApiPerformance = {
  annualisedRollingYtdPerformance?: number | null
  annualisedTotalPerformance?: number | null
  annualisedVolatility?: number | null
  maxDrawdown?: number | null
  realisedVolatility?: number | null
  rollingYtdReturn?: number | null
  sharpeRatio?: number | null
  totalReturn?: number | null
  ytdReturn?: number | null
}
export type ApiAssetDetails = {
  asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset
  assetIsInUse: boolean
  assetUsage: {
    [key: string]: number
  }
  fiveYearPerformance?: ApiPerformance
  oneYearMonthPerformance?: ApiPerformance
  sixMonthPerformance?: ApiPerformance
  threeMonthPerformance?: ApiPerformance
  threeYearPerformance?: ApiPerformance
}
export type ApiAssetDetailsRead = {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  assetIsInUse: boolean
  assetUsage: {
    [key: string]: number
  }
  fiveYearPerformance?: ApiPerformance
  oneYearMonthPerformance?: ApiPerformance
  sixMonthPerformance?: ApiPerformance
  threeMonthPerformance?: ApiPerformance
  threeYearPerformance?: ApiPerformance
}
export type ApiAssetDetailsApiPaginationResult = {
  data: ApiAssetDetails[]
  totalDocuments: number
}
export type ApiAssetDetailsApiPaginationResultRead = {
  data: ApiAssetDetailsRead[]
  totalDocuments: number
}
export type ApiAssetPriceWithOverride = {
  displayName?: string | null
  isManuallyOverridden?: boolean
  price?: number
  receivedDateTime?: string
  source?: string | null
  valueDate?: string
}
export type ApiAssetPriceWithHistory = {
  allPrices?: ApiAssetPriceWithOverride[] | null
  assetName?: string | null
  currency?: string | null
  currentPrice?: ApiAssetPriceWithOverride
  currentValuationCycle?: string
  isinCode?: string | null
  nextValuationCycle?: string
}
export type ApiRenameFundManagerResult = {
  assetIds?: string[] | null
  count?: number
}
export type ApiRenameFundManagerRequest = {
  managementCompanyCode?: string | null
  newName?: string | null
}
export type ApiTradingProviderType = 'FinSwitch' | 'Absa' | 'None'
export type ApiAssetDefaultConfiguration = {
  assetClasses?: string[] | null
  currencies?: string[] | null
  fees?: ApiFee[] | null
}
export type ApiAssetExDates = {
  exDates?: string[] | null
}
export type ApiIndex = {
  assetId: string
  name: string
}
export type ApiAssetWithOrderAlert = {
  asset?: (ApiMutualFundAsset | ApiSegregatedPortfolioAsset) | null
  hasLateOrderConfirmations?: boolean
}
export type ApiAssetWithOrderAlertRead = {
  asset?: (ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead) | null
  hasLateOrderConfirmations?: boolean
}
export type ApiAssetWithOrderAlertApiPaginationResult = {
  data: ApiAssetWithOrderAlert[]
  totalDocuments: number
}
export type ApiAssetWithOrderAlertApiPaginationResultRead = {
  data: ApiAssetWithOrderAlertRead[]
  totalDocuments: number
}
export type EventType =
  | 'DbAdd'
  | 'DbUpdate'
  | 'DbReplace'
  | 'DbDelete'
  | 'PasswordResetRequested'
  | 'PasswordReset'
  | 'ChangePassword'
  | 'UserDetailsChanged'
  | 'EmailChanged'
  | 'UserCreated'
  | 'UserConfirmed'
  | 'UserDisabled'
  | 'UserLockedOut'
  | 'PasswordChanged'
  | 'IncorrectPasswordUsed'
  | 'UserLogInUnsuccessful'
  | 'UserPartiallyLoggedIn'
  | 'UserLoggedIn'
  | 'UserLoggedOut'
  | 'TwoFactorSetup'
  | 'SaveTrade'
  | 'UpdateTrade'
  | 'SubmitTrade'
  | 'ApproveTrade'
  | 'CommitToTrade'
  | 'ActivateTrade'
  | 'RejectTrade'
  | 'ExpireTrade'
  | 'DeleteTrade'
  | 'RevertDraft'
  | 'RemoveDraft'
  | 'DeactivateUser'
  | 'ActivateUser'
  | 'AddExchangeFile'
  | 'CloseTrade'
export type AuditLog = {
  metadata?: DocumentMetadata
  type?: EventType
}
export type ApiLoginUser = {
  password: string
  rememberMe: boolean
  username: string
}
export type SsoConfig = {
  /** Gets the SSO button text. */
  buttonText: string
  /** Gets the UI app/client identifier. */
  clientId: string
  /** Gets the authentication tenant/domain identifier. */
  tenantId: string
}
export type ApiPortfolioManagerCategory = 'None' | 'Cat1' | 'Cat2'
export type ApiAddBusinessUnitUser = {
  email: string
  firstName: string
  lastName: string
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  roles?: string[] | null
}
export type UserStatus = 'Active' | 'Pending' | 'Locked' | 'Inactive' | 'Closed'
export type UserInformationBasic = {
  email: string
  firstName: string
  inactive: boolean
  lastLoginDate?: string | null
  lastName: string
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  roles: string[]
  status: UserStatus
  userId: string
  userName: string
}
export type ApiBusinessUnitWithUsers = {
  businessUnitId: string
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
  users?: UserInformationBasic[] | null
}
export type ApiTransferBusinessUnitOwnershipResult = {
  errors?: string[] | null
  success?: boolean
}
export type ApiTransferBusinessUnitOwnership = {
  fromBusinessUnitId: string
  password: string
  toBusinessUnitId: string
}
export type ApiCashInstrumentBase = {
  currencyIso: string
  instrumentId: string
  name: string
  sharePrecisionScale: number
  type: ApiCashInstrumentType
}
export type ApiLoan = {
  type: 'Loan'
} & ApiCashInstrumentBase & {
    type: ApiCashInstrumentType
  }
export type ApiDeposit = {
  type: 'Deposit'
} & ApiCashInstrumentBase & {
    type: ApiCashInstrumentType
  }
export type ApiZcbCurve = {
  type: 'ZcbCurve'
} & ApiCashInstrumentBase & {
    type: ApiCashInstrumentType
  }
export type ApiCashInstrumentApiPaginationResult = {
  data: (ApiLoan | ApiDeposit | ApiZcbCurve)[]
  totalDocuments: number
}
export type ApiNewBusinessUnit = {
  businessUnitIdOverride?: string | null
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies?: string[] | null
}
export type ApiNewClient = {
  businessUnits: ApiNewBusinessUnit[]
  clientIdOverride?: string | null
  clientName: string
  clientType: ApiClientType
  defaultCashInstruments: ApiClientDefaultCashInstruments
  defaultFees?: ApiClientDefaultFees
  disallowedStrategies?: string[] | null
  reinvestmentType: ApiReinvestmentType
  tradeBuildingSettings: ApiClientTradeBuildingSettings
}
export type ApiClientWithUsers = {
  businessUnits: ApiBusinessUnit[]
  clientId: string
  clientName: string
  clientType: ApiClientType
  defaultCashInstruments: ApiClientDefaultCashInstruments
  defaultFees?: ApiClientDefaultFees
  disallowedStrategies?: string[] | null
  isExternal: boolean
  reinvestmentType: ApiReinvestmentType
  tradeBuildingSettings: ApiClientTradeBuildingSettings
  users?: UserInformationBasic[] | null
}
export type ApiAddClientUser = {
  email: string
  firstName: string
  lastName: string
}
export type ApiAddBusinessUnitToClient = {
  businessUnitName: string
  competency: ApiCompetencyType
  disallowedStrategies: string[]
}
export type ApiCounterparty = {
  counterpartyId: string
  counterpartyName: string
  sdsId: string | null
}
export type ApiValuationModelIdentity = {
  modelName: string
  modelVersion: string
}
export type ApiHolidayCalendar = {
  assumptions: ApiHolidayCalendarAssumptions
  endDate: string
  holidays: string[]
  startDate: string
}
export type ApiFeeDeductionOverride = {
  effectiveCycle: string
  feeDeductionCycle: string
}
export type ApiModelParametersMessage = {
  effectiveCycle: string
  feeDeductionOverrides?: ApiFeeDeductionOverride[] | null
  loanId?: string | null
  loanUnitPrecision?: number | null
  notionalCurrency?: string | null
  notionalPrecision?: number | null
  notionalUnitPrecision?: number | null
  valuationHolidayCalendar?: ApiHolidayCalendar
  valuationModel?: ApiValuationModelIdentity
  vatRate: number
}
export type ExchangeFileType =
  | 'TechnicalAccountSharesTransactions'
  | 'TechnicalAccountCurrencyTransactions'
  | 'OrdersScheduledAggregated'
  | 'OrdersScheduledCounterparty'
  | 'OrdersScheduledSegregatedPortfolioAggregated'
  | 'OrdersScheduledSegregatedPortfolioCounterparty'
  | 'OrdersScheduledFinSwitch'
  | 'OrdersConfirmedAggregated'
  | 'OrdersConfirmedCounterparty'
  | 'OrdersConfirmedFinSwitch'
  | 'OrdersConfirmedSegregatedPortfolioAggregated'
  | 'OrdersConfirmedSegregatedPortfolioCounterparty'
  | 'OrdersLoanScheduledAggregated'
  | 'OrdersLoanScheduledCounterparty'
  | 'OrdersDepositScheduledAggregated'
  | 'OrdersDepositScheduledCounterparty'
  | 'OrdersZcbScheduledAggregated'
  | 'OrdersZcbScheduledCounterparty'
  | 'OrdersDistributionsAggregated'
  | 'OrdersDistributionsCounterparty'
  | 'AssetHoldingsCounterpartyAggregated'
  | 'AssetHoldingsAggregated'
  | 'TechnicalAccountSharesTransactionsHoldings'
  | 'TechnicalAccountCurrencyTransactionsHoldings'
  | 'CurrencyHoldingsAggregated'
  | 'CurrencyHoldingsCounterpartyAggregated'
  | 'LoanHoldingsAggregated'
  | 'LoanHoldingsCounterpartyAggregated'
  | 'PricesMutualFunds'
  | 'PricesSegregatedPortfolios'
  | 'PricesFinSwitch'
  | 'PricesHistoricalFinSwitch'
  | 'FxRatesAlphaVantage'
  | 'DistributionsFinSwitch'
  | 'Curve'
  | 'PricesCurrencyDeposits'
  | 'PricesLoans'
  | 'PricesCurrencyDepositsExport'
  | 'PricesLoansExport'
  | 'PricesIndexes'
  | 'PaymentsFundSettlement'
  | 'PaymentsAccountDeduction'
  | 'PaymentsBankDeduction'
  | 'PaymentsCounterpartyFundDistribution'
  | 'PaymentsTotalFundDistribution'
  | 'PaymentsFeeAccrual'
  | 'PaymentsFeeAccrualGapPremiumExternal'
  | 'PaymentsGapPremium'
  | 'PaymentsGapAmount'
  | 'AssetGapRisk'
  | 'ClientDocumentation'
  | 'ExternalAccountValuations'
  | 'FundsDetails'
  | 'FundsConstituents'
  | 'FundConstituents'
  | 'RiskReport'
  | 'HoldingsReport'
  | 'PaymentsSegregatedPortfolioSettlement'
  | 'OrdersConfirmedSegregatedPortfolioAbsa'
  | 'NoteHoldings'
  | 'NoteStatements'
  | 'NoteTaxReportCapitalGainCsvFull'
  | 'NoteTaxReportCapitalGainJsonFull'
  | 'NoteTaxReportIncomeCsvFull'
  | 'NoteTaxReportIncomeJsonFull'
  | 'NoteTaxReportCapitalGainCsvInterim'
  | 'NoteTaxReportCapitalGainJsonInterim'
  | 'NoteTaxReportIncomeCsvInterim'
  | 'NoteTaxReportIncomeJsonInterim'
  | 'NoteTaxReportCapitalGainCsvYTD'
  | 'NoteTaxReportCapitalGainJsonYTD'
  | 'NoteTaxReportIncomeCsvYTD'
  | 'NoteTaxReportIncomeJsonYTD'
  | 'UnitTransfersFullyAggregated'
  | 'UnitTransfersCounterpartyAggregated'
  | 'OrdersCorrectionFundAggregated'
  | 'OrdersCorrectionFundCounterparty'
  | 'OrdersNoteCounterpartyTransfer'
  | 'FeesCsvReport'
  | 'PortfolioFactSheet'
export type ApiNewDfm = {
  dfmName: string
}
export type ApiDfm = {
  dfmId: string
  dfmName: string
}
export type ApiAddDfmUser = {
  email: string
  firstName: string
  lastName: string
  portfolioManagerCategory: ApiPortfolioManagerCategory
}
export type UserInformationBasicDfm = {
  email: string
  firstName: string
  inactive: boolean
  lastLoginDate?: string | null
  lastName: string
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  roles: string[]
  status: UserStatus
  userId: string
  userName: string
}
export type ApiDfmWithUsers = {
  dfmId: string
  dfmName: string
  users?: UserInformationBasicDfm[] | null
}
export type TaxClassification = 'Yield' | 'Capital'
export type JsonNodeOptions = {
  propertyNameCaseInsensitive?: boolean
}
export type JsonNode = {
  options?: JsonNodeOptions
  parent?: JsonNode
  root?: JsonNode
}
export type TestResult = {
  /** The message. */
  message?: string | null
  /** The name. */
  name?: string | null
  /** True if successful */
  success?: boolean
  /** The value. */
  value?: number
}
export type ApiValuationModelResourceMetadata = {
  isValid: boolean
  modules?: string[] | null
  valuationModelIdentity: string
}
export type TenancyEntry = {
  error?: string | null
  tenantName: string
  valuationModels?: ApiValuationModelResourceMetadata[] | null
}
export type DiagnosticsInformation = {
  loadedAssemblies?: string[] | null
  tenants?: TenancyEntry[] | null
}
export type TenantTimeInformation = {
  currentCycle?: string
  currentSnap?: string
  tenantName?: string | null
}
export type ServiceInformation = {
  applicationTime?: TenantTimeInformation[] | null
  assemblyVersion?: string | null
  currentUser?: string | null
  fileVersion?: string | null
  informationalVersion?: string | null
  publicUri?: string | null
  serverName?: string | null
  smtpHost?: string | null
  systemTime?: string
  webHostEnvironment?: string | null
}
export type ApiLogLevel = 'Verbose' | 'Debug' | 'Information' | 'Warning' | 'Error' | 'Fatal'
export type ApiLogEventSimple = {
  exception?: string | null
  level: ApiLogLevel
  renderedMessage: string
  timestamp: string
}
export type ApiLogRequest = {
  fromTimeExclusive?: string
  levels?: ApiLogLevel[] | null
  toTimeInclusive?: string
}
export type IndexDescription = {
  collectionName?: string | null
  indexName?: string | null
  isUnique?: boolean
  keys?: string | null
  partialFilterExpression?: string | null
}
export type ApiBackUpRequest = {
  fromCreationTimeInclusive: string
  toCreationTimeExclusive: string
}
export type ApiEmailRequest = {
  body?: string | null
  subject?: string | null
  to?: string | null
}
export type ApiDistributionData = {
  amountPerShare: number
  code: string
  declarationDate?: string | null
  distributionType: ApiDistributionType
  exDistributionDate: string
  isCorrection: boolean
  providerType: ApiMarketDataProviderType
  receivedTime: string
  reinvestmentDate?: string | null
}
export type ApiNewReinvestmentConfirmation = {
  assetId: string
  exDate: string
  reinvestmentDate: string
  shares: number
}
export type ApiOrderTradingAgent = 'FinSwitch' | 'Absa'
export type ApiReinvestmentConfirmation = {
  assetId: string
  confirmationId: string
  exDate: string | null
  executedPrice: number | null
  referenceNumber: string | null
  reinvestmentDate: string
  shares: number
  tradingAgent: ApiOrderTradingAgent
  user: string | null
  value: number | null
}
export type ApiExpectedReinvestmentData = {
  assetId: string
  assetPrice: number
  assetPriceScalingFactor: number
  assetPriceValueDate: string
  exDate: string
  expectedReinvestmentUnits: number
  referenceHoldingUnits: number
  scaledDistributions: {
    Capital?: number
    Dividend?: number
    Interest?: number
  }
  totalDistributionAmount: number
}
export type ApiDistributionAlert = {
  assetId: string
  assetName: string
  hasOnlyProviderConfirmation: boolean
  hasOnlyProviderDistribution: boolean
  hasUnassignedConfirmation: boolean
  isConfirmationLate: boolean
  isDistributionLate: boolean
}
export type ApiAccountDocumentationStage =
  | 'Other'
  | 'Draft'
  | 'PendingExecution'
  | 'PendingApproval'
  | 'Final'
export type ApiAccountDocumentationInfo = {
  accountId?: string | null
  fileName?: string | null
  number?: number
  stage?: ApiAccountDocumentationStage
  timestamp?: string
}
export type StreamedResult = object
export type ApiEmailDetails = {
  cc?: string[] | null
  from?: string[] | null
  id: string
  subject?: string | null
  textBody?: string | null
  to?: string[] | null
}
export type ApiNewAggregatedOrderCorrection = {
  assetId: string
  executionPrice: number
  isAppliedToAccounts: boolean
  orderId: string
}
export type ApiNewAggregatedOrderConfirmation = {
  executionPrice: number
  orderId: string
}
export type ApiAggregatedOrderConfirmationState = 'Submitted' | 'Processed' | 'Ignored'
export type ApiAggregatedOrderConfirmation = {
  confirmationAuthor: string
  createdTime: string
  executionPrice: number
  orderConfirmationId: string
  orderId: string
  state: ApiAggregatedOrderConfirmationState
}
export type ApiIndividualOrderSummary = {
  accountName: string
  accountStatus: ApiAccountStatus
  businessUnitName: string
  shares?: number | null
  value?: number | null
}
export type ApiOutstandingAggregatedOrder = {
  assetId: string
  assetName: string
  confirmation?: ApiAggregatedOrderConfirmation
  createdDate: string
  direction: ApiOrderLegDirection
  estimatedPrice: number
  individualOrders: ApiIndividualOrderSummary[]
  isConfirmationLate: boolean
  numberAccounts: number
  orderId: string
  shares?: number | null
  state: ApiOrderLegState
  value?: number | null
}
export type ApiIndividualOrderCorrection = {
  accountId: string
  amount?: number | null
  orderId: string
  shares?: number | null
}
export type ApiAggregatedOrderCorrection = {
  amountToBeAllocated?: number | null
  assetId: string
  correctionAuthor: string
  createdTime: string
  executionPrice: number
  individualOrderCorrections?: ApiIndividualOrderCorrection[] | null
  isAppliedToAccounts: boolean
  isProcessed: boolean
  orderCorrectionId: string
  orderId: string
  sharesToBeAllocated?: number | null
  technicalAccountTransactionId?: string | null
  valuationCycleWhenProcessed?: string | null
}
export type ApiConfirmedAggregatedOrder = {
  assetId: string
  assetName: string
  confirmation?: ApiAggregatedOrderConfirmation
  confirmationAuthor: string
  confirmedDate: string
  correction?: ApiAggregatedOrderCorrection
  createdDate: string
  direction: ApiOrderLegDirection
  executionPrice: number
  individualOrders: ApiIndividualOrderSummary[]
  numberAccounts: number
  orderId: string
  shares?: number | null
  state: ApiOrderLegState
  value?: number | null
}
export type ApiConfirmedAggregatedOrderApiPaginationResult = {
  data: ApiConfirmedAggregatedOrder[]
  totalDocuments: number
}
export type ApiGetNoteExportFilters = {
  clientType?: ApiClientType
  currencyCode?: string | null
  ids?: string[] | null
  isNoteCollateralized?: boolean | null
}
export type ApiNoteData = {
  currentCalculatedNoteSize: number
  newCalculatedNoteTaxClassifications: ApiTaxClassification
  newCurrentCalculatedNoteSize: number
  noteId: string
  noteTaxClassification: ApiTaxClassification
}
export type ApiInstructionSet = {
  deposits?: ApiDepositInstruction[] | null
  portfolioChanges?: ApiPortfolioChangeInstruction[] | null
  switchOutInstructions?: ApiSwitchOutInstruction[] | null
  withdrawals?: ApiWithdrawalInstruction[] | null
}
export type ApiInstructionSetRead = {
  deposits?: ApiDepositInstruction[] | null
  portfolioChanges?: ApiPortfolioChangeInstructionRead[] | null
  switchOutInstructions?: ApiSwitchOutInstruction[] | null
  withdrawals?: ApiWithdrawalInstruction[] | null
}
export type BasicApiResult = {
  errorMessage?: string | null
  success?: boolean
  validationErrors?: string[] | null
}
export type ApiNoteInstructionType = 'Deposit' | 'Withdrawal'
export type ApiNoteInstructionSubmission = {
  accountAmounts: {
    [key: string]: number
  }
  instructionType: ApiNoteInstructionType
  noteId: string
}
export type ApiNoteStatus =
  | 'Active'
  | 'Expired'
  | 'PendingApproval'
  | 'PendingCommitment'
  | 'PendingClientCommitment'
  | 'PendingSettlement'
  | 'PendingActivation'
  | 'Activating'
export type ApiNoteInProgressAssociatedTrade = {
  accountId: string
  accountName: string
  instructionAmount: number
  instructionDocumentNumber: number
}
export type ApiNoteInProgress = {
  associatedTrades: ApiNoteInProgressAssociatedTrade[]
  businessUnitId: string
  canBeRejectedByUser: boolean
  client: string
  counterpartyId: string
  currentValue: number
  dateActionIsRequiredBy?: string | null
  dividendProcessing: ApiDividendProcessing
  endDate?: string | null
  instructionAmount: number
  isCollateralForLoan: boolean
  newValue: number
  noteId: string
  noteName: string
  noteStatus: ApiNoteStatus
  numberActiveTrades: number
  numberClosedTrades: number
  ongoingInstructionType: ApiNoteInstructionType
  startDate: string
  taxClassification: ApiTaxClassification
  taxClassificationBreakDown: {
    Capital?: number
    Yield?: number
  }
}
export type ApiNoteInProgressApiPaginationResult = {
  data: ApiNoteInProgress[]
  totalDocuments: number
}
export type ApiAccountsAndNotesInProgress = {
  numberPendingNoteApprovals: number
  numberPendingTradeApprovals: number
}
export type AddNote = {
  businessUnitId: string
  dividendProcessing: ApiDividendProcessing
  endDate?: string | null
  fees?: ApiFee[] | null
  isCollateralForLoan: boolean
  noteName: string
  startDate: string
}
export type ActionResult = object
export type ChangeNoteApiTaxClassification = {
  newTaxClassification?: ApiTaxClassification
  noteId?: string | null
}
export type GetApiNoteDataAfterInstructions = {
  /** The account identifier. */
  accountId?: string | null
  /** The instructions to apply. */
  apiInstructions?:
    | (
        | ApiNewAccountInstruction
        | ApiDepositInstruction
        | ApiPortfolioChangeInstruction
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )[]
    | null
}
export type GetApiNoteDataAfterInstructionsRead = {
  /** The account identifier. */
  accountId?: string | null
  /** The instructions to apply. */
  apiInstructions?:
    | (
        | ApiNewAccountInstructionRead
        | ApiDepositInstruction
        | ApiPortfolioChangeInstructionRead
        | ApiAccountClosureInstruction
        | ApiWithdrawalInstruction
        | ApiProtectedValueChangeInstruction
        | ApiStrategyChangeInstruction
        | ApiProtectionPortfolioChangeInstruction
        | ApiAncillaryAssetsChangeInstruction
        | ApiSwitchInInstruction
        | ApiSwitchOutInstruction
        | ApiDividendInstruction
        | ApiReinvestmentConfirmationInstruction
        | ApiNoteChangeInstruction
      )[]
    | null
}
export type GetApiNoteTaxClassificationAfterNewAccount = {
  accountId?: string | null
  accountName: string
  depositId?: string | null
  investment?: number | null
  loanId?: string | null
  noteId: string
  portfolioId?: string | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  requestedStartDate?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolio
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  version?: number | null
  zcbInstrumentId?: string | null
}
export type GetApiNoteTaxClassificationAfterNewAccountRead = {
  accountId?: string | null
  accountName: string
  depositId?: string | null
  investment?: number | null
  loanId?: string | null
  noteId: string
  portfolioId?: string | null
  protectionPortfolioWeights?: ApiPortfolioInvestment[] | null
  requestedStartDate?: string | null
  selfSelectPortfolio?: ApiSelfSelectPortfolioRead
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
  strategyTemplateId?: string | null
  switchRequest?: ApiAccountSwitchRequest
  transferUnits?: ApiTransferOfUnits[] | null
  version?: number | null
  zcbInstrumentId?: string | null
}
export type Factor = {
  timestamp?: string
  value?: number
}
export type ApiPerformancePeriod =
  | 'Full'
  | 'SixMonth'
  | 'OneYear'
  | 'ThreeYear'
  | 'FiveYear'
  | 'TenYear'
export type ApiPerformanceResponse = {
  annualisedRollingYtdPerformance: number | null
  annualisedTotalPerformance: number | null
  annualisedVolatility: number | null
  maxDrawdown: number | null
  period: ApiPerformancePeriod
  realisedVolatility: number | null
  rollingYtdReturn: number | null
  sharpeRatio: number | null
  totalReturn: number | null
  ytdReturn: number | null
}
export type ApiAssetPerformanceResponse = {
  assetId: string
  performance: ApiPerformanceResponse[] | null
  weight: number
}
export type ApiBacktestResponse = {
  assetPerformance: ApiAssetPerformanceResponse[]
  backtestTimeseries: Factor[]
  portfolioPerformance: ApiPerformanceResponse
}
export type ApiBacktestRequest = {
  accountId?: string | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
}
export type ApiProjectionResponse = {
  percentile20UnitisedPriceTimeseries: Factor[]
  percentile50UnitisedPriceTimeseries: Factor[]
  percentile80UnitisedPriceTimeseries: Factor[]
}
export type ApiProjectionRequest = {
  accountId?: string | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
}
export type ApiTradeBacktestResponse = {
  backtestTimeseries: Factor[]
  tradePerformance: ApiPerformanceResponse
}
export type ApiTradePerformanceCalculation = {
  accountId?: string | null
  depositId?: string | null
  loanId?: string | null
  noteId?: string | null
  portfolioInvestment?: ApiPortfolioInvestment[] | null
  protectionWeights?: ApiPortfolioInvestment[] | null
  strategy?:
    | (ApiPassThroughStrategy | ApiCppiStrategy | ApiTippStrategy | ApiVolControlStrategy)
    | null
}
export type ApiNewPortfolio = {
  allowedBusinessUnitIds?: string[] | null
  dateAdded?: string | null
  disallowedStrategies?: string[] | null
  fees?: ApiFee[] | null
  investmentWeights?: ApiPortfolioInvestment[] | null
  multiplier?: number | null
  portfolioName?: string | null
  portfolioOwnerId?: string | null
  portfolioType?: ApiPortfolioType
  rebalancingDefinition: ApiRebalancingDefinition
  startDate?: string | null
  targetWeights: ApiPortfolioInvestment[]
}
export type ApiModelPortfolioMinimal = {
  disallowedStrategies?: string[] | null
  portfolioId: string
  portfolioName?: string | null
  portfolioType?: ApiPortfolioType
  taxClassification?: ApiTaxClassification
}
export type ApiModelPortfolioApiPaginationResult = {
  data: ApiModelPortfolio[]
  totalDocuments: number
}
export type ApiModelPortfolioApiPaginationResultRead = {
  data: ApiModelPortfolioRead[]
  totalDocuments: number
}
export type ApiPortfolioStatusFilter = 'All' | 'Active' | 'Inactive'
export type ApiModelPortfolioUsage = {
  portfolioId: string
  totalValue: number
  totalValueByBusinessUnit: {
    [key: string]: number
  }
  totalValueByClient: {
    [key: string]: number
  }
}
export type ApiCalculatedPortfolioMultiplier = {
  multiplier: number
}
export type ApiFxData = {
  currencyPair: string
  spotDate: string
  spotRate: number
}
export type HoldingReconciliationReportEntry = {
  assetId?: string | null
  assetName?: string | null
  executionAgent?: string | null
  executionAgentHoldings?: number
  internalHoldings?: number
  lastAssetPrice?: number | null
}
export type HoldingReconciliationReport = {
  entries?: HoldingReconciliationReportEntry[] | null
  metadata?: DocumentMetadata
  reportType: string
  reportVersion?: string | null
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
}
export type AssetConcentrationReportEntry = {
  amountInvestedWithGapRisk?: number
  amountInvestedWithoutGapRisk?: number
  assetClass?: string | null
  assetCurrency?: string | null
  assetId?: string | null
  assetName?: string | null
  aum?: number | null
  currency?: string | null
  fundManager?: string | null
  totalInFlightSellOrdersAmount?: number | null
}
export type AssetConcentrationReportEntryRead = {
  amountInvestedTotal?: number
  amountInvestedWithGapRisk?: number
  amountInvestedWithoutGapRisk?: number
  assetClass?: string | null
  assetCurrency?: string | null
  assetId?: string | null
  assetName?: string | null
  aum?: number | null
  currency?: string | null
  fundManager?: string | null
  totalInFlightSellOrdersAmount?: number | null
}
export type AssetConcentrationReport = {
  entries?: AssetConcentrationReportEntry[] | null
  metadata?: DocumentMetadata
  reportType: string
  reportVersion?: string | null
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
}
export type AssetConcentrationReportRead = {
  entries?: AssetConcentrationReportEntryRead[] | null
  metadata?: DocumentMetadata
  reportType: string
  reportVersion?: string | null
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
}
export type MaxDrawdownReportEntryType =
  | 'MutualFund'
  | 'Equity'
  | 'SegregatedPortfolio'
  | 'ModelPortfolio'
  | 'FundManager'
export type AssetProtectionClassification = 'Performance' | 'Protection'
export type MaxDrawdownReportEntry = {
  fundManager?: string | null
  gapPutStrike?: number | null
  isTherePosition?: boolean
  itemId?: string | null
  itemName?: string | null
  itemType?: MaxDrawdownReportEntryType
  maxDrawdown1D?: number | null
  maxDrawdown1M?: number | null
  maxDrawdown1W?: number | null
  maxDrawdown1Y?: number | null
  maxDrawdown3D?: number | null
  protectionClassification?: AssetProtectionClassification
}
export type MaxDrawdownReport = {
  entries?: {
    Equity?: MaxDrawdownReportEntry[]
    FundManager?: MaxDrawdownReportEntry[]
    ModelPortfolio?: MaxDrawdownReportEntry[]
    MutualFund?: MaxDrawdownReportEntry[]
    SegregatedPortfolio?: MaxDrawdownReportEntry[]
  } | null
  metadata?: DocumentMetadata
  reportType: string
  reportVersion?: string | null
  valuationCycle: ValuationCycleIdentifier
  valuationSnap: ValuationSnapIdentifier
}
export type ApiGapRiskInfo = {
  cushion?: number | null
  fundMultipliers?: {
    [key: string]: number
  } | null
  gapPutStrike?: number | null
  grossTradeValue?: number
  impliedMultiplier?: number | null
  isRebalancingTakingPlace?: boolean
  loanAmount?: number
  protectedAmount?: number
  riskFreeAssetCurrentAllocation?: number
  riskFreeAssetTargetAllocation?: number | null
  riskyAssetCurrentAllocation?: number
  riskyAssetTargetAllocation?: number | null
  targetMultiplier?: number | null
}
export type ApiGapRiskInfoRead = {
  checkCalculation?: number | null
  cushion?: number | null
  fundMultipliers?: {
    [key: string]: number
  } | null
  gapPutStrike?: number | null
  grossTradeValue?: number
  impliedMultiplier?: number | null
  isRebalancingTakingPlace?: boolean
  loanAmount?: number
  netTradeValue?: number
  protectedAmount?: number
  ratioImpliedMultiplierOverTargetMultiplier?: number | null
  riskFreeAssetCurrentAllocation?: number
  riskFreeAssetTargetAllocation?: number | null
  riskyAssetCurrentAllocation?: number
  riskyAssetTargetAllocation?: number | null
  targetMultiplier?: number | null
}
export type ApiOverrideInfo = {
  areOverridesAllowed?: boolean
  currentTime?: string
  noOverrideEndTime?: string | null
  noOverrideStartTime?: string | null
}
export type ApiMarketAumValue = {
  aum?: number
  code: string
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiAssetMarketDataPrice = {
  code: string
  price: number
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiFxRateQuote = {
  currencyBase: string
  currencyCounter: string
  providerType: ApiMarketDataProviderType
  receivedTime: string
  spotRate: number
  valueDate: string
}
export type ApiCurrencyDepositMarketDataPrice = {
  code: string
  price: number
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiLoanMarketDataPrice = {
  code: string
  price: number
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiIndexMarketDataPrice = {
  code: string
  price: number
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiConstituentAsset = {
  amountInvestedWithGapRisk?: number | null
  amountInvestedWithoutGapRisk?: number | null
  aum?: number | null
  currency?: string | null
  instrumentCode?: string | null
  instrumentLongName?: string | null
  isin?: string | null
  region?: string | null
  sector?: string | null
  type?: string | null
  weight?: number | null
}
export type ApiAssetConstituency = {
  code: string
  constituents: ApiConstituentAsset[]
  providerType: ApiMarketDataProviderType
  receivedTime: string
  valueDate: string
}
export type ApiMarketDataSet = {
  assetConstituencies: ApiAssetConstituency[] | null
  assetPrices: ApiAssetMarketDataPrice[] | null
  aumValues: ApiMarketAumValue[] | null
  currencyDepositPrices: ApiCurrencyDepositMarketDataPrice[] | null
  distributions: ApiDistributionData[] | null
  fxRates: ApiFxRateQuote[] | null
  indexPrices: ApiIndexMarketDataPrice[] | null
  loanPrices: ApiLoanMarketDataPrice[] | null
  providerType: ApiMarketDataProviderType
}
export type ApiMarketDataSetRequest = {
  fromCreationTimeInclusive: string
  toCreationTimeExclusive: string
}
export type ApiOverridenAssetPrice = {
  isinCode?: string | null
  newPrice?: number
  overrideAuthor?: string | null
  overrideAuthorDisplayName?: string | null
  overrideDateTime?: string
  valuationCycle?: string
  valueDate?: string
}
export type ApiAssetPriceUserOverride = {
  isinCode?: string | null
  priceOverride?: number
}
export type ApiAssetWithConstituents = {
  assetId: string
  assetName: string
  constituentAssets?: ApiConstituentAsset[] | null
  currency: string
}
export type ApiAssetPrice = {
  effectiveDate?: string | null
  estimate?: boolean
  midPrice: number
  priceDate: string
}
export type ApiDistributionInfo = {
  amountPerShare: number
  exDividendDate: string
  reinvestmentDate?: string | null
}
export type ApiAssetData = {
  assetId: string
  nextDistribution: ApiDistributionInfo
  protectionClassification?: ApiAssetProtectionClassification
  publishedPrices: ApiAssetPrice[]
}
export type ApiIndexData = {
  assetId: string
  prices: ApiAssetPrice[]
  publicationCalendar?: ApiHolidayCalendar
}
export type ApiCurrencyPrice = {
  price: number
  priceDate: string
}
export type ApiCurrencyData = {
  currency?: string | null
  publishedPrices: ApiCurrencyPrice[]
}
export type ApiLoanPrice = {
  price: number
  priceDate: string
}
export type ApiLoanData = {
  loanId?: string | null
  publishedPrices: ApiLoanPrice[]
}
export type ApiCurvePoint = {
  ask?: number | null
  bid?: number | null
  date: string
}
export type ApiZcbCurveData = {
  points: ApiCurvePoint[]
  zcbInstrumentId?: string | null
}
export type ApiInvestmentShares = {
  assetId: string
  shares: number
}
export type ApiFundOfFundsData = {
  investmentWeights?: InvestmentWeight[] | null
  portfolioId: string
  theoreticalFundUnits?: ApiInvestmentShares[] | null
}
export type ApiMarketDataSnapshot = {
  assets?: ApiAssetData[] | null
  currencies?: ApiCurrencyData[] | null
  fundOfFunds?: ApiFundOfFundsData[] | null
  fx?: ApiFxData[] | null
  indexes?: ApiIndexData[] | null
  loans?: ApiLoanData[] | null
  snap: string
  zcbCurves?: ApiZcbCurveData[] | null
}
export type ApiGapPayments = {
  clientId?: string | null
  clientName?: string | null
  counterPartyId?: string | null
  gapAmount?: number
}
export type HoldingsAndTransferBalancesReconciliationEntry = {
  assetId?: string | null
  assetName?: string | null
  availableTransferBalance?: number
  executionAgentHoldings?: number
  fundCode?: string | null
  internalHoldings?: number
}
export type HoldingsAndTransferBalancesReconciliation = {
  entries?: HoldingsAndTransferBalancesReconciliationEntry[] | null
}
export type AllAssetsLadderScenarioConfiguration = {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}
export type ScenarioCoordinate = {
  bump: number
  label?: string | null
}
export type ScenarioPoint = {
  coordinate?: ScenarioCoordinate
  value?: number
}
export type AllAssetsLadderScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: ScenarioPoint[] | null
}
export type AllAssetsLadderScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: ScenarioPoint[] | null
}
export type SingleAssetLadderScenarioConfiguration = {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}
export type SingleAssetLadderScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioPoint[] | null
  } | null
}
export type SingleAssetLadderScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioPoint[] | null
  } | null
}
export type SingleAssetDrawdownScenarioConfiguration = {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}
export type ScenarioVector = {
  coordinate?: ScenarioCoordinate
  points?: ScenarioPoint[] | null
}
export type SingleAssetDrawdownScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type SingleAssetDrawdownScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type FundManagerLadderScenarioConfiguration = {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}
export type FundManagerLadderScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioPoint[] | null
  } | null
}
export type FundManagerLadderScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioPoint[] | null
  } | null
}
export type FundManagerDrawdownScenarioConfiguration = {
  ladder?: number[] | null
  metadata?: DocumentMetadata
}
export type FundManagerDrawdownScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type FundManagerDrawdownScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type CustomAssetScenarioConfiguration = {
  metadata?: DocumentMetadata
  otherAssetsLadder?: number[] | null
  singleAssetLadder?: number[] | null
}
export type CustomAssetScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type CustomAssetScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type CustomFundManagerScenarioConfiguration = {
  metadata?: DocumentMetadata
  otherFundManagersLadder?: number[] | null
  singleFundManagerLadder?: number[] | null
}
export type CustomFundManagerScenarioResult = {
  metadata?: DocumentMetadata
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type CustomFundManagerScenarioResultRead = {
  creationTime?: string
  metadata?: DocumentMetadata
  scenarioName?: string | null
  valuationCycle?: ValuationCycleIdentifier
  values?: {
    [key: string]: ScenarioVector[] | null
  } | null
}
export type ApiTaskState = 'Scheduled' | 'Started' | 'Failed' | 'Succeeded'
export type ApiTaskLog = {
  logId?: string | null
  logTime?: string
  message?: string | null
  taskExecutionId?: string | null
  taskInstanceKey?: string | null
  taskName?: string | null
  taskState?: ApiTaskState
  valuationCycle?: string
  valuationSnap?: string
}
export type ApiTaskExecution = {
  endLog?: ApiTaskLog
  firstUpdateTime?: string
  lastUpdateTime?: string
  scheduleLog?: ApiTaskLog
  startLog?: ApiTaskLog
  taskExecutionId?: string
  taskInstanceKey?: string | null
  taskName?: string | null
  taskState?: ApiTaskState
}
export type ApiValuationCycleSpecification = 'Daily'
export type ApiIdentifierSetting = {
  idPaddingLength?: number
  idPrefix?: string | null
  lastUpdateTime?: string
  nextId?: number
}
export type ApiIdentifierConfiguration = {
  accountSettings?: ApiIdentifierSetting
  noteSettings?: ApiIdentifierSetting
  portfolioSettings?: ApiIdentifierSetting
}
export type ApiNoteDefaultConfiguration = {
  counterPartyIds?: string[] | null
}
export type ApiTradeConfiguration = {
  assetDefaultConfiguration?: ApiAssetDefaultConfiguration
  cashInstrumentReferenceRates?: string[] | null
  cleanupEnabled?: boolean | null
  daysToCommitToTrade: number
  identifierConfiguration?: ApiIdentifierConfiguration
  instructionsNotRequiringFullApproval?: ApiInstructionType[] | null
  newInformationExpiry: string
  noteDefaultConfiguration?: ApiNoteDefaultConfiguration
  numberOfMonteCarloProjectionPaths?: number | null
  pickupDirectory?: string | null
  pipelineDefinitionName: string
  technicalAccountDepositId: string
  tradeIdentifier: string
  valuationCycleExpiry: string
  valuationCycleOffset?: string | null
  valuationCycleOverride?: string | null
  valuationCycleSpecification: ApiValuationCycleSpecification
  valuationCycleTimeZone: string
  valuationEnabled?: boolean | null
  valuationLookbackDays?: number | null
  valuationSnapOverride?: string | null
  virtualPrecision: number
}
export type ApiTaskTriggerType = 'Completion' | 'Periodic'
export type ApiTaskTriggerBase = {
  type: ApiTaskTriggerType
}
export type ApiTaskCompletionDependency = {
  daysLag: number
  taskName: string
}
export type ApiCompletionTriggerType = 'OncePerDay' | 'AfterEachCompletion'
export type ApiTaskTriggerCompletion = {
  type: 'Completion'
} & ApiTaskTriggerBase & {
    completionTriggerType: ApiCompletionTriggerType
    dependencies: ApiTaskCompletionDependency[]
    type: ApiTaskTriggerType
  }
export type ApiTaskTriggerPeriodic = {
  type: 'Periodic'
} & ApiTaskTriggerBase & {
    cronExpressions: string[]
    timeZone: string
    type: ApiTaskTriggerType
  }
export type ApiTaskRetryPolicy = {
  numberRetries: number
  waitTimeBetweenRetries: string | null
}
export type ApiTaskPriority = 'VeryLow' | 'Low' | 'Medium' | 'High' | 'VeryHigh'
export type ApiTaskDefinition = {
  description: string | null
  isTaskEnabled: boolean
  priority: ApiTaskPriority
  taskName: string
  taskRetryPolicy: ApiTaskRetryPolicy
  taskTimeOut: string | null
  taskTrigger: ApiTaskTriggerCompletion | ApiTaskTriggerPeriodic
  taskType: string
}
export type ApiTaskCalculationGraph = {
  delayBetweenTaskExecutorRuns: string
  delayBetweenTaskHouseKeepingManagerRuns?: string
  delayBetweenTaskSchedulerRuns: string
  executorTimeOut?: string
  maximumNumberDaysToKeepTaskLogs: number
  maximumNumberMissedHeartbeats: number
  schedulerTimeOut: string
  taskDefinitions: ApiTaskDefinition[]
}
export type ApiSchedulingConfiguration = {
  calculationGraph?: ApiTaskCalculationGraph
  isTaskCalculationGraphEnabled: boolean
}
export type ApiFinSwitchConfiguration = {
  address: string
  bulkedInvestorCode: string
  companyCode: string
  login: string
  maximumNumberOfCalendarDaysInRequest: number
  minimumNumberSecondsBetweenCalls: number
  password: string
  useIsoCurrencyCodes?: boolean | null
}
export type ApiAlphaVantageConfiguration = {
  key: string
  urlFx: string
}
export type ApiSnapshotBuilderConfiguration = {
  lengthAssetTimeSeries: number
  lengthAumValueTimeSeries: number
  lengthCurrencyTimeSeries: number
  lengthLoanTimeSeries: number
}
export type ApiPaymentsConfiguration = {
  bankDeductionPaymentLag: number
  clientDepositsPaymentLag: number
  clientWithdrawalsPaymentLag: number
  fundSettlementBuyPaymentLag: number
  fundSettlementSellPaymentLag: number
  gapAmountPaymentLag: number
  gapPremiumPaymentLag: number
}
export type ApiExternalAccountValuationsSource = {
  fakeClient: ApiClient
  fakeNote: ApiNote
  isEnabled: boolean
  login: string
  password: string
  source?: ApiSource
  url: string
}
export type ApiExternalAccountValuationsSourcesConfiguration = {
  externalSources: ApiExternalAccountValuationsSource[] | null
}
export type ApiFrontendConfiguration = {
  allowTradeBuilder: boolean
}
export type ApiMarketDataConfiguration = {
  marketDataCutOffBeforeValuationCycleExpiry: string | null
}
export type ApiPricingModelConfiguration = {
  gapRiskPricingPaths: number
  maxTermSimulationYears?: number | null
  rebalanceDays?: number | null
  rollingSimulationYears?: number | null
  volatility?: number | null
}
export type ApiTimeWithTimeZone = {
  dailyTime?: string | null
  timeZone?: string | null
}
export type ApiSystemTimesConfiguration = {
  afterGapRiskIsReady?: ApiTimeWithTimeZone
  afterReportsHaveRun?: ApiTimeWithTimeZone
  afterTheFinSwitchOrdersAreProcessed?: ApiTimeWithTimeZone
  justAfterAbsaHasUploadedOrderConfirmations?: ApiTimeWithTimeZone
  justAfterTheFinSwitchOrdersAreDownloaded?: ApiTimeWithTimeZone
  justAfterTheMarketDataSnapshotIsCreated?: ApiTimeWithTimeZone
  justBeforeTheFinSwitchOrdersAreDownloaded?: ApiTimeWithTimeZone
  justBeforeTheMarketDataSnapshotIsCreated?: ApiTimeWithTimeZone
  marketDataOverrideAllowedPostCutOffTime: ApiTimeWithTimeZone
  marketDataOverrideAllowedPostStartTime: ApiTimeWithTimeZone
}
export type ApiEmailAlert = {
  emailAddress: string | null
  isEnabled: boolean
}
export type ApiAlertsConfiguration = {
  gapEventAlert: ApiEmailAlert
  lateDistributionAlert: ApiEmailAlert
  lateOrderConfirmationAlert: ApiEmailAlert
  missingMarketDataAlert: ApiEmailAlert
}
export type ApiTenantConfiguration = {
  alertsConfiguration?: ApiAlertsConfiguration
  alphaVantageConfiguration: ApiAlphaVantageConfiguration
  externalAccountValuationsSourcesConfiguration: ApiExternalAccountValuationsSourcesConfiguration
  finSwitchConfiguration: ApiFinSwitchConfiguration
  frontendConfiguration?: ApiFrontendConfiguration
  marketDataConfiguration?: ApiMarketDataConfiguration
  paymentsConfiguration: ApiPaymentsConfiguration
  pricingModelConfiguration?: ApiPricingModelConfiguration
  schedulingConfiguration: ApiSchedulingConfiguration
  snapshotBuilderConfiguration: ApiSnapshotBuilderConfiguration
  systemTimesConfiguration?: ApiSystemTimesConfiguration
  tenantName: string
  tradeConfiguration: ApiTradeConfiguration
}
export type ImportTenantCommand = {
  /** The base path for imports. */
  basePath?: string | null
  /** Set to true to first drop the collection before import. */
  drop?: boolean
  /** The import name. */
  name?: string | null
  /** The tenant name. */
  tenant?: string | null
}
export type DecimalDecimalTuple = {
  item1?: number
  item2?: number
}
export type ApiNewStrategyTemplate = {
  defaultHighWatermarkObservationFrequency?: ApiObservationFrequency
  defaultLeverageRatio?: number | null
  defaultProtectionLevel?: number | null
  defaultTargetVolatility?: number | null
  highWatermarkObservationFrequency?: ApiObservationFrequency
  leverageRatio?: number | null
  maxLeverageRatio?: number | null
  maxNumberOfMonthsToTimeToMaturity?: number | null
  maxProtectionLevel?: number | null
  maxTargetVolatility?: number | null
  minLeverageRatio?: number | null
  minNumberOfMonthsToTimeToMaturity?: number | null
  minProtectionLevel?: number | null
  minTargetVolatility?: number | null
  protectionAssetId?: string | null
  protectionLevel?: number | null
  shortCircuitMaxAllocation?: number | null
  shortCircuitReducedMultiplier?: number | null
  sortOrder?: number
  strategyName: string
  strategyTemplateIdOverride?: string | null
  strategyType: ApiStrategyType
  targetVolatility?: number | null
  targetVolatilityMappings?: DecimalDecimalTuple[] | null
  volatilityIndexTriggerLevel?: number | null
}
export type ApiStrategyTemplate = {
  defaultHighWatermarkObservationFrequency?: ApiObservationFrequency
  defaultLeverageRatio?: number | null
  defaultProtectionLevel?: number | null
  defaultTargetVolatility?: number | null
  highWatermarkObservationFrequency?: ApiObservationFrequency
  leverageRatio?: number | null
  maxLeverageRatio?: number | null
  maxNumberOfMonthsToTimeToMaturity?: number | null
  maxProtectionLevel?: number | null
  maxTargetVolatility?: number | null
  minLeverageRatio?: number | null
  minNumberOfMonthsToTimeToMaturity?: number | null
  minProtectionLevel?: number | null
  minTargetVolatility?: number | null
  protectionAssetId?: string | null
  protectionLevel?: number | null
  shortCircuitMaxAllocation?: number | null
  shortCircuitReducedMultiplier?: number | null
  sortOrder?: number
  strategyName: string
  strategyTemplateId: string
  strategyType: ApiStrategyType
  targetVolatility?: number | null
  targetVolatilityMappings?: DecimalDecimalTuple[] | null
  volatilityIndexTriggerLevel?: number | null
}
export type ConfigurationType =
  | 'AlphaAdvantage'
  | 'ExternalValuationSources'
  | 'FinSwitch'
  | 'FrontEnd'
  | 'MarketData'
  | 'Payments'
  | 'PricingModel'
  | 'Recaptcha'
  | 'Reconciliation'
  | 'Scheduling'
  | 'Security'
  | 'SnapshotBuilding'
  | 'SystemTimes'
  | 'Trade'
  | 'Alerts'
export type ValuationCycleSpecification = 'Daily'
export type IdentifierSetting = {
  idPaddingLength?: number
  idPrefix?: string | null
  lastUpdateTime?: string
  nextId?: number
}
export type IdentifierConfiguration = {
  accountSettings?: IdentifierSetting
  noteSettings?: IdentifierSetting
  portfolioSettings?: IdentifierSetting
}
export type NoteDefaultConfiguration = {
  counterPartyIds?: string[] | null
}
export type AssetDefaultConfiguration = {
  assetClasses?: string[] | null
  currencies?: string[] | null
  fees?: Fee[] | null
}
export type TradeConfiguration = {
  assetDefaultConfiguration?: AssetDefaultConfiguration
  cashInstrumentReferenceRates?: string[] | null
  cleanupEnabled?: boolean | null
  daysToCommitToTrade?: number
  identifierConfiguration?: IdentifierConfiguration
  instructionsNotRequiringFullApproval?: InstructionType[] | null
  metadata?: DocumentMetadata
  newInformationExpiry?: string | null
  noteDefaultConfiguration?: NoteDefaultConfiguration
  numberOfMonteCarloProjectionPaths?: number | null
  pickupDirectory?: string | null
  pipelineDefinitionName?: string | null
  technicalAccountDepositId?: string | null
  tradeIdentifier?: string | null
  type?: ConfigurationType
  valuationCycleExpiry?: string
  valuationCycleOffset?: string | null
  valuationCycleOverride?: string | null
  valuationCycleSpecification?: ValuationCycleSpecification
  valuationCycleTimeZone?: string | null
  valuationEnabled?: boolean | null
  valuationLookbackDays?: number | null
  valuationSnapOverride?: string | null
  virtualPrecision?: number
}
export type TaskTriggerType = 'Completion' | 'Periodic'
export type TaskTrigger = {
  type: TaskTriggerType
}
export type TaskRetryPolicy = {
  numberRetries: number
  waitTimeBetweenRetries: string | null
}
export type TaskPriority = 'VeryLow' | 'Low' | 'Medium' | 'High' | 'VeryHigh'
export type TaskDefinition = {
  description: string | null
  isTaskEnabled: boolean
  priority: TaskPriority
  taskName: string
  taskRetryPolicy: TaskRetryPolicy
  taskTimeOut: string | null
  taskTrigger: TaskTrigger
  taskType: string
}
export type TaskCalculationGraph = {
  delayBetweenTaskExecutorRuns?: string
  delayBetweenTaskHouseKeepingManagerRuns?: string
  delayBetweenTaskSchedulerRuns?: string
  executorTimeOut?: string
  maximumNumberDaysToKeepTaskLogs?: number
  maximumNumberMissedHeartbeats?: number
  schedulerTimeOut?: string
  taskDefinitions?: TaskDefinition[] | null
}
export type SchedulingConfiguration = {
  calculationGraph?: TaskCalculationGraph
  isTaskCalculationGraphEnabled?: boolean
  metadata?: DocumentMetadata
  type?: ConfigurationType
}
export type ApiTimeOverrideStatus = {
  valuationCycleOverride: string
  valuationSnapOverride: string
}
export type ReconciliationConfiguration = {
  activePremiumRelativeTolerance?: number | null
  assetAbsoluteMagnitudeTolerance?: number | null
  metadata?: DocumentMetadata
  overallAbsoluteMagnitudeTolerance?: number | null
  protectedValueRelativeTolerance?: number | null
  type?: ConfigurationType
}
export type ApiReconciliationConfiguration = {
  activePremiumRelativeTolerance?: number | null
  assetAbsoluteMagnitudeTolerance?: number | null
  overallAbsoluteMagnitudeTolerance?: number | null
  protectedValueRelativeTolerance?: number | null
}
export type ApiAccountUserDetails = {
  email: string
  emailConfirmed: boolean
  externalLogins: string[]
  hasAuthenticator: boolean
  phoneNumber: string | null
  recoveryCodesLeft: number
  twoFactorClientRemembered: boolean
  twoFactorEnabled: boolean
  username: string
}
export type IdentityError = {
  code?: string | null
  description?: string | null
}
export type ApiAuthenticatorDetails = {
  authenticatorUri: string
  errors: IdentityError[] | null
  sharedKey: string
}
export type ApiResultStatus = 'Success' | 'Error'
export type ApiResult = {
  data: any | null
  message: string | null
  status: ApiResultStatus
}
export type ApiResetAuthenticator = {
  userID: string
}
export type ApiVerifyAuthenticator = {
  verificationCode: string
}
export type ApiTwoFactorLoginUser = {
  isRecovery: boolean
  verificationCode: string
}
export type ApiSetTwoFactorEnabled = {
  enabled: boolean
  userId: string
}
export type ApiOrganisationType =
  | 'Unknown'
  | 'Administrator'
  | 'Bank'
  | 'Client'
  | 'BusinessUnit'
  | 'Dfm'
export type ApiOrganisation = {
  organisationId: string
  organisationName: string
  organisationType: ApiOrganisationType
}
export type UserInformation = {
  clients: ApiClient[]
  dfms: ApiDfm[]
  email: string
  emailConfirmed: boolean
  firstName: string
  inactive: boolean
  isLockedOut: boolean
  lastLoginDate?: string | null
  lastName: string
  organisation: ApiOrganisation
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  roles: string[]
  status: UserStatus
  twoFactorEnabled: boolean
  userId: string
  userName: string
}
export type ApiEditUser = {
  firstName: string
  lastName: string
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  rolesToAdd?: string[] | null
  rolesToRemove?: string[] | null
  userName: string
}
export type NewUserCommand = {
  email: string
  firstName: string
  lastName: string
  organisation: ApiOrganisation
  password: string
  portfolioManagerCategory?: ApiPortfolioManagerCategory
  requiresConfirmation: boolean
  requiresTwoFactor: boolean
  roles: string[]
  userName: string
}
export type ApiConfirmEmailResult = {
  passwordResetToken: string | null
  userAlreadyOnBoarded: boolean
  userId: string
}
export type ApiConfirmEmail = {
  confirmEmailToken: string
  userId: string
}
export type ApiOnboardingDetails = {
  confirmEmailToken: string
  newPassword: string
  userId: string
}
export type ApiRecaptchaConfiguration = {
  disabled?: boolean
}
export type ApiForgotPassword = {
  email: string
  recaptchaResponse: string | null
  remoteIP: string | null
}
export type ResetPasswordCommand = {
  password: string
  token: string
  userId: string
}
export type ChangePasswordCommand = {
  newPassword: string
  oldPassword: string
  userName: string
}
export type AddUserRoleCommand = {
  role: string
  userName: string
}
export type RemoveUserFromRoleCommand = {
  role: string
  userName: string
}
export type GetUserNameResponse = {
  userName: string
}
export type GetUserNameCommand = {
  firstName: string
  lastName: string
}
export type IndexStatus = 'None' | 'Ready' | 'Expired'
export type ValuationIndexStatus = {
  metadata?: DocumentMetadata
  status: IndexStatus
  valuationSnap: ValuationSnapIdentifier
}
export type ReportingStatus = 'None' | 'Ready' | 'Expired'
export type ValuationReportingStatus = {
  metadata?: DocumentMetadata
  reportType: string
  status: ReportingStatus
  valuationSnap: ValuationSnapIdentifier
}
export const {
  useDeleteByTenantClientAndClientIdBusinessUnitsBusinessUnitIdMutation,
  useDeleteSetupExportsByNameMutation,
  useDeleteUsermanagerRemoveByUsernameMutation,
  useGetAuthAuthConfigJsQuery,
  useGetByTenantAccountAllaccountdetailsQuery,
  useGetByTenantAccountAndAccountSourceAccountIdentifierQuery,
  useGetByTenantAccountDashboardQuery,
  useGetByTenantAccountExportPendingfeesQuery,
  useGetByTenantAccountFirstaccountdateQuery,
  useGetByTenantAccountInprogressAndAccountIdentifierQuery,
  useGetByTenantAccountInprogressQuery,
  useGetByTenantAccountQuery,
  useGetByTenantAccountRunningQuery,
  useGetByTenantAccountSnapshotsAndAccountSourceAccountIdentifierLatestQuery,
  useGetByTenantAccountSnapshotsAndDateQuery,
  useGetByTenantAccountSnapshotsRangeAndAccountSourceAccountIdStartDateEndDateQuery,
  useGetByTenantAccountStaticAndAccountNameQuery,
  useGetByTenantAccountStaticQuery,
  useGetByTenantAccountSummaryAndAccountSourceAccountIdentifierQuery,
  useGetByTenantAssetAndAssetIdDetailsQuery,
  useGetByTenantAssetAndAssetIdHistoryQuery,
  useGetByTenantAssetAndAssetIdQuery,
  useGetByTenantAssetDefaultsQuery,
  useGetByTenantAssetIndexesQuery,
  useGetByTenantAssetListOrderAlertQuery,
  useGetByTenantAssetListQuery,
  useGetByTenantAssetMutualfundsQuery,
  useGetByTenantAssetQuery,
  useGetByTenantAssetSegregatedportfoliosQuery,
  useGetByTenantBusinessunitAndBusinessUnitIdQuery,
  useGetByTenantBusinessunitAndBusinessUnitIdUsersQuery,
  useGetByTenantCashinstrumentListQuery,
  useGetByTenantCashinstrumentQuery,
  useGetByTenantClientAndClientIdQuery,
  useGetByTenantClientAndClientIdUsersQuery,
  useGetByTenantClientQuery,
  useGetByTenantClientUsersQuery,
  useGetByTenantConfigurationReconciliationQuery,
  useGetByTenantConfigurationSchedulingQuery,
  useGetByTenantConfigurationTradeQuery,
  useGetByTenantConfigurationTradeValuationcycleCurrentQuery,
  useGetByTenantConfigurationTradeValuationcyclePreviousQuery,
  useGetByTenantConfigurationTradeValuationcycleoverrideQuery,
  useGetByTenantConfigurationTradeValuationsnapCurrentQuery,
  useGetByTenantConfigurationTradeValuationsnapoverrideQuery,
  useGetByTenantConfigurationUiQuery,
  useGetByTenantCounterpartyAllQuery,
  useGetByTenantCounterpartyCounterpartyidsQuery,
  useGetByTenantDfmAndDfmIdUsersQuery,
  useGetByTenantDistributionsAndAssetIdQuery,
  useGetByTenantDistributionsAssetswithalertsQuery,
  useGetByTenantDistributionsReinvestmentsAndAssetIdQuery,
  useGetByTenantDistributionsReinvestmentsDataAndAssetIdExDateQuery,
  useGetByTenantDocumentationAccountAndAccountIdDocumentNumberQuery,
  useGetByTenantDocumentationAccountAndAccountIdSummaryQuery,
  useGetByTenantDocumentationAndFileNameQuery,
  useGetByTenantDocumentationNoteAndNoteIdSummaryQuery,
  useGetByTenantNomQueueAndDateDepthQuery,
  useGetByTenantNoteAndNoteIdCloseQuery,
  useGetByTenantNoteAndNoteIdStatementDateQuery,
  useGetByTenantNoteAndNoteIdStatementLatestQuery,
  useGetByTenantNoteAndNoteIdStatementYearMonthQuery,
  useGetByTenantNoteAndNoteIdStatementsPreviousQuery,
  useGetByTenantNoteBusinessunitAndIdQuery,
  useGetByTenantNoteDataAccountAndAccountIdPendingchangesQuery,
  useGetByTenantNoteExportFilterQuery,
  useGetByTenantNoteHoldingsAndDateExportQuery,
  useGetByTenantNoteInprogressCountQuery,
  useGetByTenantNoteInprogressQuery,
  useGetByTenantNoteInstructionValidateQuery,
  useGetByTenantNoteQuery,
  useGetByTenantNoteStatementsQuery,
  useGetByTenantOrderConfirmedQuery,
  useGetByTenantOrderOutstandingAndAssetIdQuery,
  useGetByTenantPortfolioAndModelPortfolioIdQuery,
  useGetByTenantPortfolioAndModelPortfolioIdUsageQuery,
  useGetByTenantPortfolioAndPortfolioIdPortfolioFactSheetDateQuery,
  useGetByTenantPortfolioAndPortfolioIdPortfolioFactSheetYearMonthQuery,
  useGetByTenantPortfolioListQuery,
  useGetByTenantPortfolioMinimalAndBusinessUnitIdQuery,
  useGetByTenantPortfolioQuery,
  useGetByTenantRiskmanagementAndDateAssetconcentrationQuery,
  useGetByTenantRiskmanagementAndDateClientgappaymentsQuery,
  useGetByTenantRiskmanagementAndDateHoldingsreconciliationQuery,
  useGetByTenantRiskmanagementAndDateMarketdatasnapshotQuery,
  useGetByTenantRiskmanagementAndDateMaxdrawdownQuery,
  useGetByTenantRiskmanagementAndTradeIdGapriskinfoQuery,
  useGetByTenantRiskmanagementAssetConstituentsQuery,
  useGetByTenantRiskmanagementAssetpriceoverrideinfoQuery,
  useGetByTenantRiskmanagementExportHoldingsreportQuery,
  useGetByTenantRiskmanagementExportQuery,
  useGetByTenantRiskmanagementExportStaticQuery,
  useGetByTenantRiskmanagementLatestAssetconcentrationQuery,
  useGetByTenantRiskmanagementLatestAssetspricesQuery,
  useGetByTenantRiskmanagementLatestHoldingsreconciliationQuery,
  useGetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationQuery,
  useGetByTenantRiskmanagementLatestMarketdataFxQuery,
  useGetByTenantRiskmanagementLatestMarketdatasnapshotQuery,
  useGetByTenantRiskmanagementLatestMaxdrawdownQuery,
  useGetByTenantRiskmanagementMarketdatasetsQuery,
  useGetByTenantScenariosLatestAllassetsladderQuery,
  useGetByTenantScenariosLatestCustomassetQuery,
  useGetByTenantScenariosLatestCustomfundmanagerQuery,
  useGetByTenantScenariosLatestFundmanagerdrawdownQuery,
  useGetByTenantScenariosLatestFundmanagerladderQuery,
  useGetByTenantScenariosLatestSingleassetdrawdownQuery,
  useGetByTenantScenariosLatestSingleassetladderQuery,
  useGetByTenantStaticAssetclassesQuery,
  useGetByTenantStaticBusinessdatesAndFromToQuery,
  useGetByTenantStaticCashinstrumentreferenceratesQuery,
  useGetByTenantStaticCurrenciesQuery,
  useGetByTenantStaticFeebasisQuery,
  useGetByTenantStaticFeedaycountQuery,
  useGetByTenantStaticFeedeductionfrequencyQuery,
  useGetByTenantStaticFeetypeQuery,
  useGetByTenantStrategyQuery,
  useGetByTenantVAndAccountIdHistoryQuery,
  useGetByTenantVAndDateAccountAccountIdQuery,
  useGetByTenantVDatesQuery,
  useGetDiagnosticsBackupByPartIndexesQuery,
  useGetDiagnosticsBackupByPartIndexesdescriptionQuery,
  useGetDiagnosticsBackupByPartQuery,
  useGetDiagnosticsBackupPartialByPartQuery,
  useGetDiagnosticsByTenantTaxclassifierQuery,
  useGetDiagnosticsCheckindexesByTenantQuery,
  useGetDiagnosticsErrorQuery,
  useGetDiagnosticsMediatrQuery,
  useGetDiagnosticsMediatrSendQuery,
  useGetDiagnosticsQuery,
  useGetDiagnosticsRolesQuery,
  useGetDiagnosticsServiceQuery,
  useGetDiagnosticsStopQuery,
  useGetDiagnosticsTaxclassifierQuery,
  useGetDiagnosticsTenantByTenantQuery,
  useGetDiagnosticsWaitByNumberSecondsQuery,
  useGetEmailByIdQuery,
  useGetEmailListByDateQuery,
  useGetExchangefileByTenantAndFilenameTypeQuery,
  useGetExchangefileLastByTenantAndTypeMaxDateInclusiveQuery,
  useGetIndexStatusQuery,
  useGetMediatRSendQuery,
  useGetReportingStatusQuery,
  useGetSchedulerByTenantExecutionsQuery,
  useGetSchedulerByTenantLogsAndStartSnapAsTicksIsInclusiveQuery,
  useGetSchedulerByTenantRunAndTaskNameQuery,
  useGetSetupExportByTenantNameAndNameQuery,
  useGetSetupExportsByNameQuery,
  useGetSetupExportsQuery,
  useGetSetupImportByTenantNameAndNameQuery,
  useGetSetupTenantsQuery,
  useGetStatusAccessAdministratorQuery,
  useGetStatusAccessBusinessUnitUserQuery,
  useGetStatusAccessServertoserverQuery,
  useGetStatusAccessUserQuery,
  useGetStatusOnlineQuery,
  useGetSystemAuditAfterByDateQuery,
  useGetTwoFactorQuery,
  useGetTwoFactorSetupQuery,
  useGetUsermanagerBankAllQuery,
  useGetUsermanagerClientAllQuery,
  useGetUsermanagerCurrentQuery,
  useGetUsermanagerEnabledisablelockoutByUsernameAndIsEnabledQuery,
  useGetUsermanagerExportBankQuery,
  useGetUsermanagerExportBusinessunitByBusinessUnitIdQuery,
  useGetUsermanagerExportClientByCliendIdQuery,
  useGetUsermanagerExportClientQuery,
  useGetUsermanagerExportQuery,
  useGetUsermanagerGetbyidByUserIdQuery,
  useGetUsermanagerQuery,
  useGetUsermanagerRecaptchaDisabledQuery,
  useGetUsermanagerRolesAllQuery,
  useGetUsermanagerRolesBankAllQuery,
  useGetUsermanagerRolesClientAllQuery,
  useGetUsermanagerRolesQuery,
  useGetUsermanagerUnlockByUsernameQuery,
  usePostAuthLoginMutation,
  usePostAuthLogoutMutation,
  usePostByTenantAccountAccrualsExportMutation,
  usePostByTenantAccountActivateAndAccountIdentifierMutation,
  usePostByTenantAccountApproveAndAccountIdentifierMutation,
  usePostByTenantAccountApproveEconomicsAndAccountIdentifierMutation,
  usePostByTenantAccountCloseAndAccountIdentifierMutation,
  usePostByTenantAccountCommitAndAccountIdentifierMutation,
  usePostByTenantAccountCommitClientAndAccountIdentifierMutation,
  usePostByTenantAccountConfirmAndAccountIdentifierMutation,
  usePostByTenantAccountDeleteAndAccountIdentifierMutation,
  usePostByTenantAccountDeleterevertdraftAndAccountIdentifierMutation,
  usePostByTenantAccountExportJsonMutation,
  usePostByTenantAccountExportMutation,
  usePostByTenantAccountLocksAndAccountIdLockTypeRemoveMutation,
  usePostByTenantAccountPricesAndAccountIdMutation,
  usePostByTenantAccountRejectAndAccountIdentifierMutation,
  usePostByTenantAccountSaveMutation,
  usePostByTenantAccountSubmitAndAccountIdentifierMutation,
  usePostByTenantAccountUpdateSaveMutation,
  usePostByTenantAssetAndAssetIdExdatesAddMutation,
  usePostByTenantAssetAndAssetIdMarketdatareadyMutation,
  usePostByTenantAssetAndAssetIdRestoreMutation,
  usePostByTenantAssetAndAssetIdSoftdeleteMutation,
  usePostByTenantAssetIndexMutation,
  usePostByTenantAssetMutualfundMutation,
  usePostByTenantAssetSegregatedportfolioMutation,
  usePostByTenantAssetUploadMutation,
  usePostByTenantBusinessunitAndBusinessUnitIdUsersMutation,
  usePostByTenantBusinessunitTransferMutation,
  usePostByTenantCashinstrumentDepositMutation,
  usePostByTenantCashinstrumentDepositUpdateMutation,
  usePostByTenantCashinstrumentLoanMutation,
  usePostByTenantCashinstrumentLoanUpdateMutation,
  usePostByTenantCashinstrumentZcbcurveMutation,
  usePostByTenantCashinstrumentZcbcurveUpdateMutation,
  usePostByTenantClientAndClientIdBusinessUnitsMutation,
  usePostByTenantClientAndClientIdUsersMutation,
  usePostByTenantClientMutation,
  usePostByTenantConfigurationCleanupDisableMutation,
  usePostByTenantConfigurationCleanupEnableMutation,
  usePostByTenantConfigurationFinswitchIsocurrencycodesDisableMutation,
  usePostByTenantConfigurationFinswitchIsocurrencycodesEnableMutation,
  usePostByTenantConfigurationGraphDisableMutation,
  usePostByTenantConfigurationGraphEnableMutation,
  usePostByTenantConfigurationReconciliationUpdateMutation,
  usePostByTenantConfigurationTradeAssetDefaultsMutation,
  usePostByTenantConfigurationTradeDisableMutation,
  usePostByTenantConfigurationTradeEnableMutation,
  usePostByTenantConfigurationTradeIdentifierConfigurationMutation,
  usePostByTenantConfigurationTradeNoteDefaultsMutation,
  usePostByTenantConfigurationTradeValuationsnapandcycleoverrideUnsetMutation,
  usePostByTenantConfigurationTradeValuationsnapoverrideSetAndValuationSnapMutation,
  usePostByTenantCounterpartyAddMutation,
  usePostByTenantDfmAndDfmIdUsersMutation,
  usePostByTenantDfmMutation,
  usePostByTenantDistributionsAddMutation,
  usePostByTenantDistributionsReinvestmentsAddMutation,
  usePostByTenantDocumentationAndFileNameMutation,
  usePostByTenantNomInstructionMutation,
  usePostByTenantNomManyMutation,
  usePostByTenantNomOneMutation,
  usePostByTenantNoteAndNoteIdChangeBusinessunitNewBusinessUnitIdMutation,
  usePostByTenantNoteAndNoteIdChangeCounterpartyNewCounterpartyIdMutation,
  usePostByTenantNoteAndNoteIdChangeIscollateralforloanIsCollateralForLoanMutation,
  usePostByTenantNoteAndNoteIdInstructionActivateMutation,
  usePostByTenantNoteAndNoteIdInstructionApproveCommitmentClientMutation,
  usePostByTenantNoteAndNoteIdInstructionApproveCommitmentMutation,
  usePostByTenantNoteAndNoteIdInstructionApproveMutation,
  usePostByTenantNoteAndNoteIdInstructionApproveSettlementMutation,
  usePostByTenantNoteAndNoteIdInstructionRejectMutation,
  usePostByTenantNoteChangetaxclassificationAndNoteIdNewTaxClassificationMutation,
  usePostByTenantNoteDataAccountAndAccountIdNewinstructions2Mutation,
  usePostByTenantNoteDataAccountAndAccountIdNewinstructionsMutation,
  usePostByTenantNoteDataNewaccountMutation,
  usePostByTenantNoteExportMutation,
  usePostByTenantNoteInstructionSubmitMutation,
  usePostByTenantNoteMutation,
  usePostByTenantOrderConfirmationMutation,
  usePostByTenantOrderCorrectionMutation,
  usePostByTenantPerformancePortfolioBacktestMutation,
  usePostByTenantPerformancePortfolioProjectionMutation,
  usePostByTenantPerformanceTradeBacktestMutation,
  usePostByTenantPerformanceTradeProjectionMutation,
  usePostByTenantPortfolioCalculatemultiplierMutation,
  usePostByTenantPortfolioMutation,
  usePostByTenantRiskmanagementAssetpriceoverrideMutation,
  usePostByTenantRiskmanagementUploadmarketdatasetMutation,
  usePostByTenantScenariosConfigurationAllassetsladderMutation,
  usePostByTenantScenariosConfigurationCustomassetMutation,
  usePostByTenantScenariosConfigurationCustomfundmanagerMutation,
  usePostByTenantScenariosConfigurationFundmanagerdrawdownMutation,
  usePostByTenantScenariosConfigurationFundmanagerladderMutation,
  usePostByTenantScenariosConfigurationSingleassetdrawdownMutation,
  usePostByTenantScenariosConfigurationSingleassetladderMutation,
  usePostByTenantStrategyMutation,
  usePostByTenantUploadExchangefileAndContentTypeFileTypeFileNameReferenceDateMutation,
  usePostByTenantUploadModelparametersMutation,
  usePostDiagnosticsBackupByPartMutation,
  usePostDiagnosticsCreateindexMutation,
  usePostDiagnosticsDropByPartIndexAndIndexMutation,
  usePostDiagnosticsDropByPartIndexesMutation,
  usePostDiagnosticsEmailMutation,
  usePostDiagnosticsErrorMutation,
  usePostDiagnosticsLogsByTenantNameCleanMutation,
  usePostDiagnosticsLogsMutation,
  usePostDiagnosticsRestoreByPartIndexesMutation,
  usePostDiagnosticsRestoreByPartMutation,
  usePostDiagnosticsRestorePartialByPartMutation,
  usePostExchangefileByTenantAndFilenameTypeDateMutation,
  usePostSchedulerByTenantExcecutionsLastDeleteAndTaskNameMutation,
  usePostSchedulerByTenantExcecutionsUnsuccessfulLastDeleteAllMutation,
  usePostSchedulerByTenantJobstatusesRevokeMutation,
  usePostSchedulerByTenantReleaselockAllMutation,
  usePostSchedulerByTenantReleaselockAndLockNameProcessIdMutation,
  usePostSchedulerByTenantRunOustandingMutation,
  usePostSetupCreatetenantMutation,
  usePostSetupDropcollectionindexesByTenantNameMutation,
  usePostSetupExportsByNameMutation,
  usePostSetupImportMutation,
  usePostSetupInitializeallcollectionsByTenantNameMutation,
  usePostSetupRemovetenantByTenantNameMutation,
  usePostSetupResetcollectionindexesMutation,
  usePostSetupResetidentityMutation,
  usePostSetupUpdatetasksByTenantNameMutation,
  usePostSetupUpdatetenantMutation,
  usePostTwoFactorEnableMutation,
  usePostTwoFactorLoginMutation,
  usePostTwoFactorRecoveryCodesMutation,
  usePostTwoFactorResetMutation,
  usePostTwoFactorVerifyMutation,
  usePostUsermanagerActivateByUsernameMutation,
  usePostUsermanagerAddtoroleMutation,
  usePostUsermanagerChangepwdMutation,
  usePostUsermanagerConfirmEmailMutation,
  usePostUsermanagerCreateMutation,
  usePostUsermanagerDeactivateByUsernameMutation,
  usePostUsermanagerForgotPasswordMutation,
  usePostUsermanagerOnboardMutation,
  usePostUsermanagerRemovefromroleMutation,
  usePostUsermanagerResetMutation,
  usePostUsermanagerUsernameGenerateMutation,
  usePutByTenantAssetAndAssetIdMarketDataProviderNewMarketDataProviderMutation,
  usePutByTenantAssetAndAssetIdTradingProviderNewTradingProviderMutation,
  usePutByTenantAssetFundManagerMutation,
  usePutByTenantAssetMutualfundMutation,
  usePutByTenantAssetSegregatedportfolioMutation,
  usePutByTenantClientAndClientIdBusinessUnitsMutation,
  usePutByTenantClientMutation,
  usePutByTenantCounterpartyUpdateMutation,
  usePutByTenantDfmMutation,
  usePutByTenantDistributionsReinvestmentsAssignAndConfirmationIdExDateMutation,
  usePutByTenantPortfolioAndModelPortfolioIdApproveMutation,
  usePutByTenantPortfolioAndModelPortfolioIdRejectMutation,
  usePutByTenantPortfolioMutation,
  usePutByTenantStrategyMutation,
  usePutUsermanagerMutation,
  useRestoreObsoleteBlockChainMutation
} = injectedRtkApi
